import _objectWithoutProperties from "/home/runner/work/pretto/pretto/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/home/runner/work/pretto/pretto/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/runner/work/pretto/pretto/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["as", "children"],
    _excluded2 = ["as", "children"],
    _excluded3 = ["as", "children"],
    _excluded4 = ["as", "children"],
    _excluded5 = ["as", "children"],
    _excluded6 = ["as", "children"],
    _excluded7 = ["as", "children"],
    _excluded8 = ["as", "children"],
    _excluded9 = ["as", "children"],
    _excluded10 = ["as", "children"],
    _excluded11 = ["as", "children"],
    _excluded12 = ["as", "children"],
    _excluded13 = ["as", "children"],
    _excluded14 = ["as", "children"],
    _excluded15 = ["as", "children"],
    _excluded16 = ["as", "children"],
    _excluded17 = ["as", "children"],
    _excluded18 = ["as", "children"],
    _excluded19 = ["as", "children"],
    _excluded20 = ["as", "children"],
    _excluded21 = ["as", "children"],
    _excluded22 = ["as", "children"],
    _excluded23 = ["as", "children"],
    _excluded24 = ["as", "children"],
    _excluded25 = ["as", "children"],
    _excluded26 = ["as", "children"],
    _excluded27 = ["as", "children"],
    _excluded28 = ["as", "children"],
    _excluded29 = ["as", "children"],
    _excluded30 = ["as", "children"],
    _excluded31 = ["as", "children"],
    _excluded32 = ["as", "children"],
    _excluded33 = ["as", "children"],
    _excluded34 = ["as", "children"],
    _excluded35 = ["as", "children"],
    _excluded36 = ["as", "children"],
    _excluded37 = ["as", "children"],
    _excluded38 = ["as", "children"],
    _excluded39 = ["as", "children"],
    _excluded40 = ["as", "children"],
    _excluded41 = ["as", "children"],
    _excluded42 = ["as", "children"],
    _excluded43 = ["as", "children"],
    _excluded44 = ["as", "children"],
    _excluded45 = ["as", "children"],
    _excluded46 = ["as", "children"],
    _excluded47 = ["as", "children"],
    _excluded48 = ["as", "children"],
    _excluded49 = ["as", "children"],
    _excluded50 = ["as", "children"],
    _excluded51 = ["as", "children"],
    _excluded52 = ["as", "children"],
    _excluded53 = ["as", "children"],
    _excluded54 = ["as", "children"],
    _excluded55 = ["as", "children"],
    _excluded56 = ["as", "children"],
    _excluded57 = ["as", "children"],
    _excluded58 = ["as", "children"],
    _excluded59 = ["as", "children"],
    _excluded60 = ["as", "children"],
    _excluded61 = ["as", "children"],
    _excluded62 = ["as", "children"],
    _excluded63 = ["as", "children"],
    _excluded64 = ["as", "children"],
    _excluded65 = ["as", "children"],
    _excluded66 = ["as", "children"],
    _excluded67 = ["as", "children"],
    _excluded68 = ["as", "children"],
    _excluded69 = ["as", "children"],
    _excluded70 = ["as", "children"],
    _excluded71 = ["as", "children"],
    _excluded72 = ["as", "children"],
    _excluded73 = ["as", "children"],
    _excluded74 = ["as", "children"],
    _excluded75 = ["as", "children"],
    _excluded76 = ["as", "children"],
    _excluded77 = ["as", "children"],
    _excluded78 = ["as", "children"],
    _excluded79 = ["as", "children"],
    _excluded80 = ["as", "children"],
    _excluded81 = ["as", "children"],
    _excluded82 = ["as", "children"],
    _excluded83 = ["as", "children"],
    _excluded84 = ["as", "children"],
    _excluded85 = ["as", "children"],
    _excluded86 = ["as", "children"],
    _excluded87 = ["as", "children"],
    _excluded88 = ["as", "children"],
    _excluded89 = ["as", "children"],
    _excluded90 = ["as", "children"],
    _excluded91 = ["as", "children"],
    _excluded92 = ["as", "children"],
    _excluded93 = ["as", "children"],
    _excluded94 = ["as", "children"],
    _excluded95 = ["as", "children"],
    _excluded96 = ["as", "children"],
    _excluded97 = ["as", "children"],
    _excluded98 = ["as", "children"],
    _excluded99 = ["as", "children"],
    _excluded100 = ["as", "children"],
    _excluded101 = ["as", "children"],
    _excluded102 = ["as", "children"],
    _excluded103 = ["as", "children"],
    _excluded104 = ["as", "children"],
    _excluded105 = ["as", "children"],
    _excluded106 = ["as", "children"],
    _excluded107 = ["as", "children"],
    _excluded108 = ["as", "children"],
    _excluded109 = ["as", "children"],
    _excluded110 = ["as", "children"],
    _excluded111 = ["as", "children"],
    _excluded112 = ["as", "children"],
    _excluded113 = ["as", "children"],
    _excluded114 = ["as", "children"],
    _excluded115 = ["as", "children"],
    _excluded116 = ["as", "children"],
    _excluded117 = ["as", "children"],
    _excluded118 = ["as", "children"],
    _excluded119 = ["as", "children"],
    _excluded120 = ["as", "children"],
    _excluded121 = ["as", "children"],
    _excluded122 = ["as", "children"],
    _excluded123 = ["as", "children"],
    _excluded124 = ["as", "children"],
    _excluded125 = ["as", "children"],
    _excluded126 = ["as", "children"],
    _excluded127 = ["as", "children"],
    _excluded128 = ["as", "children"],
    _excluded129 = ["as", "children"],
    _excluded130 = ["as", "children"],
    _excluded131 = ["as", "children"],
    _excluded132 = ["as", "children"],
    _excluded133 = ["as", "children"],
    _excluded134 = ["as", "children"],
    _excluded135 = ["as", "children"],
    _excluded136 = ["as", "children"],
    _excluded137 = ["as", "children"],
    _excluded138 = ["as", "children"],
    _excluded139 = ["as", "children"],
    _excluded140 = ["as", "children"],
    _excluded141 = ["as", "children"],
    _excluded142 = ["as", "children"],
    _excluded143 = ["as", "children"],
    _excluded144 = ["as", "children"],
    _excluded145 = ["as", "children"],
    _excluded146 = ["as", "children"],
    _excluded147 = ["as", "children"],
    _excluded148 = ["as", "children"],
    _excluded149 = ["as", "children"],
    _excluded150 = ["as", "children"],
    _excluded151 = ["as", "children"],
    _excluded152 = ["as", "children"],
    _excluded153 = ["as", "children"],
    _excluded154 = ["as", "children"],
    _excluded155 = ["as", "children"],
    _excluded156 = ["as", "children"],
    _excluded157 = ["as", "children"],
    _excluded158 = ["as", "children"],
    _excluded159 = ["as", "children"],
    _excluded160 = ["as", "children"],
    _excluded161 = ["as", "children"],
    _excluded162 = ["as", "children"],
    _excluded163 = ["as", "children"],
    _excluded164 = ["as", "children"],
    _excluded165 = ["as", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useRef, cloneElement, useState, useCallback, createContext, useContext, useEffect } from 'react';
import _extends from '@babel/runtime/helpers/esm/extends';
var PictoContext = /*#__PURE__*/createContext({
  optimise: function optimise(id, node) {
    return node;
  },
  refresh: function refresh() {}
});

var PictoProvider = function PictoProvider(_ref) {
  var children = _ref.children;
  var forceUpdate = useForceUpdate();
  var cache = useRef({});
  var isPending = useRef(false);
  var value = {
    optimise: function optimise(id, node) {
      if (!(id in cache.current)) {
        cache.current = _objectSpread(_objectSpread({}, cache.current), {}, _defineProperty({}, id, node));
        isPending.current = true;
      }

      return /*#__PURE__*/cloneElement(node, {
        fill: null,
        xmlnsXlink: 'http://www.w3.org/1999/xlink'
      }, /*#__PURE__*/React.createElement("use", {
        xlinkHref: '#' + id
      }));
    },
    refresh: function refresh() {
      if (!isPending) {
        return;
      }

      forceUpdate();
      isPending.current = false;
    }
  };
  return /*#__PURE__*/React.createElement(PictoContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(React.Fragment, null, children, /*#__PURE__*/React.createElement(Symbols, {
    cache: cache
  })));
};

var Symbols = function Symbols(_ref2) {
  var cache = _ref2.cache;
  var entries = Object.entries(cache.current);

  if (entries.length < 1) {
    return null;
  }

  return /*#__PURE__*/React.createElement("svg", {
    style: {
      display: 'none'
    },
    xmlns: "http://www.w3.org/2000/svg"
  }, Object.entries(cache.current).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        id = _ref4[0],
        node = _ref4[1];

    return /*#__PURE__*/cloneElement(node, {
      as: 'symbol',
      className: null,
      height: null,
      id: id,
      key: id,
      width: null,
      xmlns: null
    });
  }));
};

var useForceUpdate = function useForceUpdate() {
  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      updateState = _useState2[1];

  var forceUpdate = useCallback(function () {
    return updateState({});
  }, []);
  return forceUpdate;
};

var SVGComponent$2A = function SVGComponent$2A(_ref5) {
  var _ref5$as = _ref5.as,
      Component = _ref5$as === void 0 ? "svg" : _ref5$as,
      _ref5$children = _ref5.children,
      children = _ref5$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M24,7H23V23H1V7H0V1H24ZM22,7H2V22H22Zm-6,8H8V11h8Zm-1-3H9v2h6ZM23,2H1V6H23Z"
  })) : _ref5$children,
      props = _objectWithoutProperties(_ref5, _excluded);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Archive = function Archive(props) {
  var _useContext = useContext(PictoContext),
      optimise = _useContext.optimise,
      refresh = _useContext.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_15c0G2', /*#__PURE__*/React.createElement(SVGComponent$2A, props));
};

var SVGComponent$2z = function SVGComponent$2z(_ref6) {
  var _ref6$as = _ref6.as,
      Component = _ref6$as === void 0 ? "svg" : _ref6$as,
      _ref6$children = _ref6.children,
      children = _ref6$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M28.21,30.65l3.99-3.98-8.65-8.66-8.66,8.66L0,11.77l3.12-3.12,11.77,11.78,8.66-8.66,11.77,11.78,3.99-3.99,.69,11.79-11.79-.7Z"
  })) : _ref6$children,
      props = _objectWithoutProperties(_ref6, _excluded2);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "currentColor"
  }, props), children);
};

var ArrowDirectionDown = function ArrowDirectionDown(props) {
  var _useContext2 = useContext(PictoContext),
      optimise = _useContext2.optimise,
      refresh = _useContext2.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_1uVN2t', /*#__PURE__*/React.createElement(SVGComponent$2z, props));
};

var SVGComponent$2y = function SVGComponent$2y(_ref7) {
  var _ref7$as = _ref7.as,
      Component = _ref7$as === void 0 ? "svg" : _ref7$as,
      _ref7$children = _ref7.children,
      children = _ref7$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M40,20l-8.82-7.85v5.65H0S0,22.2,0,22.2H31.18s-.01,5.65-.01,5.65l8.83-7.85Z"
  })) : _ref7$children,
      props = _objectWithoutProperties(_ref7, _excluded3);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "currentColor"
  }, props), children);
};

var ArrowDirectionEgal = function ArrowDirectionEgal(props) {
  var _useContext3 = useContext(PictoContext),
      optimise = _useContext3.optimise,
      refresh = _useContext3.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_1uVSMB', /*#__PURE__*/React.createElement(SVGComponent$2y, props));
};

var SVGComponent$2x = function SVGComponent$2x(_ref8) {
  var _ref8$as = _ref8.as,
      Component = _ref8$as === void 0 ? "svg" : _ref8$as,
      _ref8$children = _ref8.children,
      children = _ref8$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M28.21,9.35l3.99,3.98-8.65,8.66L14.89,13.33,0,28.23l3.12,3.12,11.77-11.78,8.66,8.66,11.77-11.78,3.99,3.99,.69-11.79-11.79,.7Z"
  })) : _ref8$children,
      props = _objectWithoutProperties(_ref8, _excluded4);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "currentColor"
  }, props), children);
};

var ArrowDirectionUp = function ArrowDirectionUp(props) {
  var _useContext4 = useContext(PictoContext),
      optimise = _useContext4.optimise,
      refresh = _useContext4.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_ZDUIq2', /*#__PURE__*/React.createElement(SVGComponent$2x, props));
};

var SVGComponent$2w = function SVGComponent$2w(_ref9) {
  var _ref9$as = _ref9.as,
      Component = _ref9$as === void 0 ? "svg" : _ref9$as,
      _ref9$children = _ref9.children,
      children = _ref9$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M23,11h1V3H16V4h6.29L10.65,15.65l.7.7L23,4.71ZM1,13H0v8H8V20H1.71L13.35,8.35l-.7-.7L1,19.29Z"
  })) : _ref9$children,
      props = _objectWithoutProperties(_ref9, _excluded5);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var ArrowDouble = function ArrowDouble(props) {
  var _useContext5 = useContext(PictoContext),
      optimise = _useContext5.optimise,
      refresh = _useContext5.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z1oHpFA', /*#__PURE__*/React.createElement(SVGComponent$2w, props));
};

var SVGComponent$2v = function SVGComponent$2v(_ref10) {
  var _ref10$as = _ref10.as,
      Component = _ref10$as === void 0 ? "svg" : _ref10$as,
      _ref10$children = _ref10.children,
      children = _ref10$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "m12.83,15.3l2.49-2.51,1.18,1.18-4.5,4.53-4.5-4.53,1.18-1.18,2.49,2.51V5.5h1.66v9.8Z"
  })) : _ref10$children,
      props = _objectWithoutProperties(_ref10, _excluded6);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var ArrowDown = function ArrowDown(props) {
  var _useContext6 = useContext(PictoContext),
      optimise = _useContext6.optimise,
      refresh = _useContext6.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_19AFBf', /*#__PURE__*/React.createElement(SVGComponent$2v, props));
};

var SVGComponent$2u = function SVGComponent$2u(_ref11) {
  var _ref11$as = _ref11.as,
      Component = _ref11$as === void 0 ? "svg" : _ref11$as,
      _ref11$children = _ref11.children,
      children = _ref11$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M3.51,20.49a12,12,0,1,1,17,0A12,12,0,0,1,3.51,20.49Zm.71-.71a11,11,0,1,1,15.56,0A11,11,0,0,1,4.22,19.78Zm11.55-4.72-.6-5.92,1,0L17,17l-7.86-.79.06-1,5.91.61L6.7,7.4l.7-.7Z",
    fillRule: "evenodd"
  })) : _ref11$children,
      props = _objectWithoutProperties(_ref11, _excluded7);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var ArrowDownRightCircle = function ArrowDownRightCircle(props) {
  var _useContext7 = useContext(PictoContext),
      optimise = _useContext7.optimise,
      refresh = _useContext7.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_ZmSCts', /*#__PURE__*/React.createElement(SVGComponent$2u, props));
};

var SVGComponent$2t = function SVGComponent$2t(_ref12) {
  var _ref12$as = _ref12.as,
      Component = _ref12$as === void 0 ? "svg" : _ref12$as,
      _ref12$children = _ref12.children,
      children = _ref12$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "m8.7,12.83l2.51,2.49-1.18,1.18-4.53-4.5,4.53-4.5,1.18,1.18-2.51,2.49h9.8v1.66h-9.8Z"
  })) : _ref12$children,
      props = _objectWithoutProperties(_ref12, _excluded8);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var ArrowLeft = function ArrowLeft(props) {
  var _useContext8 = useContext(PictoContext),
      optimise = _useContext8.optimise,
      refresh = _useContext8.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_19BFVb', /*#__PURE__*/React.createElement(SVGComponent$2t, props));
};

var SVGComponent$2s = function SVGComponent$2s(_ref13) {
  var _ref13$as = _ref13.as,
      Component = _ref13$as === void 0 ? "svg" : _ref13$as,
      _ref13$children = _ref13.children,
      children = _ref13$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "m11.25,17.11l3.58,3.57-1.57,1.57-6.26-6.25,6.26-6.25,1.57,1.57-3.58,3.57h13.75v2.22h-13.75Z"
  })) : _ref13$children,
      props = _objectWithoutProperties(_ref13, _excluded9);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, props), children);
};

var ArrowLeftBold = function ArrowLeftBold(props) {
  var _useContext9 = useContext(PictoContext),
      optimise = _useContext9.optimise,
      refresh = _useContext9.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z2ipaWS', /*#__PURE__*/React.createElement(SVGComponent$2s, props));
};

var SVGComponent$2r = function SVGComponent$2r(_ref14) {
  var _ref14$as = _ref14.as,
      Component = _ref14$as === void 0 ? "svg" : _ref14$as,
      _ref14$children = _ref14.children,
      children = _ref14$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "m15.3,11.17l-2.51-2.49,1.18-1.18,4.53,4.5-4.53,4.5-1.18-1.18,2.51-2.49H5.5v-1.66h9.8Z"
  })) : _ref14$children,
      props = _objectWithoutProperties(_ref14, _excluded10);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var ArrowRight = function ArrowRight(props) {
  var _useContext10 = useContext(PictoContext),
      optimise = _useContext10.optimise,
      refresh = _useContext10.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_iaeGf', /*#__PURE__*/React.createElement(SVGComponent$2r, props));
};

var SVGComponent$2q = function SVGComponent$2q(_ref15) {
  var _ref15$as = _ref15.as,
      Component = _ref15$as === void 0 ? "svg" : _ref15$as,
      _ref15$children = _ref15.children,
      children = _ref15$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "m20.75,14.89l-3.58-3.57,1.57-1.57,6.26,6.25-6.26,6.25-1.57-1.57,3.58-3.57H7v-2.22h13.75Z"
  })) : _ref15$children,
      props = _objectWithoutProperties(_ref15, _excluded11);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, props), children);
};

var ArrowRightBold = function ArrowRightBold(props) {
  var _useContext11 = useContext(PictoContext),
      optimise = _useContext11.optimise,
      refresh = _useContext11.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_11WmGg', /*#__PURE__*/React.createElement(SVGComponent$2q, props));
};

var SVGComponent$2p = function SVGComponent$2p(_ref16) {
  var _ref16$as = _ref16.as,
      Component = _ref16$as === void 0 ? "svg" : _ref16$as,
      _ref16$children = _ref16.children,
      children = _ref16$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "m16.5,10.03l-1.18,1.18-2.49-2.51v9.8h-1.66v-9.8l-2.49,2.51-1.18-1.18,4.5-4.53,4.5,4.53Z"
  })) : _ref16$children,
      props = _objectWithoutProperties(_ref16, _excluded12);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var ArrowUp = function ArrowUp(props) {
  var _useContext12 = useContext(PictoContext),
      optimise = _useContext12.optimise,
      refresh = _useContext12.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_16d0VX', /*#__PURE__*/React.createElement(SVGComponent$2p, props));
};

var SVGComponent$2o = function SVGComponent$2o(_ref17) {
  var _ref17$as = _ref17.as,
      Component = _ref17$as === void 0 ? "svg" : _ref17$as,
      _ref17$children = _ref17.children,
      children = _ref17$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M20.49,20.49a12,12,0,1,1,0-17A12,12,0,0,1,20.49,20.49Zm-.71-.71a11,11,0,1,1,0-15.56A11,11,0,0,1,19.78,19.78ZM15.06,8.23l-5.92.6,0-1L17,7.05l-.79,7.86-1-.06.61-5.91L7.4,17.3l-.7-.7Z",
    fillRule: "evenodd"
  })) : _ref17$children,
      props = _objectWithoutProperties(_ref17, _excluded13);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var ArrowUpRightCircle = function ArrowUpRightCircle(props) {
  var _useContext13 = useContext(PictoContext),
      optimise = _useContext13.optimise,
      refresh = _useContext13.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z76OT6', /*#__PURE__*/React.createElement(SVGComponent$2o, props));
};

var SVGComponent$2n = function SVGComponent$2n(_ref18) {
  var _ref18$as = _ref18.as,
      Component = _ref18$as === void 0 ? "svg" : _ref18$as,
      _ref18$children = _ref18.children,
      children = _ref18$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 9.5V5L12 0.5L10.57 1L1 5V9.5H3V19.58C2.46957 19.58 1.96086 19.7907 1.58579 20.1658C1.21071 20.5409 1 21.0496 1 21.58V23.5H23V21.58C23 21.0496 22.7893 20.5409 22.4142 20.1658C22.0391 19.7907 21.5304 19.58 21 19.58V9.5H23ZM22 21.58V22.5H2V21.58C2 21.3148 2.10536 21.0604 2.29289 20.8729C2.48043 20.6854 2.73478 20.58 3 20.58H21C21.2652 20.58 21.5196 20.6854 21.7071 20.8729C21.8946 21.0604 22 21.3148 22 21.58ZM4 19.58V9.5H6V19.58H4ZM7 19.58V9.5H10V19.58H7ZM11 19.58V9.5H13V19.58H11ZM14 19.58V9.5H17V19.58H14ZM18 19.58V9.5H20V19.58H18ZM2 8.5V5.68L12 1.57L22 5.68V8.5H2ZM12 3.42C11.6044 3.42 11.2178 3.5373 10.8889 3.75706C10.56 3.97682 10.3036 4.28918 10.1522 4.65463C10.0009 5.02009 9.96126 5.42222 10.0384 5.81018C10.1156 6.19814 10.3061 6.55451 10.5858 6.83421C10.8655 7.11392 11.2219 7.3044 11.6098 7.38157C11.9978 7.45874 12.3999 7.41913 12.7654 7.26776C13.1308 7.11638 13.4432 6.86004 13.6629 6.53114C13.8827 6.20224 14 5.81556 14 5.42C14 4.88957 13.7893 4.38086 13.4142 4.00579C13.0391 3.63071 12.5304 3.42 12 3.42ZM12 6.42C11.8022 6.42 11.6089 6.36135 11.4444 6.25147C11.28 6.14159 11.1518 5.98541 11.0761 5.80268C11.0004 5.61996 10.9806 5.41889 11.0192 5.22491C11.0578 5.03093 11.153 4.85275 11.2929 4.71289C11.4327 4.57304 11.6109 4.4778 11.8049 4.43921C11.9989 4.40063 12.2 4.42043 12.3827 4.49612C12.5654 4.57181 12.7216 4.69998 12.8315 4.86443C12.9414 5.02888 13 5.22222 13 5.42C13 5.68522 12.8946 5.93957 12.7071 6.12711C12.5196 6.31464 12.2652 6.42 12 6.42Z"
  })) : _ref18$children,
      props = _objectWithoutProperties(_ref18, _excluded14);

  return /*#__PURE__*/React.createElement(Component, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Bank = function Bank(props) {
  var _useContext14 = useContext(PictoContext),
      optimise = _useContext14.optimise,
      refresh = _useContext14.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_95oG', /*#__PURE__*/React.createElement(SVGComponent$2n, props));
};

var SVGComponent$2m = function SVGComponent$2m(_ref19) {
  var _ref19$as = _ref19.as,
      Component = _ref19$as === void 0 ? "svg" : _ref19$as,
      _ref19$children = _ref19.children,
      children = _ref19$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M21.19,7H24V22H3V17H.19V2h21ZM23,8H4V21H23ZM13.5,9A5.5,5.5,0,1,1,8,14.5,5.5,5.5,0,0,1,13.5,9Zm0,1A4.5,4.5,0,1,1,9,14.5,4.51,4.51,0,0,1,13.5,10Zm.5,8H13v-.8a1.7,1.7,0,0,1-1.48-1.71h1c0,.59.33.89,1,.89.82,0,1.33-.92-.17-1.44-.76-.27-1.68-.68-1.68-1.69A1.49,1.49,0,0,1,13,11.8V11h1v.81a1.57,1.57,0,0,1,1.31,1.59h-1a.74.74,0,0,0-.81-.77c-.55,0-.79.29-.79.62s.14.5,1,.77c1.06.34,1.66.84,1.66,1.74A1.42,1.42,0,0,1,14,17.21ZM20.19,7V3h-19V16H3V7Z",
    fillRule: "evenodd"
  })) : _ref19$children,
      props = _objectWithoutProperties(_ref19, _excluded15);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var BankNote = function BankNote(props) {
  var _useContext15 = useContext(PictoContext),
      optimise = _useContext15.optimise,
      refresh = _useContext15.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z27BwJf', /*#__PURE__*/React.createElement(SVGComponent$2m, props));
};

var SVGComponent$2l = function SVGComponent$2l(_ref20) {
  var _ref20$as = _ref20.as,
      Component = _ref20$as === void 0 ? "svg" : _ref20$as,
      _ref20$children = _ref20.children,
      children = _ref20$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M24,19H0V18H24Zm0-6H0V12H24Zm0-6H0V6H24Z"
  })) : _ref20$children,
      props = _objectWithoutProperties(_ref20, _excluded16);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Bars = function Bars(props) {
  var _useContext16 = useContext(PictoContext),
      optimise = _useContext16.optimise,
      refresh = _useContext16.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_95qQ', /*#__PURE__*/React.createElement(SVGComponent$2l, props));
};

var SVGComponent$2k = function SVGComponent$2k(_ref21) {
  var _ref21$as = _ref21.as,
      Component = _ref21$as === void 0 ? "svg" : _ref21$as,
      _ref21$children = _ref21.children,
      children = _ref21$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M1,20V17.05C3,16.4,3.58,14.9,4.67,11c.9-3.22,1.89-6.79,4.87-8a2.22,2.22,0,0,1,0-.45,2.5,2.5,0,0,1,5,0,2.32,2.32,0,0,1,0,.46c3,1.24,4,4.81,4.88,8,1.1,3.95,1.7,5.42,3.66,6.06V20H16a4,4,0,0,1-8,0Zm14,0H9a3,3,0,0,0,6,0ZM2,19H22V17.76c-2.06-.92-2.82-3.63-3.62-6.5C17.31,7.45,16.21,3.5,12,3.5S6.69,7.44,5.63,11.24c-.8,2.88-1.56,5.6-3.63,6.52ZM13.49,2.65V2.5a1.5,1.5,0,0,0-3,0v.15A6.87,6.87,0,0,1,12,2.5,7,7,0,0,1,13.49,2.65Z"
  })) : _ref21$children,
      props = _objectWithoutProperties(_ref21, _excluded17);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Bell = function Bell(props) {
  var _useContext17 = useContext(PictoContext),
      optimise = _useContext17.optimise,
      refresh = _useContext17.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_96pH', /*#__PURE__*/React.createElement(SVGComponent$2k, props));
};

var SVGComponent$2j = function SVGComponent$2j(_ref22) {
  var _ref22$as = _ref22.as,
      Component = _ref22$as === void 0 ? "svg" : _ref22$as,
      _ref22$children = _ref22.children,
      children = _ref22$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M5,0V24l7-6,7,6V0ZM6,1H18V21.83l-6-5.15L6,21.83Z"
  })) : _ref22$children,
      props = _objectWithoutProperties(_ref22, _excluded18);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Bookmark = function Bookmark(props) {
  var _useContext18 = useContext(PictoContext),
      optimise = _useContext18.optimise,
      refresh = _useContext18.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_2ruN6Q', /*#__PURE__*/React.createElement(SVGComponent$2j, props));
};

var SVGComponent$2i = function SVGComponent$2i(_ref23) {
  var _ref23$as = _ref23.as,
      Component = _ref23$as === void 0 ? "svg" : _ref23$as,
      _ref23$children = _ref23.children,
      children = _ref23$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "m8,5.04c-.55,0-1,.45-1,1v20c0,.55.45,1,1,1h3.5c.55,0,1-.45,1-1V6.04c0-.55-.45-1-1-1h-3.5Zm11.5,0c-.55,0-1,.45-1,1v20c0,.55.45,1,1,1h3.5c.55,0,1-.45,1-1V6.04c0-.55-.45-1-1-1h-3.5Z"
  })) : _ref23$children,
      props = _objectWithoutProperties(_ref23, _excluded19);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, props), children);
};

var BreakBold = function BreakBold(props) {
  var _useContext19 = useContext(PictoContext),
      optimise = _useContext19.optimise,
      refresh = _useContext19.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_7BImG', /*#__PURE__*/React.createElement(SVGComponent$2i, props));
};

var SVGComponent$2h = function SVGComponent$2h(_ref24) {
  var _ref24$as = _ref24.as,
      Component = _ref24$as === void 0 ? "svg" : _ref24$as,
      _ref24$children = _ref24.children,
      children = _ref24$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M16,4h8V23H0V4H8V2A1,1,0,0,1,9,1h6a1,1,0,0,1,1,1Zm7,1H1V22H23ZM20,9v1H4V9ZM15,2.5a.47.47,0,0,0-.15-.35A.47.47,0,0,0,14.5,2h-5a.47.47,0,0,0-.35.15A.47.47,0,0,0,9,2.5V4h6Z",
    fillRule: "evenodd"
  })) : _ref24$children,
      props = _objectWithoutProperties(_ref24, _excluded20);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var Briefcase = function Briefcase(props) {
  var _useContext20 = useContext(PictoContext),
      optimise = _useContext20.optimise,
      refresh = _useContext20.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_ZCaOqa', /*#__PURE__*/React.createElement(SVGComponent$2h, props));
};

var SVGComponent$2g = function SVGComponent$2g(_ref25) {
  var _ref25$as = _ref25.as,
      Component = _ref25$as === void 0 ? "svg" : _ref25$as,
      _ref25$children = _ref25.children,
      children = _ref25$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M20,15a1,1,0,1,1-1-1A1,1,0,0,1,20,15Zm-3,0a1,1,0,1,1-1-1A1,1,0,0,1,17,15Zm-3,0a1,1,0,1,1-1-1A1,1,0,0,1,14,15ZM19.42,20a12.75,12.75,0,0,1-3.33.48C12.63,20.43,9,18.36,9,15c0-3.13,3.14-5.68,7-5.68s7,2.55,7,5.68a5.07,5.07,0,0,1-1.48,3.52l.84,2.69ZM6,16.57l-4.39,1.9,1.26-4A6.82,6.82,0,0,1,1,9.76C1,5.48,5.26,2,10.5,2c5,0,9.13,3.19,9.47,7.22a9.35,9.35,0,0,0-4-.89c-4.2,0-8,2.8-8,6.68a5.42,5.42,0,0,0,.41,2A17.1,17.1,0,0,1,6,16.57ZM24,15A6.25,6.25,0,0,0,21,9.8v0C21,4.67,16,1,10.5,1S0,4.7,0,9.76a7.75,7.75,0,0,0,1.79,4.92L.05,20.25l6.07-2.63A17,17,0,0,0,9,18.11a8.35,8.35,0,0,0,7.11,3.32A13.08,13.08,0,0,0,19.33,21L24,23l-1.32-4.25A5.87,5.87,0,0,0,24,15Z",
    fillRule: "evenodd"
  })) : _ref25$children,
      props = _objectWithoutProperties(_ref25, _excluded21);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var BubbleDouble = function BubbleDouble(props) {
  var _useContext21 = useContext(PictoContext),
      optimise = _useContext21.optimise,
      refresh = _useContext21.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_2qOs6B', /*#__PURE__*/React.createElement(SVGComponent$2g, props));
};

var SVGComponent$2f = function SVGComponent$2f(_ref26) {
  var _ref26$as = _ref26.as,
      Component = _ref26$as === void 0 ? "svg" : _ref26$as,
      _ref26$children = _ref26.children,
      children = _ref26$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,2h2V4h2V7.7l7,2.62V23h1v1H0V23H1V12H7V4H9V2h2V0h1Zm3,3H8V23H9V21h5v2h1ZM13,22H10v1h3Zm8,1h1V11L16,8.77V23h1V21h4ZM7,13H2V23H3V21H6v2H7ZM5,22H4v1H5Zm15,0H18v1h2ZM4,17v2H3V17Zm2,0v2H5V17ZM11,7V19H10V7ZM21,18v1H17V18ZM13,7V19H12V7Zm8,9v1H17V16ZM4,14v2H3V14Zm2,0v2H5V14Zm15,0v1H17V14Zm0-2v1H17V12ZM13,3H10V4h3Z"
  })) : _ref26$children,
      props = _objectWithoutProperties(_ref26, _excluded22);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Building = function Building(props) {
  var _useContext22 = useContext(PictoContext),
      optimise = _useContext22.optimise,
      refresh = _useContext22.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z1BE88O', /*#__PURE__*/React.createElement(SVGComponent$2f, props));
};

var SVGComponent$2e = function SVGComponent$2e(_ref27) {
  var _ref27$as = _ref27.as,
      Component = _ref27$as === void 0 ? "svg" : _ref27$as,
      _ref27$children = _ref27.children,
      children = _ref27$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M13,24H11a1,1,0,0,1-.75-.34L9.67,23h4.66l-.58.66A1,1,0,0,1,13,24Zm1.87-3a.5.5,0,1,1,0,1H9.13a.5.5,0,1,1,0-1ZM12,4c3,0,6,2,6,5.73A10.74,10.74,0,0,1,16.09,15a10.41,10.41,0,0,0-1.84,5h1c0-3.29,3.75-6.1,3.75-10.27C19,5.39,15.5,3,12,3S5,5.39,5,9.73c0,4.17,3.75,7,3.75,10.27h1a10.41,10.41,0,0,0-1.84-5A10.74,10.74,0,0,1,6,9.73C6,6,9,4,12,4Zm9.42,8a.49.49,0,0,1,.25.66.5.5,0,0,1-.66.25l-.91-.42a.5.5,0,0,1-.25-.66.49.49,0,0,1,.66-.24ZM2.58,12a.49.49,0,0,0-.25.66.5.5,0,0,0,.66.25l.91-.42a.5.5,0,0,0,.25-.66.49.49,0,0,0-.66-.24ZM21.5,9h-1a.5.5,0,0,1,0-1h1a.5.5,0,0,1,0,1ZM3.5,8a.5.5,0,0,1,0,1h-1a.5.5,0,0,1,0-1ZM20.32,4.91a.5.5,0,0,0-.57-.82l-.82.57a.5.5,0,0,0-.13.7.51.51,0,0,0,.7.12Zm-16.64,0a.5.5,0,0,1,.57-.82l.82.57a.5.5,0,0,1,.13.7.51.51,0,0,1-.7.12ZM17,1.88a.5.5,0,0,0-.87-.49l-.49.87a.51.51,0,0,0,.2.68.5.5,0,0,0,.68-.19Zm-10,0a.5.5,0,0,1,.87-.49l.49.87a.51.51,0,0,1-.2.68.5.5,0,0,1-.68-.19ZM12.5.5a.5.5,0,0,0-1,0v1a.5.5,0,0,0,1,0Z"
  })) : _ref27$children,
      props = _objectWithoutProperties(_ref27, _excluded23);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Bulb = function Bulb(props) {
  var _useContext23 = useContext(PictoContext),
      optimise = _useContext23.optimise,
      refresh = _useContext23.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_9axB', /*#__PURE__*/React.createElement(SVGComponent$2e, props));
};

var SVGComponent$2d = function SVGComponent$2d(_ref28) {
  var _ref28$as = _ref28.as,
      Component = _ref28$as === void 0 ? "svg" : _ref28$as,
      _ref28$children = _ref28.children,
      children = _ref28$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "4"
  })) : _ref28$children,
      props = _objectWithoutProperties(_ref28, _excluded24);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "16",
    viewBox: "0 0 16 16",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var BulletBold = function BulletBold(props) {
  var _useContext24 = useContext(PictoContext),
      optimise = _useContext24.optimise,
      refresh = _useContext24.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z27pwP4', /*#__PURE__*/React.createElement(SVGComponent$2d, props));
};

var SVGComponent$2c = function SVGComponent$2c(_ref29) {
  var _ref29$as = _ref29.as,
      Component = _ref29$as === void 0 ? "svg" : _ref29$as,
      _ref29$children = _ref29.children,
      children = _ref29$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "4"
  })) : _ref29$children,
      props = _objectWithoutProperties(_ref29, _excluded25);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var BulletBook = function BulletBook(props) {
  var _useContext25 = useContext(PictoContext),
      optimise = _useContext25.optimise,
      refresh = _useContext25.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z27pwNq', /*#__PURE__*/React.createElement(SVGComponent$2c, props));
};

var SVGComponent$2b = function SVGComponent$2b(_ref30) {
  var _ref30$as = _ref30.as,
      Component = _ref30$as === void 0 ? "svg" : _ref30$as,
      _ref30$children = _ref30.children,
      children = _ref30$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12.23,18.06a2.49,2.49,0,0,0,2.68-2.43l1.05.14A3.46,3.46,0,0,1,12.23,19a3.81,3.81,0,0,1-3.91-3.12H7V15H8.18c0-.16,0-.32,0-.48s0-.27,0-.41H7v-.9H8.3A3.88,3.88,0,0,1,12.23,10a3.5,3.5,0,0,1,3.69,3l-1,.16a2.54,2.54,0,0,0-2.7-2.23,2.82,2.82,0,0,0-2.88,2.25H13v.9H9.19c0,.14,0,.27,0,.41a3.87,3.87,0,0,0,0,.48h2.87v.9H9.36A2.82,2.82,0,0,0,12.23,18.06ZM15.5,5a3.93,3.93,0,0,1-.29,1.5h2.65l5.33,16H.85l4.27-16H7.79A3.93,3.93,0,0,1,7.5,5a4,4,0,0,1,8,0ZM8.9,6.5h5.2a3,3,0,1,0-5.2,0Zm-3,1-3.73,14H21.81l-4.67-14Z"
  })) : _ref30$children,
      props = _objectWithoutProperties(_ref30, _excluded26);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var Burden = function Burden(props) {
  var _useContext26 = useContext(PictoContext),
      optimise = _useContext26.optimise,
      refresh = _useContext26.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_2mw1QN', /*#__PURE__*/React.createElement(SVGComponent$2b, props));
};

var SVGComponent$2a = function SVGComponent$2a(_ref31) {
  var _ref31$as = _ref31.as,
      Component = _ref31$as === void 0 ? "svg" : _ref31$as,
      _ref31$children = _ref31.children,
      children = _ref31$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "m4.5,7c0-.28.22-.5.5-.5h22c.28,0,.5.22.5.5v2c0,.28-.22.5-.5.5H5c-.28,0-.5-.22-.5-.5v-2Zm0,8c0-.28.22-.5.5-.5h22c.28,0,.5.22.5.5v2c0,.28-.22.5-.5.5H5c-.28,0-.5-.22-.5-.5v-2Zm.5,7.5c-.28,0-.5.22-.5.5v2c0,.28.22.5.5.5h22c.28,0,.5-.22.5-.5v-2c0-.28-.22-.5-.5-.5H5Z"
  })) : _ref31$children,
      props = _objectWithoutProperties(_ref31, _excluded27);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, props), children);
};

var BurgerBold = function BurgerBold(props) {
  var _useContext27 = useContext(PictoContext),
      optimise = _useContext27.optimise,
      refresh = _useContext27.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z50ELm', /*#__PURE__*/React.createElement(SVGComponent$2a, props));
};

var SVGComponent$29 = function SVGComponent$29(_ref32) {
  var _ref32$as = _ref32.as,
      Component = _ref32$as === void 0 ? "svg" : _ref32$as,
      _ref32$children = _ref32.children,
      children = _ref32$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M22,24H2V0H22ZM3,23H21V1H3ZM20,7H4V2H20ZM5,6H19V3H5Zm4,6H5V8H9ZM6,11H8V9H6Zm8,1H10V8h4Zm-3-1h2V9H11Zm3,6H10V13h4Zm-3-1h2V14H11ZM9,17H5V13H9ZM6,16H8V14H6Zm3,6H5V18H9ZM6,21H8V19H6Zm13-9H15V8h4Zm-3-1h2V9H16Zm3,6H15V13h4Zm-3-1h2V14H16Zm3,6H10V18h9Zm-8-1h7V19H11Z"
  })) : _ref32$children,
      props = _objectWithoutProperties(_ref32, _excluded28);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Calculator = function Calculator(props) {
  var _useContext28 = useContext(PictoContext),
      optimise = _useContext28.optimise,
      refresh = _useContext28.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_10Jxyh', /*#__PURE__*/React.createElement(SVGComponent$29, props));
};

var SVGComponent$28 = function SVGComponent$28(_ref33) {
  var _ref33$as = _ref33.as,
      Component = _ref33$as === void 0 ? "svg" : _ref33$as,
      _ref33$children = _ref33.children,
      children = _ref33$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M23.9,23H-.1V4h4V1h4V4h8V1h4V4h4Zm-1-15H.9V22h22ZM6.4,16.8l1-.1c.2.9.7,1.5,1.6,1.5a1.61,1.61,0,0,0,1.7-1.6c0-1-.8-1.8-2.4-1.4l.1-.8c.9.1,1.9-.3,1.9-1.3,0-.7-.5-1.2-1.4-1.2a1.45,1.45,0,0,0-1.5,1.4l-1-.2a2.39,2.39,0,0,1,2.5-2,2.28,2.28,0,0,1,2.5,2,1.88,1.88,0,0,1-1.2,1.6,1.85,1.85,0,0,1,1.6,1.9C11.9,18,10.6,19,9,19A2.39,2.39,0,0,1,6.4,16.8ZM15.9,19h-1V12.7a8.17,8.17,0,0,1-2,1.2V13a4.69,4.69,0,0,0,2.3-2h.7Zm7-14H.9V7h22ZM6.9,2h-2V4h2Zm12,0h-2V4h2Z"
  })) : _ref33$children,
      props = _objectWithoutProperties(_ref33, _excluded29);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Calendar = function Calendar(props) {
  var _useContext29 = useContext(PictoContext),
      optimise = _useContext29.optimise,
      refresh = _useContext29.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z8cP4v', /*#__PURE__*/React.createElement(SVGComponent$28, props));
};

var SVGComponent$27 = function SVGComponent$27(_ref34) {
  var _ref34$as = _ref34.as,
      Component = _ref34$as === void 0 ? "svg" : _ref34$as,
      _ref34$children = _ref34.children,
      children = _ref34$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M13,2V0H11V2H5V0H3V2H0V15H16V2Zm2,12H1V5H15ZM15,4H1V3H15ZM10.43,7.68,9,8.56v-1l1.53-.91.9,0v5.88h-1ZM7.27,10.74c0-.63-.4-.92-1.19-.92h-.5V9H6c.7,0,1.09-.3,1.09-.83a.9.9,0,0,0-1-.84h0a1.11,1.11,0,0,0-1.16,1l-1-.15A2,2,0,0,1,6,6.5c1.15,0,2,.67,2,1.62a1.4,1.4,0,0,1-.72,1.22,1.52,1.52,0,0,1,.93,1.51c0,1.07-.84,1.78-2.1,1.78a2.11,2.11,0,0,1-2.3-1.9,1.34,1.34,0,0,1,0-.2l1-.14c.08.88.54,1.35,1.34,1.35S7.27,11.37,7.27,10.74Z"
  })) : _ref34$children,
      props = _objectWithoutProperties(_ref34, _excluded30);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), children);
};

var CalendarBold = function CalendarBold(props) {
  var _useContext30 = useContext(PictoContext),
      optimise = _useContext30.optimise,
      refresh = _useContext30.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_ZdD3T7', /*#__PURE__*/React.createElement(SVGComponent$27, props));
};

var SVGComponent$26 = function SVGComponent$26(_ref35) {
  var _ref35$as = _ref35.as,
      Component = _ref35$as === void 0 ? "svg" : _ref35$as,
      _ref35$children = _ref35.children,
      children = _ref35$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M15,3a2,2,0,0,1,2,2V9l7-4V19l-7-4v4a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V5A2,2,0,0,1,2,3Zm0,17a1,1,0,0,0,1-1V5a1,1,0,0,0-1-1H2A1,1,0,0,0,1,5V19a1,1,0,0,0,1,1Zm2-9.85v3.7l6,3.43V6.72Z"
  })) : _ref35$children,
      props = _objectWithoutProperties(_ref35, _excluded31);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var Camera = function Camera(props) {
  var _useContext31 = useContext(PictoContext),
      optimise = _useContext31.optimise,
      refresh = _useContext31.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_2nf8iD', /*#__PURE__*/React.createElement(SVGComponent$26, props));
};

var SVGComponent$25 = function SVGComponent$25(_ref36) {
  var _ref36$as = _ref36.as,
      Component = _ref36$as === void 0 ? "svg" : _ref36$as,
      _ref36$children = _ref36.children,
      children = _ref36$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M6,4.4H5V3H24V19H16.3L19,23H17.7L15,19H13l-2.7,4H9l2.7-4H9V18h8V17h3v1h3V4H6ZM8.2,21.8A1.16,1.16,0,0,1,7,23a1.38,1.38,0,0,1-1.3-1.2l-.4-4-.3,4A1.22,1.22,0,0,1,3.8,23a1.3,1.3,0,0,1-1.3-1.2l-.3-6.5-.3.6a1.23,1.23,0,0,1-1.3.5,1.09,1.09,0,0,1-.7-1v-.3L1.2,11a1.41,1.41,0,0,1,1.4-1H6.7A4.15,4.15,0,0,0,8,9.7l3.1-1.8a1.06,1.06,0,0,1,1.2.2.94.94,0,0,1-.1,1.3l-3,2.9a1.82,1.82,0,0,0-.6,1.4C8.5,15.1,8.2,21.8,8.2,21.8ZM2.5,11c-.2,0-.3.1-.4.3-.3,1-1,3.7-1.1,4.1l1.5-2.6a.32.32,0,0,1,.6.2l.3,8.8c.1.2.6.2.6,0,0,0,.3-3.4.3-3.9a.94.94,0,0,1,1-1,1,1,0,0,1,1,1c0,.3.3,3.4.4,3.9s.5.3.5,0c0,0,.2-6.7.3-8.1a3.33,3.33,0,0,1,.9-2.1l3-2.9c-.7.5-2.4,1.5-3.1,1.9a3.53,3.53,0,0,1-1.7.4ZM19,12H14V11h5Zm2-2H14V9h7ZM5.3,5A2.26,2.26,0,0,0,3,7.3,2.26,2.26,0,0,0,5.3,9.6,2.26,2.26,0,0,0,7.6,7.3,2.26,2.26,0,0,0,5.3,5Zm0,1a1.3,1.3,0,0,1,0,2.6A1.26,1.26,0,0,1,4,7.3,1.26,1.26,0,0,1,5.3,6ZM21,8H14V7h7Z"
  })) : _ref36$children,
      props = _objectWithoutProperties(_ref36, _excluded32);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var ChalkboardTeacher = function ChalkboardTeacher(props) {
  var _useContext32 = useContext(PictoContext),
      optimise = _useContext32.optimise,
      refresh = _useContext32.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_2vUgaA', /*#__PURE__*/React.createElement(SVGComponent$25, props));
};

var SVGComponent$24 = function SVGComponent$24(_ref37) {
  var _ref37$as = _ref37.as,
      Component = _ref37$as === void 0 ? "svg" : _ref37$as,
      _ref37$children = _ref37.children,
      children = _ref37$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M0,22H1V17H5v5H7V12h4V22h2V7h4V22h2V1h4V22h1v1H0Zm4-4H2v4H4Zm6-5H8v9h2Zm6-5H14V22h2Zm6-6H20V22h2Z"
  })) : _ref37$children,
      props = _objectWithoutProperties(_ref37, _excluded33);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var ChartBar = function ChartBar(props) {
  var _useContext33 = useContext(PictoContext),
      optimise = _useContext33.optimise,
      refresh = _useContext33.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_1Lpmv3', /*#__PURE__*/React.createElement(SVGComponent$24, props));
};

var SVGComponent$23 = function SVGComponent$23(_ref38) {
  var _ref38$as = _ref38.as,
      Component = _ref38$as === void 0 ? "svg" : _ref38$as,
      _ref38$children = _ref38.children,
      children = _ref38$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M24,4.68,7.67,22,0,13l.76-.65,7,8.2L23.27,4Z"
  })) : _ref38$children,
      props = _objectWithoutProperties(_ref38, _excluded34);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Check = function Check(props) {
  var _useContext34 = useContext(PictoContext),
      optimise = _useContext34.optimise,
      refresh = _useContext34.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_4GGpz', /*#__PURE__*/React.createElement(SVGComponent$23, props));
};

var SVGComponent$22 = function SVGComponent$22(_ref39) {
  var _ref39$as = _ref39.as,
      Component = _ref39$as === void 0 ? "svg" : _ref39$as,
      _ref39$children = _ref39.children,
      children = _ref39$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M5.8,11.6l8-8.29,1.44,1.38L5.88,14.4.32,9.23,1.68,7.77Z",
    fillRule: "evenodd"
  })) : _ref39$children,
      props = _objectWithoutProperties(_ref39, _excluded35);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), children);
};

var CheckBold = function CheckBold(props) {
  var _useContext35 = useContext(PictoContext),
      optimise = _useContext35.optimise,
      refresh = _useContext35.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z2eHEHd', /*#__PURE__*/React.createElement(SVGComponent$22, props));
};

var SVGComponent$21 = function SVGComponent$21(_ref40) {
  var _ref40$as = _ref40.as,
      Component = _ref40$as === void 0 ? "svg" : _ref40$as,
      _ref40$children = _ref40.children,
      children = _ref40$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "m6.52,10.72l5.99-6.22,1.08,1.04-7.01,7.28-4.17-3.88,1.02-1.1,3.09,2.87Z"
  })) : _ref40$children,
      props = _objectWithoutProperties(_ref40, _excluded36);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), children);
};

var CheckBoldMini = function CheckBoldMini(props) {
  var _useContext36 = useContext(PictoContext),
      optimise = _useContext36.optimise,
      refresh = _useContext36.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_XYUds', /*#__PURE__*/React.createElement(SVGComponent$21, props));
};

var SVGComponent$20 = function SVGComponent$20(_ref41) {
  var _ref41$as = _ref41.as,
      Component = _ref41$as === void 0 ? "svg" : _ref41$as,
      _ref41$children = _ref41.children,
      children = _ref41$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M18.63,4.23c-.16-.16-.41-.32-.57-.16-.56.56-1.49.58-1.92,1.35v0c-.57.67-1.38,1.08-1.63,2a.35.35,0,0,0,.08,0l-.08,0c-.15.08-.16.23-.16.38l0,0a11.4,11.4,0,0,1-.89,1.08h0c-.08.15-.15.24-.23.37l-.09,0c-.23.41-.55.76-.8,1.17h0a10.34,10.34,0,0,1-.53,1l-.2.2a1.54,1.54,0,0,0-.05.17,2.6,2.6,0,0,0-.62,1.39l0,.05c-.09.07-.16.23-.25.32l0,.06a3.05,3.05,0,0,0-.7.88.18.18,0,0,0-.07.05.73.73,0,0,0-.16.41.06.06,0,0,0,0,0,4.53,4.53,0,0,0-.79,1.11l.08.08-.06,0c-.25.07-.09.67-.57.57l-.14-.09c-.23-.38-.44-.81-.66-1.27a.43.43,0,0,1,0-.11v-.12h0a.08.08,0,0,0,0,0,.3.3,0,0,1,0-.13c-.07-.22-.18-.47-.27-.72l-.09-.28A2.18,2.18,0,0,1,7,13.46a1.89,1.89,0,0,0-.8-1l0,0a.81.81,0,0,0-1.07-.24c-.39.25-.16.67.09.92a0,0,0,0,1,0,0,.91.91,0,0,0,.15.38h0A19.54,19.54,0,0,0,7,18.09a1,1,0,0,0,.07-.15,1,1,0,0,1,0,.17,1.15,1.15,0,0,0,.23.55l0,0H7.29c.51.67,1.08,1.17,2.05.76v0a1.26,1.26,0,0,0,.68-.78l.12-.1c0-.25.09-.41.09-.57.74-.48.9-1.31,1.31-2.07A6,6,0,0,1,12,15a3.86,3.86,0,0,0,.8-2.12l-.08,0,0,0c.07,0,.08-.07.09-.11l0,0c.48-.07.48-.51.57-.83l-.12.08.12-.17.16-.16v0l0,0a9.67,9.67,0,0,0,2.11-3,.56.56,0,0,1,.05-.08s0,.06,0,.08c.32-.41,1.06-.64.64-1.4h0c.9-.25,1.22-1,1.7-1.59h0c.07-.16.16-.25.23-.41h0c.09-.09.25-.16.34-.25V5C19,4.78,18.87,4.47,18.63,4.23ZM16.2,6l0,0-.11,0ZM7.54,16.87h0l-.08.06Zm-.13.34s0,0,0,.05h0S7.4,17.23,7.41,17.21Z"
  })) : _ref41$children,
      props = _objectWithoutProperties(_ref41, _excluded37);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var CheckHandwrite = function CheckHandwrite(props) {
  var _useContext37 = useContext(PictoContext),
      optimise = _useContext37.optimise,
      refresh = _useContext37.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_14TK4O', /*#__PURE__*/React.createElement(SVGComponent$20, props));
};

var SVGComponent$1$ = function SVGComponent$1$(_ref42) {
  var _ref42$as = _ref42.as,
      Component = _ref42$as === void 0 ? "svg" : _ref42$as,
      _ref42$children = _ref42.children,
      children = _ref42$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "m7.43,10.57l1.13-1.13,3.43,3.43,3.43-3.43,1.13,1.13-4.57,4.57-4.57-4.57Z"
  })) : _ref42$children,
      props = _objectWithoutProperties(_ref42, _excluded38);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var ChevronDown = function ChevronDown(props) {
  var _useContext38 = useContext(PictoContext),
      optimise = _useContext38.optimise,
      refresh = _useContext38.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_ZslpJA', /*#__PURE__*/React.createElement(SVGComponent$1$, props));
};

var SVGComponent$1_ = function SVGComponent$1_(_ref43) {
  var _ref43$as = _ref43.as,
      Component = _ref43$as === void 0 ? "svg" : _ref43$as,
      _ref43$children = _ref43.children,
      children = _ref43$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M1.94,5.86l1.29-1.3L7.44,8.84l4.2-4.28,1.3,1.3-5.5,5.58Z"
  })) : _ref43$children,
      props = _objectWithoutProperties(_ref43, _excluded39);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "16",
    viewBox: "0 0 16 16",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var ChevronDownBold = function ChevronDownBold(props) {
  var _useContext39 = useContext(PictoContext),
      optimise = _useContext39.optimise,
      refresh = _useContext39.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_126jrr', /*#__PURE__*/React.createElement(SVGComponent$1_, props));
};

var SVGComponent$1Z = function SVGComponent$1Z(_ref44) {
  var _ref44$as = _ref44.as,
      Component = _ref44$as === void 0 ? "svg" : _ref44$as,
      _ref44$children = _ref44.children,
      children = _ref44$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M9.58,2.5l1.3,1.3L6.59,8l4.29,4.2-1.3,1.3L4,8Z"
  })) : _ref44$children,
      props = _objectWithoutProperties(_ref44, _excluded40);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "16",
    viewBox: "0 0 16 16",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var ChevronLeftBold = function ChevronLeftBold(props) {
  var _useContext40 = useContext(PictoContext),
      optimise = _useContext40.optimise,
      refresh = _useContext40.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_1n8MkT', /*#__PURE__*/React.createElement(SVGComponent$1Z, props));
};

var SVGComponent$1Y = function SVGComponent$1Y(_ref45) {
  var _ref45$as = _ref45.as,
      Component = _ref45$as === void 0 ? "svg" : _ref45$as,
      _ref45$children = _ref45.children,
      children = _ref45$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M6.3,2.5,5,3.8,9.28,8,5,12.2l1.3,1.3L11.88,8Z"
  })) : _ref45$children,
      props = _objectWithoutProperties(_ref45, _excluded41);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "16",
    viewBox: "0 0 16 16",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var ChevronRightBold = function ChevronRightBold(props) {
  var _useContext41 = useContext(PictoContext),
      optimise = _useContext41.optimise,
      refresh = _useContext41.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z1NlNzP', /*#__PURE__*/React.createElement(SVGComponent$1Y, props));
};

var SVGComponent$1X = function SVGComponent$1X(_ref46) {
  var _ref46$as = _ref46.as,
      Component = _ref46$as === void 0 ? "svg" : _ref46$as,
      _ref46$children = _ref46.children,
      children = _ref46$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "m16.56,13.44l-1.13,1.13-3.43-3.43-3.43,3.43-1.13-1.13,4.57-4.57,4.57,4.57Z"
  })) : _ref46$children,
      props = _objectWithoutProperties(_ref46, _excluded42);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var ChevronUp = function ChevronUp(props) {
  var _useContext42 = useContext(PictoContext),
      optimise = _useContext42.optimise,
      refresh = _useContext42.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z1zQNF8', /*#__PURE__*/React.createElement(SVGComponent$1X, props));
};

var SVGComponent$1W = function SVGComponent$1W(_ref47) {
  var _ref47$as = _ref47.as,
      Component = _ref47$as === void 0 ? "svg" : _ref47$as,
      _ref47$children = _ref47.children,
      children = _ref47$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M1.94,10.14l1.29,1.3L7.44,7.16l4.2,4.28,1.3-1.3L7.44,4.56Z"
  })) : _ref47$children,
      props = _objectWithoutProperties(_ref47, _excluded43);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "16",
    viewBox: "0 0 16 16",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var ChevronUpBold = function ChevronUpBold(props) {
  var _useContext43 = useContext(PictoContext),
      optimise = _useContext43.optimise,
      refresh = _useContext43.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_1q8qOU', /*#__PURE__*/React.createElement(SVGComponent$1W, props));
};

var SVGComponent$1V = function SVGComponent$1V(_ref48) {
  var _ref48$as = _ref48.as,
      Component = _ref48$as === void 0 ? "svg" : _ref48$as,
      _ref48$children = _ref48.children,
      children = _ref48$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Zm0,1A11,11,0,1,1,1,12,11,11,0,0,1,12,1Zm0,11h6v1H11V4h1Z",
    fillRule: "evenodd"
  })) : _ref48$children,
      props = _objectWithoutProperties(_ref48, _excluded44);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Clock = function Clock(props) {
  var _useContext44 = useContext(PictoContext),
      optimise = _useContext44.optimise,
      refresh = _useContext44.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_4Hg1C', /*#__PURE__*/React.createElement(SVGComponent$1V, props));
};

var SVGComponent$1U = function SVGComponent$1U(_ref49) {
  var _ref49$as = _ref49.as,
      Component = _ref49$as === void 0 ? "svg" : _ref49$as,
      _ref49$children = _ref49.children,
      children = _ref49$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,8.17h2.67v1.5H7V4.83H8.5Zm6-.17A6.5,6.5,0,1,1,8,1.5,6.51,6.51,0,0,1,14.5,8ZM13,8a5,5,0,1,0-5,5A5,5,0,0,0,13,8Z"
  })) : _ref49$children,
      props = _objectWithoutProperties(_ref49, _excluded45);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), children);
};

var ClockBold = function ClockBold(props) {
  var _useContext45 = useContext(PictoContext),
      optimise = _useContext45.optimise,
      refresh = _useContext45.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_1ga8eC', /*#__PURE__*/React.createElement(SVGComponent$1U, props));
};

var SVGComponent$1T = function SVGComponent$1T(_ref50) {
  var _ref50$as = _ref50.as,
      Component = _ref50$as === void 0 ? "svg" : _ref50$as,
      _ref50$children = _ref50.children,
      children = _ref50$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "m16,17.73l5.27,5.27,1.73-1.73-5.27-5.27,5.27-5.27-1.73-1.73-5.27,5.27-5.27-5.27-1.73,1.73,5.27,5.27-5.27,5.27,1.73,1.73,5.27-5.27Z"
  })) : _ref50$children,
      props = _objectWithoutProperties(_ref50, _excluded46);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, props), children);
};

var CloseBold = function CloseBold(props) {
  var _useContext46 = useContext(PictoContext),
      optimise = _useContext46.optimise,
      refresh = _useContext46.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_1MPN80', /*#__PURE__*/React.createElement(SVGComponent$1T, props));
};

var SVGComponent$1S = function SVGComponent$1S(_ref51) {
  var _ref51$as = _ref51.as,
      Component = _ref51$as === void 0 ? "svg" : _ref51$as,
      _ref51$children = _ref51.children,
      children = _ref51$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M18.5,20H5.5a4.5,4.5,0,0,1-.8-8.92l.78-.14,0-.79a6.49,6.49,0,0,1,13,0l0,.79.78.14A4.5,4.5,0,0,1,18.5,20Zm1-9.91a7.49,7.49,0,0,0-15,0A5.5,5.5,0,0,0,5.5,21h13a5.5,5.5,0,0,0,1-10.91Z"
  })) : _ref51$children,
      props = _objectWithoutProperties(_ref51, _excluded47);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Cloud = function Cloud(props) {
  var _useContext47 = useContext(PictoContext),
      optimise = _useContext47.optimise,
      refresh = _useContext47.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_4HgaE', /*#__PURE__*/React.createElement(SVGComponent$1S, props));
};

var SVGComponent$1R = function SVGComponent$1R(_ref52) {
  var _ref52$as = _ref52.as,
      Component = _ref52$as === void 0 ? "svg" : _ref52$as,
      _ref52$children = _ref52.children,
      children = _ref52$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M11.49,10.17,9,13.24l-.73-.68L12,8l3.75,4.58-.75.67-2.5-3.08V18h-1Zm7,9.83H5.5a4.5,4.5,0,0,1-.8-8.92l.78-.14,0-.79a6.49,6.49,0,0,1,13,0l0,.79.78.14A4.5,4.5,0,0,1,18.5,20Zm1-9.91a7.49,7.49,0,0,0-15,0A5.5,5.5,0,0,0,5.5,21h13a5.5,5.5,0,0,0,1-10.91Z",
    fillRule: "evenodd"
  })) : _ref52$children,
      props = _objectWithoutProperties(_ref52, _excluded48);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var CloudUpload = function CloudUpload(props) {
  var _useContext48 = useContext(PictoContext),
      optimise = _useContext48.optimise,
      refresh = _useContext48.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_efIsB', /*#__PURE__*/React.createElement(SVGComponent$1R, props));
};

var SVGComponent$1Q = function SVGComponent$1Q(_ref53) {
  var _ref53$as = _ref53.as,
      Component = _ref53$as === void 0 ? "svg" : _ref53$as,
      _ref53$children = _ref53.children,
      children = _ref53$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "m8,0C3.59,0,0,3.59,0,8s3.59,8,8,8,8-3.59,8-8S12.41,0,8,0Zm1.72,5.49c0,.05-.01.1-.1.05-.27-.1-.57-.16-1.08-.16-1.19,0-1.87.74-2.03,1.59h2.17s.05.01.05.05v.55c0,.05-.03.05-.05.05h-2.24c-.01.19-.01.44-.01.6h2.25s.05.01.05.07v.54s-.01.07-.05.07h-2.17c.17,1.01.94,1.69,2.03,1.69.47,0,.75-.02,1.09-.14.03-.01.07,0,.07.05v.99s-.02.1-.07.12c-.29.12-.66.15-1.26.15-1.74,0-2.94-1.19-3.14-2.85h-.57s-.05-.01-.05-.07v-.54s.01-.07.05-.07h.5c0-.2,0-.4.01-.6h-.49c-.05,0-.07-.01-.07-.05v-.54c0-.05.02-.07.05-.07h.58c.3-1.58,1.54-2.74,3.25-2.74.56,0,.89.03,1.15.14.05.01.07.05.07.12v.99Z"
  })) : _ref53$children,
      props = _objectWithoutProperties(_ref53, _excluded49);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "16",
    viewBox: "0 0 16 16",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var CoinBold = function CoinBold(props) {
  var _useContext49 = useContext(PictoContext),
      optimise = _useContext49.optimise,
      refresh = _useContext49.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_ZL7gXF', /*#__PURE__*/React.createElement(SVGComponent$1Q, props));
};

var SVGComponent$1P = function SVGComponent$1P(_ref54) {
  var _ref54$as = _ref54.as,
      Component = _ref54$as === void 0 ? "svg" : _ref54$as,
      _ref54$children = _ref54.children,
      children = _ref54$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M16.87,14.63l1,.14A3.45,3.45,0,0,1,14.19,18a3.82,3.82,0,0,1-3.92-3.12H9V14h1.17c0-.16,0-.32,0-.48s0-.27,0-.41H9v-.9h1.3A3.87,3.87,0,0,1,14.19,9a3.49,3.49,0,0,1,3.68,3l-1,.16a2.54,2.54,0,0,0-2.69-2.23,2.84,2.84,0,0,0-2.89,2.25h3.61v.9H11.15c0,.14,0,.27,0,.41s0,.32,0,.48H14v.9H11.31a2.83,2.83,0,0,0,2.88,2.18A2.49,2.49,0,0,0,16.87,14.63ZM24,13.5A10.43,10.43,0,0,1,4.93,19.42h0A10.48,10.48,0,1,1,19.08,4.59,10.51,10.51,0,0,1,24,13.5ZM3.79,17.24h0A10.73,10.73,0,0,1,3.1,13.5,10.49,10.49,0,0,1,13.55,3a10.26,10.26,0,0,1,3.34.55A9.48,9.48,0,0,0,3.79,17.24ZM23,13.5A9.46,9.46,0,1,0,13.55,23,9.49,9.49,0,0,0,23,13.5Z",
    fillRule: "evenodd"
  })) : _ref54$children,
      props = _objectWithoutProperties(_ref54, _excluded50);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var Coins = function Coins(props) {
  var _useContext50 = useContext(PictoContext),
      optimise = _useContext50.optimise,
      refresh = _useContext50.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_4HCzW', /*#__PURE__*/React.createElement(SVGComponent$1P, props));
};

var SVGComponent$1O = function SVGComponent$1O(_ref55) {
  var _ref55$as = _ref55.as,
      Component = _ref55$as === void 0 ? "svg" : _ref55$as,
      _ref55$children = _ref55.children,
      children = _ref55$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M11,2H21l3,3V7H19v5h1v3a7.86,7.86,0,0,0-2.08,0A2.21,2.21,0,0,0,16,17a2,2,0,0,0,3.68,1.09.51.51,0,1,1,.88.51A3.06,3.06,0,0,1,18,20a3,3,0,0,1-1-5.83V12h1V7H11V24H5V7H4V9H0V2H5V0h6ZM10,7H6V23h4ZM9,20,7,21v1l2-1Zm0-3L7,18v1l2-1Zm0-3L7,15v1l2-1Zm10-1H18v1h1ZM9,11,7,12v1l2-1ZM9,8,7,9v1L9,9Zm1-7H6V3H1V8H3V6H23V5.41L20.59,3H10Z",
    fillRule: "evenodd"
  })) : _ref55$children,
      props = _objectWithoutProperties(_ref55, _excluded51);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var Crane = function Crane(props) {
  var _useContext51 = useContext(PictoContext),
      optimise = _useContext51.optimise,
      refresh = _useContext51.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_4HYwO', /*#__PURE__*/React.createElement(SVGComponent$1O, props));
};

var SVGComponent$1N = function SVGComponent$1N(_ref56) {
  var _ref56$as = _ref56.as,
      Component = _ref56$as === void 0 ? "svg" : _ref56$as,
      _ref56$children = _ref56.children,
      children = _ref56$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,1A2.8,2.8,0,0,0,9.2,3.8a3.16,3.16,0,0,0,1.1,2.3C9.8,8.9,8.4,9.2,7.4,9.2A3.09,3.09,0,0,1,4.9,7.5a2.94,2.94,0,0,0,.7-1.9A2.86,2.86,0,0,0,2.8,2.8,2.88,2.88,0,0,0,0,5.7,3.06,3.06,0,0,0,2,8.5V23H22V8.4a2.92,2.92,0,0,0,2-2.8,2.8,2.8,0,0,0-5.6,0,2.94,2.94,0,0,0,.7,1.9,2.82,2.82,0,0,1-2.5,1.7c-.6,0-2.3,0-2.9-3.2a3,3,0,0,0,1-2.9A2.71,2.71,0,0,0,12,1Zm9,21V19H3v3Zm0-4V7.7c1.1-.3,2-.9,2-2.1a1.8,1.8,0,0,0-3.6,0,2.62,2.62,0,0,0,.9,1.8c-.8,1.6-1.9,2.8-3.7,2.8-2.5,0-3.6-1.9-3.9-4.5.7-.7,1.3-1.3,1.1-2.3A1.83,1.83,0,0,0,12,2a1.79,1.79,0,0,0-1.8,1.8c0,.8.5,1.3,1.2,1.9-.3,2.7-1.4,4.5-3.9,4.5-1.9,0-2.9-1.4-3.7-2.7a3,3,0,0,0,1-1.9A1.79,1.79,0,0,0,3,3.8,1.92,1.92,0,0,0,1,5.7c0,1.1.9,1.8,2,2.1V18Z",
    fillRule: "evenodd"
  })) : _ref56$children,
      props = _objectWithoutProperties(_ref56, _excluded52);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Crown = function Crown(props) {
  var _useContext52 = useContext(PictoContext),
      optimise = _useContext52.optimise,
      refresh = _useContext52.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_4I3e6', /*#__PURE__*/React.createElement(SVGComponent$1N, props));
};

var SVGComponent$1M = function SVGComponent$1M(_ref57) {
  var _ref57$as = _ref57.as,
      Component = _ref57$as === void 0 ? "svg" : _ref57$as,
      _ref57$children = _ref57.children,
      children = _ref57$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 5.33333H16V0H10.6667V0.666667H14.862L7.09733 8.43067L7.56933 8.90267L15.3333 1.138V5.33333Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666667 6.66667H4.66255e-07L0 12L5.33333 12V11.3333L1.138 11.3333L8.90267 3.56933L8.43067 3.09733L0.666667 10.862L0.666667 6.66667Z"
  })) : _ref57$children,
      props = _objectWithoutProperties(_ref57, _excluded53);

  return /*#__PURE__*/React.createElement(Component, _extends({
    width: "16",
    height: "12",
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var DoubleArrow = function DoubleArrow(props) {
  var _useContext53 = useContext(PictoContext),
      optimise = _useContext53.optimise,
      refresh = _useContext53.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_1Bzbk', /*#__PURE__*/React.createElement(SVGComponent$1M, props));
};

var SVGComponent$1L = function SVGComponent$1L(_ref58) {
  var _ref58$as = _ref58.as,
      Component = _ref58$as === void 0 ? "svg" : _ref58$as,
      _ref58$children = _ref58.children,
      children = _ref58$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M17.7,2.38A11.45,11.45,0,0,1,24,12.5,11.76,11.76,0,0,1,12,24,11.76,11.76,0,0,1,0,12.5,11.45,11.45,0,0,1,6.3,2.38l.63.81A10.47,10.47,0,0,0,1,12.5,10.74,10.74,0,0,0,12,23,10.74,10.74,0,0,0,23,12.5a10.47,10.47,0,0,0-5.89-9.31ZM12.52,0V14.83l3.91-4.61.79.67L12,17,6.78,10.9l.77-.68,3.93,4.61V0Z"
  })) : _ref58$children,
      props = _objectWithoutProperties(_ref58, _excluded54);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Download = function Download(props) {
  var _useContext54 = useContext(PictoContext),
      optimise = _useContext54.optimise,
      refresh = _useContext54.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_1KMgPC', /*#__PURE__*/React.createElement(SVGComponent$1L, props));
};

var SVGComponent$1K = function SVGComponent$1K(_ref59) {
  var _ref59$as = _ref59.as,
      Component = _ref59$as === void 0 ? "svg" : _ref59$as,
      _ref59$children = _ref59.children,
      children = _ref59$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M23,7h-6V1H1V17H7v6H23V7Zm-15,1h14v14H8V8ZM16,2V7H7V16H2V2h14Zm-1.5,9h1v3.5h3.5v1h-3.5v3.5h-1v-3.5h-3.5v-1h3.5v-3.5Z",
    fillRule: "evenodd"
  })) : _ref59$children,
      props = _objectWithoutProperties(_ref59, _excluded55);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var Duplicate = function Duplicate(props) {
  var _useContext55 = useContext(PictoContext),
      optimise = _useContext55.optimise,
      refresh = _useContext55.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z1hF7XI', /*#__PURE__*/React.createElement(SVGComponent$1K, props));
};

var SVGComponent$1J = function SVGComponent$1J(_ref60) {
  var _ref60$as = _ref60.as,
      Component = _ref60$as === void 0 ? "svg" : _ref60$as,
      _ref60$children = _ref60.children,
      children = _ref60$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M24,21H0V3H24ZM1,4.52V20H23V4.52l-11,10ZM22.09,4H1.91L12,13.17Z"
  })) : _ref60$children,
      props = _objectWithoutProperties(_ref60, _excluded56);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Envelope = function Envelope(props) {
  var _useContext56 = useContext(PictoContext),
      optimise = _useContext56.optimise,
      refresh = _useContext56.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z2liq9E', /*#__PURE__*/React.createElement(SVGComponent$1J, props));
};

var SVGComponent$1I = function SVGComponent$1I(_ref61) {
  var _ref61$as = _ref61.as,
      Component = _ref61$as === void 0 ? "svg" : _ref61$as,
      _ref61$children = _ref61.children,
      children = _ref61$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("rect", {
    height: "2",
    width: "12",
    x: "2",
    y: "9"
  }), /*#__PURE__*/React.createElement("rect", {
    height: "2",
    width: "12",
    x: "2",
    y: "5"
  })) : _ref61$children,
      props = _objectWithoutProperties(_ref61, _excluded57);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "16",
    viewBox: "0 0 16 16",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var EqualBold = function EqualBold(props) {
  var _useContext57 = useContext(PictoContext),
      optimise = _useContext57.optimise,
      refresh = _useContext57.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z1HCd84', /*#__PURE__*/React.createElement(SVGComponent$1I, props));
};

var SVGComponent$1H = function SVGComponent$1H(_ref62) {
  var _ref62$as = _ref62.as,
      Component = _ref62$as === void 0 ? "svg" : _ref62$as,
      _ref62$children = _ref62.children,
      children = _ref62$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Zm0,1A11,11,0,1,1,1,12,11,11,0,0,1,12,1ZM5.22,9.48H18.78v1H5.22Zm13.56,4H5.22v1H18.78v-1Z",
    fillRule: "evenodd"
  })) : _ref62$children,
      props = _objectWithoutProperties(_ref62, _excluded58);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var EqualCircle = function EqualCircle(props) {
  var _useContext58 = useContext(PictoContext),
      optimise = _useContext58.optimise,
      refresh = _useContext58.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_ZDQwl0', /*#__PURE__*/React.createElement(SVGComponent$1H, props));
};

var SVGComponent$1G = function SVGComponent$1G(_ref63) {
  var _ref63$as = _ref63.as,
      Component = _ref63$as === void 0 ? "svg" : _ref63$as,
      _ref63$children = _ref63.children,
      children = _ref63$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M4.35,8.69C5.5,3.69,9.24.5,14.41.5a9.89,9.89,0,0,1,6.37,2.11A9,9,0,0,1,23.9,8.28l-1,.15a7.93,7.93,0,0,0-2.77-5A8.88,8.88,0,0,0,14.41,1.5c-4.67,0-8,2.83-9.08,7.4l-.09.6H14v1H5.11L5,11.06c0,.3,0,.61,0,.94s0,.76,0,1.12l.06.38H12v1H5.24l.12.78a9.37,9.37,0,0,0,3.16,5.29,9.16,9.16,0,0,0,5.89,1.93,8.83,8.83,0,0,0,6-2A8.19,8.19,0,0,0,23,15.05l1,.11a9.17,9.17,0,0,1-3,6.1,9.82,9.82,0,0,1-6.62,2.24,10.17,10.17,0,0,1-6.52-2.15,10.34,10.34,0,0,1-3.51-5.86v0l-.15-1H0v-1H4.07l0-.27v0c0-.41,0-.82,0-1.2v0c0-.33,0-.68,0-1H4l.07-.45H0v-1H4.23l.11-.79Z"
  })) : _ref63$children,
      props = _objectWithoutProperties(_ref63, _excluded59);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var Euro = function Euro(props) {
  var _useContext59 = useContext(PictoContext),
      optimise = _useContext59.optimise,
      refresh = _useContext59.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_9yC0', /*#__PURE__*/React.createElement(SVGComponent$1G, props));
};

var SVGComponent$1F = function SVGComponent$1F(_ref64) {
  var _ref64$as = _ref64.as,
      Component = _ref64$as === void 0 ? "svg" : _ref64$as,
      _ref64$children = _ref64.children,
      children = _ref64$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M3.18,10.12H1.11v-1H3l0-.27c0-.26,0-.52,0-.77s0-.43,0-.65l0-.27H1.11v-1H3.16l0-.2A6,6,0,0,1,9.28,1a5.37,5.37,0,0,1,5.64,4.47l-1.11.18A4.33,4.33,0,0,0,9.28,2,4.83,4.83,0,0,0,4.39,5.9l-.08.32H10.2v1h-6l0,.23c0,.23,0,.46,0,.69s0,.54,0,.81l0,.23H8.79v1H4.32l.09.32a4.84,4.84,0,0,0,4.87,3.75,4.25,4.25,0,0,0,4.53-3.94L15,10.4a5.33,5.33,0,0,1-5.72,4.83,6,6,0,0,1-6.06-4.92Z"
  })) : _ref64$children,
      props = _objectWithoutProperties(_ref64, _excluded60);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), children);
};

var EuroBold = function EuroBold(props) {
  var _useContext60 = useContext(PictoContext),
      optimise = _useContext60.optimise,
      refresh = _useContext60.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_ZcuF7g', /*#__PURE__*/React.createElement(SVGComponent$1F, props));
};

var SVGComponent$1E = function SVGComponent$1E(_ref65) {
  var _ref65$as = _ref65.as,
      Component = _ref65$as === void 0 ? "svg" : _ref65$as,
      _ref65$children = _ref65.children,
      children = _ref65$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Zm0,1A11,11,0,1,1,1,12,11,11,0,0,1,12,1Zm-.5,5h1v9h-1ZM12,18a.84.84,0,1,1,.85-.84A.85.85,0,0,1,12,18Z",
    fillRule: "evenodd"
  })) : _ref65$children,
      props = _objectWithoutProperties(_ref65, _excluded61);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var ExclamationMarkCircle = function ExclamationMarkCircle(props) {
  var _useContext61 = useContext(PictoContext),
      optimise = _useContext61.optimise,
      refresh = _useContext61.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_mpUd6', /*#__PURE__*/React.createElement(SVGComponent$1E, props));
};

var SVGComponent$1D = function SVGComponent$1D(_ref66) {
  var _ref66$as = _ref66.as,
      Component = _ref66$as === void 0 ? "svg" : _ref66$as,
      _ref66$children = _ref66.children,
      children = _ref66$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M16,8a8,8,0,1,0-8,8A8,8,0,0,0,16,8ZM7,10V3H9v7Zm2.25,2.25A1.25,1.25,0,1,1,8,11,1.25,1.25,0,0,1,9.25,12.25Z",
    fillRule: "evenodd"
  })) : _ref66$children,
      props = _objectWithoutProperties(_ref66, _excluded62);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), children);
};

var ExclamationMarkCircleBold = function ExclamationMarkCircleBold(props) {
  var _useContext62 = useContext(PictoContext),
      optimise = _useContext62.optimise,
      refresh = _useContext62.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_1nrR69', /*#__PURE__*/React.createElement(SVGComponent$1D, props));
};

var SVGComponent$1C = function SVGComponent$1C(_ref67) {
  var _ref67$as = _ref67.as,
      Component = _ref67$as === void 0 ? "svg" : _ref67$as,
      _ref67$children = _ref67.children,
      children = _ref67$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M15,8c0-3.86-3.14-7-7-7S1,4.14,1,8s3.14,7,7,7,7-3.14,7-7ZM8,0c4.42,0,8,3.58,8,8s-3.58,8-8,8S0,12.42,0,8,3.58,0,8,0Zm-1,10V3h2v7h-2Zm2.25,2.25c0,.69-.56,1.25-1.25,1.25s-1.25-.56-1.25-1.25,.56-1.25,1.25-1.25,1.25,.56,1.25,1.25Z"
  })) : _ref67$children,
      props = _objectWithoutProperties(_ref67, _excluded63);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), children);
};

var ExclamationMarkCircleLine = function ExclamationMarkCircleLine(props) {
  var _useContext63 = useContext(PictoContext),
      optimise = _useContext63.optimise,
      refresh = _useContext63.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_1nt9Cq', /*#__PURE__*/React.createElement(SVGComponent$1C, props));
};

var SVGComponent$1B = function SVGComponent$1B(_ref68) {
  var _ref68$as = _ref68.as,
      Component = _ref68$as === void 0 ? "svg" : _ref68$as,
      _ref68$children = _ref68.children,
      children = _ref68$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M24,23H0L12,1ZM1.68,22H22.32L12,3.09ZM12,20a.85.85,0,1,0-.85-.84A.85.85,0,0,0,12,20Zm.5-11v8h-1V9Z"
  })) : _ref68$children,
      props = _objectWithoutProperties(_ref68, _excluded64);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var ExclamationMarkTriangle = function ExclamationMarkTriangle(props) {
  var _useContext64 = useContext(PictoContext),
      optimise = _useContext64.optimise,
      refresh = _useContext64.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_QOnNU', /*#__PURE__*/React.createElement(SVGComponent$1B, props));
};

var SVGComponent$1A = function SVGComponent$1A(_ref69) {
  var _ref69$as = _ref69.as,
      Component = _ref69$as === void 0 ? "svg" : _ref69$as,
      _ref69$children = _ref69.children,
      children = _ref69$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M8 0.666504L16 15.3332H0L8 0.666504ZM7 5L7 11H9L9 5H7ZM8 14.5C8.69036 14.5 9.25 13.9404 9.25 13.25C9.25 12.5596 8.69036 12 8 12C7.30964 12 6.75 12.5596 6.75 13.25C6.75 13.9404 7.30964 14.5 8 14.5Z",
    fillRule: "evenodd"
  })) : _ref69$children,
      props = _objectWithoutProperties(_ref69, _excluded65);

  return /*#__PURE__*/React.createElement(Component, _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var ExclamationMarkTriangleBold = function ExclamationMarkTriangleBold(props) {
  var _useContext65 = useContext(PictoContext),
      optimise = _useContext65.optimise,
      refresh = _useContext65.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_KoHeE', /*#__PURE__*/React.createElement(SVGComponent$1A, props));
};

var SVGComponent$1z = function SVGComponent$1z(_ref70) {
  var _ref70$as = _ref70.as,
      Component = _ref70$as === void 0 ? "svg" : _ref70$as,
      _ref70$children = _ref70.children,
      children = _ref70$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M8,.67L0,15.33H16L8,.67Zm0,2.09L1.68,14.33H14.32L8,2.75Zm-.88,2.45v5.37h1.79V5.2h-1.79Zm.89,8.5c.62,0,1.12-.5,1.12-1.12s-.5-1.12-1.12-1.12-1.12,.5-1.12,1.12,.5,1.12,1.12,1.12Z",
    fillRule: "evenodd"
  })) : _ref70$children,
      props = _objectWithoutProperties(_ref70, _excluded66);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), children);
};

var ExclamationMarkTriangleLine = function ExclamationMarkTriangleLine(props) {
  var _useContext66 = useContext(PictoContext),
      optimise = _useContext66.optimise,
      refresh = _useContext66.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_KpYKV', /*#__PURE__*/React.createElement(SVGComponent$1z, props));
};

var SVGComponent$1y = function SVGComponent$1y(_ref71) {
  var _ref71$as = _ref71.as,
      Component = _ref71$as === void 0 ? "svg" : _ref71$as,
      _ref71$children = _ref71.children,
      children = _ref71$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M14,4H1V22H21V11h1V23H0V3H14ZM24,9H23V2.71L11.35,14.35l-.7-.7L22.29,2H16V1h8Z",
    fillRule: "evenodd"
  })) : _ref71$children,
      props = _objectWithoutProperties(_ref71, _excluded67);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var ExternalLink = function ExternalLink(props) {
  var _useContext67 = useContext(PictoContext),
      optimise = _useContext67.optimise,
      refresh = _useContext67.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z1rf3Yh', /*#__PURE__*/React.createElement(SVGComponent$1y, props));
};

var SVGComponent$1x = function SVGComponent$1x(_ref72) {
  var _ref72$as = _ref72.as,
      Component = _ref72$as === void 0 ? "svg" : _ref72$as,
      _ref72$children = _ref72.children,
      children = _ref72$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,20C7,20,2.42,15.79,0,11.58,2.42,7.47,6.94,4,12,4s9.64,3.45,12,7.56C21.77,16,17.28,20,12,20ZM1.17,11.58C2,12.91,6.19,19,12,19c6.31,0,10.11-6.1,10.85-7.4C22.09,10.4,18.25,5,12,5S2,10.35,1.17,11.58ZM12,7a5,5,0,1,1-5,5A5,5,0,0,1,12,7Zm0,1a4,4,0,1,1-4,4A4,4,0,0,1,12,8Z",
    fillRule: "evenodd"
  })) : _ref72$children,
      props = _objectWithoutProperties(_ref72, _excluded68);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Eye = function Eye(props) {
  var _useContext68 = useContext(PictoContext),
      optimise = _useContext68.optimise,
      refresh = _useContext68.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_iQb', /*#__PURE__*/React.createElement(SVGComponent$1x, props));
};

var SVGComponent$1w = function SVGComponent$1w(_ref73) {
  var _ref73$as = _ref73.as,
      Component = _ref73$as === void 0 ? "svg" : _ref73$as,
      _ref73$children = _ref73.children,
      children = _ref73$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M23.05,15a8,8,0,0,1,1.26,16V25.38h1.87l.36-2.33H24.31V21.54a1.17,1.17,0,0,1,1.3-1.26h1v-2a12.14,12.14,0,0,0-1.8-.16h0a2.84,2.84,0,0,0-3,3.14v1.77h-2v2.33h2V31a8,8,0,0,1,1.26-16Z"
  })) : _ref73$children,
      props = _objectWithoutProperties(_ref73, _excluded69);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "46",
    viewBox: "0 0 46 46",
    width: "46",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Facebook = function Facebook(props) {
  var _useContext69 = useContext(PictoContext),
      optimise = _useContext69.optimise,
      refresh = _useContext69.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_EyY0U', /*#__PURE__*/React.createElement(SVGComponent$1w, props));
};

var SVGComponent$1v = function SVGComponent$1v(_ref74) {
  var _ref74$as = _ref74.as,
      Component = _ref74$as === void 0 ? "svg" : _ref74$as,
      _ref74$children = _ref74.children,
      children = _ref74$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M20.1,12.05a8.05,8.05,0,0,1-6.79,8V14.38h1.87l.36-2.33H13.31V10.54a1.16,1.16,0,0,1,1.31-1.26h1v-2a12.14,12.14,0,0,0-1.8-.16,2.84,2.84,0,0,0-3,3.14v1.77h-2v2.33h2V20a8,8,0,1,1,9.31-7.95Z"
  })) : _ref74$children,
      props = _objectWithoutProperties(_ref74, _excluded70);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var FacebookSmall = function FacebookSmall(props) {
  var _useContext70 = useContext(PictoContext),
      optimise = _useContext70.optimise,
      refresh = _useContext70.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z2eebHf', /*#__PURE__*/React.createElement(SVGComponent$1v, props));
};

var SVGComponent$1u = function SVGComponent$1u(_ref75) {
  var _ref75$as = _ref75.as,
      Component = _ref75$as === void 0 ? "svg" : _ref75$as,
      _ref75$children = _ref75.children,
      children = _ref75$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M22,24H2V0H16l6,6ZM15,1H3V23H21V7H15Zm3,15v1H6V16Zm0-3v1H6V13Zm0-3v1H6V10ZM16,6h4.59L16,1.41Z"
  })) : _ref75$children,
      props = _objectWithoutProperties(_ref75, _excluded71);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var File = function File(props) {
  var _useContext71 = useContext(PictoContext),
      optimise = _useContext71.optimise,
      refresh = _useContext71.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_9Dt7', /*#__PURE__*/React.createElement(SVGComponent$1u, props));
};

var SVGComponent$1t = function SVGComponent$1t(_ref76) {
  var _ref76$as = _ref76.as,
      Component = _ref76$as === void 0 ? "svg" : _ref76$as,
      _ref76$children = _ref76.children,
      children = _ref76$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 11.0309L11.0079 17.6539L7.33594 13.7229L8.03694 13.0399L11.0449 16.2239L16.2719 10.3459L16.9999 11.0309Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 24H22V6L16 0H2V24ZM3 1H15V7H21V23H3V1ZM20.586 6H16V1.414L20.586 6Z"
  })) : _ref76$children,
      props = _objectWithoutProperties(_ref76, _excluded72);

  return /*#__PURE__*/React.createElement(Component, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var FileCheck = function FileCheck(props) {
  var _useContext72 = useContext(PictoContext),
      optimise = _useContext72.optimise,
      refresh = _useContext72.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_LLbJ6', /*#__PURE__*/React.createElement(SVGComponent$1t, props));
};

var SVGComponent$1s = function SVGComponent$1s(_ref77) {
  var _ref77$as = _ref77.as,
      Component = _ref77$as === void 0 ? "svg" : _ref77$as,
      _ref77$children = _ref77.children,
      children = _ref77$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M22,24H4V2H16l6,6ZM15,3H5V23H21V9H15ZM14,1H3V22H2V0H14Zm2,7h4.59L16,3.41Z",
    fillRule: "evenodd"
  })) : _ref77$children,
      props = _objectWithoutProperties(_ref77, _excluded73);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var Files = function Files(props) {
  var _useContext73 = useContext(PictoContext),
      optimise = _useContext73.optimise,
      refresh = _useContext73.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_4T3Or', /*#__PURE__*/React.createElement(SVGComponent$1s, props));
};

var SVGComponent$1r = function SVGComponent$1r(_ref78) {
  var _ref78$as = _ref78.as,
      Component = _ref78$as === void 0 ? "svg" : _ref78$as,
      _ref78$children = _ref78.children,
      children = _ref78$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M23,0,14,14.15v7.73L10,24V14.15L1,0ZM2.75,1,11,13.85v8.49l2-1.07V13.85L21.23,1Z"
  })) : _ref78$children,
      props = _objectWithoutProperties(_ref78, _excluded74);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Filter = function Filter(props) {
  var _useContext74 = useContext(PictoContext),
      optimise = _useContext74.optimise,
      refresh = _useContext74.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_2tY0pM', /*#__PURE__*/React.createElement(SVGComponent$1r, props));
};

var SVGComponent$1q = function SVGComponent$1q(_ref79) {
  var _ref79$as = _ref79.as,
      Component = _ref79$as === void 0 ? "svg" : _ref79$as,
      _ref79$children = _ref79.children,
      children = _ref79$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12.15,7.94H13V16H12V9l-1.81,1.17v-1ZM24,12A12,12,0,1,1,12,0,12,12,0,0,1,24,12Zm-1,0A11,11,0,1,0,12,23,11,11,0,0,0,23,12Z",
    fillRule: "evenodd"
  })) : _ref79$children,
      props = _objectWithoutProperties(_ref79, _excluded75);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var FirstCircle = function FirstCircle(props) {
  var _useContext75 = useContext(PictoContext),
      optimise = _useContext75.optimise,
      refresh = _useContext75.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_c1KQd', /*#__PURE__*/React.createElement(SVGComponent$1q, props));
};

var SVGComponent$1p = function SVGComponent$1p(_ref80) {
  var _ref80$as = _ref80.as,
      Component = _ref80$as === void 0 ? "svg" : _ref80$as,
      _ref80$children = _ref80.children,
      children = _ref80$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M22,1H2V24H3V15H22L16,7.55ZM19.91,14H3V2H19.73L14.68,7.51Z",
    fillRule: "evenodd"
  })) : _ref80$children,
      props = _objectWithoutProperties(_ref80, _excluded76);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var Flag = function Flag(props) {
  var _useContext76 = useContext(PictoContext),
      optimise = _useContext76.optimise,
      refresh = _useContext76.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_9E9O', /*#__PURE__*/React.createElement(SVGComponent$1p, props));
};

var SVGComponent$1o = function SVGComponent$1o(_ref81) {
  var _ref81$as = _ref81.as,
      Component = _ref81$as === void 0 ? "svg" : _ref81$as,
      _ref81$children = _ref81.children,
      children = _ref81$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M11,5H24V22H0V2H8ZM1,3V21H23V6H10.59l-3-3Z",
    fillRule: "evenodd"
  })) : _ref81$children,
      props = _objectWithoutProperties(_ref81, _excluded77);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var Folder = function Folder(props) {
  var _useContext77 = useContext(PictoContext),
      optimise = _useContext77.optimise,
      refresh = _useContext77.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_2unlqQ', /*#__PURE__*/React.createElement(SVGComponent$1o, props));
};

var SVGComponent$1n = function SVGComponent$1n(_ref82) {
  var _ref82$as = _ref82.as,
      Component = _ref82$as === void 0 ? "svg" : _ref82$as,
      _ref82$children = _ref82.children,
      children = _ref82$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M0,2H8l3,3H21V9h3L20,22H0Zm22.65,8H4.74L1.35,21H19.26ZM20,9V6H10.59l-3-3H1V18.75L4,9Z"
  })) : _ref82$children,
      props = _objectWithoutProperties(_ref82, _excluded78);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var FolderOpen = function FolderOpen(props) {
  var _useContext78 = useContext(PictoContext),
      optimise = _useContext78.optimise,
      refresh = _useContext78.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_1n9Mxa', /*#__PURE__*/React.createElement(SVGComponent$1n, props));
};

var SVGComponent$1m = function SVGComponent$1m(_ref83) {
  var _ref83$as = _ref83.as,
      Component = _ref83$as === void 0 ? "svg" : _ref83$as,
      _ref83$children = _ref83.children,
      children = _ref83$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M13.85,7.94H12.43l-3.56,5.6v.82h4.05V16h.93V14.36h1v-.83h-1Zm-.93,5.59H9.82l3.07-4.85h0ZM12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,23A11,11,0,1,1,23,12,11,11,0,0,1,12,23Z",
    fillRule: "evenodd"
  })) : _ref83$children,
      props = _objectWithoutProperties(_ref83, _excluded79);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var FourCircle = function FourCircle(props) {
  var _useContext79 = useContext(PictoContext),
      optimise = _useContext79.optimise,
      refresh = _useContext79.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z25Oev0', /*#__PURE__*/React.createElement(SVGComponent$1m, props));
};

var SVGComponent$1l = function SVGComponent$1l(_ref84) {
  var _ref84$as = _ref84.as,
      Component = _ref84$as === void 0 ? "svg" : _ref84$as,
      _ref84$children = _ref84.children,
      children = _ref84$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12.1,0A12,12,0,1,1,.1,12a12,12,0,0,1,12-12Zm3.7,16H8.4c.6,4.3,2.2,7,3.7,7S15.2,20.3,15.8,16Zm6.6,0H16.9a13.46,13.46,0,0,1-2.5,6.8A11.43,11.43,0,0,0,22.4,16Zm-15,0H1.9a11.06,11.06,0,0,0,8,6.8A13.46,13.46,0,0,1,7.4,16ZM7.3,9H1.5a11.83,11.83,0,0,0,0,6H7.2A40.69,40.69,0,0,1,7.3,9ZM16,9H8.3a30,30,0,0,0,0,6H16A30,30,0,0,0,16,9Zm6.7,0H17a27.39,27.39,0,0,1,0,6h5.7A11.83,11.83,0,0,0,22.7,9ZM9.9,1.2A11.06,11.06,0,0,0,1.9,8H7.4A13.46,13.46,0,0,1,9.9,1.2ZM15.8,8c-.6-4.3-2.2-7-3.7-7S9,3.7,8.4,8ZM14.4,1.2A14.51,14.51,0,0,1,16.8,8h5.5A11.08,11.08,0,0,0,14.4,1.2Z"
  })) : _ref84$children,
      props = _objectWithoutProperties(_ref84, _excluded80);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Globe = function Globe(props) {
  var _useContext80 = useContext(PictoContext),
      optimise = _useContext80.optimise,
      refresh = _useContext80.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_4XwLL', /*#__PURE__*/React.createElement(SVGComponent$1l, props));
};

var SVGComponent$1k = function SVGComponent$1k(_ref85) {
  var _ref85$as = _ref85.as,
      Component = _ref85$as === void 0 ? "svg" : _ref85$as,
      _ref85$children = _ref85.children,
      children = _ref85$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M22,9.7l-2,1V18c-1,2-5.6,3-8.5,3C8.3,21,4.1,20,3,18V10.2L0,8.3,12,3,23,9.2V18l1,3H21l1-3ZM4,10.8v6.9C5,19,8.2,20,11.5,20c2.9,0,6.6-1,7.5-2.3V11.2l-7.9,4ZM2.1,8.5l9,5.7,9.8-5L12,4.1Z"
  })) : _ref85$children,
      props = _objectWithoutProperties(_ref85, _excluded81);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var GraduationCap = function GraduationCap(props) {
  var _useContext81 = useContext(PictoContext),
      optimise = _useContext81.optimise,
      refresh = _useContext81.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_1bVjwk', /*#__PURE__*/React.createElement(SVGComponent$1k, props));
};

var SVGComponent$1j = function SVGComponent$1j(_ref86) {
  var _ref86$as = _ref86.as,
      Component = _ref86$as === void 0 ? "svg" : _ref86$as,
      _ref86$children = _ref86.children,
      children = _ref86$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M10.63,8.3H10v-1h.5c0-.16,0-.33,0-.5H10v-1h.68a4.09,4.09,0,0,1,.46-1.08A3.17,3.17,0,0,1,14,3.3a3.16,3.16,0,0,1,2.15.82A2.37,2.37,0,0,1,17,5.8H16a1.45,1.45,0,0,0-.52-.94A2.2,2.2,0,0,0,14,4.3a2.17,2.17,0,0,0-2,1,3,3,0,0,0-.26.54H14.5v1h-3c0,.17,0,.34,0,.5H14v1H11.68a2.45,2.45,0,0,0,.44.73A2.42,2.42,0,0,0,14,9.8a1.92,1.92,0,0,0,2-1.12l1,.24a2.92,2.92,0,0,1-3,1.88,3.37,3.37,0,0,1-2.62-1.11A3.43,3.43,0,0,1,10.63,8.3ZM7,7a7,7,0,1,1,7,7A7,7,0,0,1,7,7ZM8,7a6,6,0,1,0,6-6A6,6,0,0,0,8,7ZM22,17.14a1.87,1.87,0,0,1-.63,1.36C20,19.78,19,20.73,18,21.57l-.21.2c-.48.42-.91.81-1.33,1.2A3.46,3.46,0,0,1,14,24a4.53,4.53,0,0,1-1.3-.2A26.72,26.72,0,0,0,7,22.67V24H2V15H7v1.73a17.51,17.51,0,0,0,1.77-.68,4.61,4.61,0,0,1,1.88-.42,8.57,8.57,0,0,1,2.93.72q.6.22,1.38.48a1.72,1.72,0,0,1,1.17,1.31L19,15.94l.09-.07a1.92,1.92,0,0,1,1.2-.43A1.74,1.74,0,0,1,22,17.14ZM6,16H3v7H6Zm13.69.65S16.73,19,16,19.5a1.92,1.92,0,0,1-1.15.52A1.55,1.55,0,0,1,14.5,20l-.19,0c-.68-.16-1.77-.41-2.56-.66a.45.45,0,1,1,.27-.86c.44.1,1.59.36,2.2.52,1,.29,1.27-.86.42-1.15l-.57-.2-1.32-.46A4.29,4.29,0,0,0,9.16,17,16.15,16.15,0,0,1,7,17.78v3.88a29.74,29.74,0,0,1,6,1.15,2.63,2.63,0,0,0,2.78-.58l1.56-1.41c.93-.82,2-1.78,3.37-3.05C21.53,17,20.53,16,19.69,16.65Z",
    fillRule: "evenodd"
  })) : _ref86$children,
      props = _objectWithoutProperties(_ref86, _excluded82);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var HandCoin = function HandCoin(props) {
  var _useContext82 = useContext(PictoContext),
      optimise = _useContext82.optimise,
      refresh = _useContext82.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_4Iz5Q', /*#__PURE__*/React.createElement(SVGComponent$1j, props));
};

var SVGComponent$1i = function SVGComponent$1i(_ref87) {
  var _ref87$as = _ref87.as,
      Component = _ref87$as === void 0 ? "svg" : _ref87$as,
      _ref87$children = _ref87.children,
      children = _ref87$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,21.59C6.37,16.05,1,11.3,1,7.19A5.06,5.06,0,0,1,6.28,2c1.31,0,4.15.5,5.72,4.46C13.59,2.49,16.46,2,17.73,2A5,5,0,0,1,23,7.19C23,11.26,17.86,15.82,12,21.59ZM17.73,1A6.53,6.53,0,0,0,12,4.25,6.51,6.51,0,0,0,6.28,1,6,6,0,0,0,0,7.19C0,11.85,5.57,16.62,12,23c6.43-6.38,12-11.15,12-15.81A6,6,0,0,0,17.73,1Z"
  })) : _ref87$children,
      props = _objectWithoutProperties(_ref87, _excluded83);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Heart = function Heart(props) {
  var _useContext83 = useContext(PictoContext),
      optimise = _useContext83.optimise,
      refresh = _useContext83.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_51CrD', /*#__PURE__*/React.createElement(SVGComponent$1i, props));
};

var SVGComponent$1h = function SVGComponent$1h(_ref88) {
  var _ref88$as = _ref88.as,
      Component = _ref88$as === void 0 ? "svg" : _ref88$as,
      _ref88$children = _ref88.children,
      children = _ref88$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M17.73,1A6.53,6.53,0,0,0,12,4.25,6.51,6.51,0,0,0,6.28,1,6,6,0,0,0,0,7.19C0,11.85,5.57,16.62,12,23c6.43-6.38,12-11.15,12-15.81A6,6,0,0,0,17.73,1Z",
    fillRule: "evenodd"
  })) : _ref88$children,
      props = _objectWithoutProperties(_ref88, _excluded84);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var HeartPlain = function HeartPlain(props) {
  var _useContext84 = useContext(PictoContext),
      optimise = _useContext84.optimise,
      refresh = _useContext84.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_ZrNxFK', /*#__PURE__*/React.createElement(SVGComponent$1h, props));
};

var SVGComponent$1g = function SVGComponent$1g(_ref89) {
  var _ref89$as = _ref89.as,
      Component = _ref89$as === void 0 ? "svg" : _ref89$as,
      _ref89$children = _ref89.children,
      children = _ref89$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M19.1,24H5.91A2,2,0,0,1,4,22a2,2,0,0,1,1.31-1.88c-.56-3.18,1.63-5.65,3.27-7.38.84-.89,1.64-1.73,1.63-2.28a.73.73,0,0,0-.63-.62c-.71,0-1.85,1.29-3.21,1.29A2.57,2.57,0,0,1,4,8.57a1.79,1.79,0,0,1,.91-1.81A3.79,3.79,0,0,0,6.85,4.38a2.47,2.47,0,0,1,2.27-2c1.14,0,1.75.48,1.4-.54A6.13,6.13,0,0,0,9.35,0c6,0,10.71,4.18,10.71,9.55,0,5.59-3.21,7.56-.89,10.46A2,2,0,0,1,21,22,2,2,0,0,1,19.1,24ZM6.25,21H5.91A1,1,0,0,0,5,22a1,1,0,0,0,.93,1H19.1a1,1,0,1,0-.17-2ZM18.9,8a9.1,9.1,0,0,0-7.62-6.85c1.21,2.28-.51,2.49-1.52,2.31-1.48-.26-1.64.38-2,1.29a4.77,4.77,0,0,1-2.4,2.91C4.64,8,5.11,9.78,6,10.07A2.51,2.51,0,0,0,7.93,9.5a3.26,3.26,0,0,1,1.65-.66,1.71,1.71,0,0,1,1.61,1.6c0,1-.83,1.86-1.91,3C6.37,16.51,6,18.1,6.31,20H18c-.95-1.59-.72-2.95,0-5H16.6a.5.5,0,0,1,0-1h1.69c.11-.32.21-.65.31-1H17.21a.5.5,0,0,1,0-1h1.62A10,10,0,0,0,19,11H17.6a.5.5,0,0,1,0-1h1.47V9.55a5.21,5.21,0,0,0,0-.55H17.38a.5.5,0,0,1,0-1ZM9.78,6.9A1.38,1.38,0,0,1,8.37,5.56a1.42,1.42,0,0,1,2.83,0A1.38,1.38,0,0,1,9.78,6.9Zm0-1.68a.4.4,0,0,0-.43.34.45.45,0,0,0,.87,0A.4.4,0,0,0,9.78,5.22Z",
    fillRule: "evenodd"
  })) : _ref89$children,
      props = _objectWithoutProperties(_ref89, _excluded85);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var HorseChase = function HorseChase(props) {
  var _useContext85 = useContext(PictoContext),
      optimise = _useContext85.optimise,
      refresh = _useContext85.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z1uLKT0', /*#__PURE__*/React.createElement(SVGComponent$1g, props));
};

var SVGComponent$1f = function SVGComponent$1f(_ref90) {
  var _ref90$as = _ref90.as,
      Component = _ref90$as === void 0 ? "svg" : _ref90$as,
      _ref90$children = _ref90.children,
      children = _ref90$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M22,11.41V24H2V11.41L.71,12.71,0,12,12,0,24,12l-.71.71ZM16,23h5V10.41l-9-9-9,9V23H8V14h8Zm-1-7.89H9v7.78h6Z"
  })) : _ref90$children,
      props = _objectWithoutProperties(_ref90, _excluded86);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var House = function House(props) {
  var _useContext86 = useContext(PictoContext),
      optimise = _useContext86.optimise,
      refresh = _useContext86.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_531FK', /*#__PURE__*/React.createElement(SVGComponent$1f, props));
};

var SVGComponent$1e = function SVGComponent$1e(_ref91) {
  var _ref91$as = _ref91.as,
      Component = _ref91$as === void 0 ? "svg" : _ref91$as,
      _ref91$children = _ref91.children,
      children = _ref91$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M20.27,14.69l.73.69L18,18.5l-2-1.78.66-.75L18,17.12Zm3.64,8.52-.82.58-2.21-3.1a5,5,0,0,1-2.57.71H0V8.65L9,.32l9,8.33v2.76h.31a5,5,0,0,1,3.37,8.69ZM10.5,15.5h-3v4.9h3Zm4.81,4.9A5,5,0,0,1,17,11.57V9.09L9,1.68,1,9.09V20.4H6.5V14.5h5v5.9Zm7-4a4,4,0,1,0-4,4A4,4,0,0,0,22.31,16.4Z"
  })) : _ref91$children,
      props = _objectWithoutProperties(_ref91, _excluded87);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var HouseMagnifier = function HouseMagnifier(props) {
  var _useContext87 = useContext(PictoContext),
      optimise = _useContext87.optimise,
      refresh = _useContext87.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z1pRCUl', /*#__PURE__*/React.createElement(SVGComponent$1e, props));
};

var SVGComponent$1d = function SVGComponent$1d(_ref92) {
  var _ref92$as = _ref92.as,
      Component = _ref92$as === void 0 ? "svg" : _ref92$as,
      _ref92$children = _ref92.children,
      children = _ref92$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Zm0,1A11,11,0,1,1,1,12,11,11,0,0,1,12,1Zm.5,17h-1V9h1ZM12,6a.85.85,0,1,1-.85.84A.85.85,0,0,1,12,6Z",
    fillRule: "evenodd"
  })) : _ref92$children,
      props = _objectWithoutProperties(_ref92, _excluded88);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var InfoCircle = function InfoCircle(props) {
  var _useContext88 = useContext(PictoContext),
      optimise = _useContext88.optimise,
      refresh = _useContext88.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_P93Av', /*#__PURE__*/React.createElement(SVGComponent$1d, props));
};

var SVGComponent$1c = function SVGComponent$1c(_ref93) {
  var _ref93$as = _ref93.as,
      Component = _ref93$as === void 0 ? "svg" : _ref93$as,
      _ref93$children = _ref93.children,
      children = _ref93$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M8,16c4.42,0,8-3.58,8-8S12.42,0,8,0,0,3.58,0,8,3.58,16,8,16Zm.67-4h-1.33V6.67h1.33v5.33Zm-.67-8.17c.46,0,.83,.37,.83,.83s-.37,.83-.83,.83-.83-.37-.83-.83,.37-.83,.83-.83Z"
  })) : _ref93$children,
      props = _objectWithoutProperties(_ref93, _excluded89);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "16",
    viewBox: "0 0 16 16",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var InfoCircleBold = function InfoCircleBold(props) {
  var _useContext89 = useContext(PictoContext),
      optimise = _useContext89.optimise,
      refresh = _useContext89.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z1oWiq2', /*#__PURE__*/React.createElement(SVGComponent$1c, props));
};

var SVGComponent$1b = function SVGComponent$1b(_ref94) {
  var _ref94$as = _ref94.as,
      Component = _ref94$as === void 0 ? "svg" : _ref94$as,
      _ref94$children = _ref94.children,
      children = _ref94$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M8,15c3.87,0,7-3.13,7-7S11.87,1,8,1,1,4.13,1,8s3.13,7,7,7Zm8-7c0,4.42-3.58,8-8,8S0,12.42,0,8,3.58,0,8,0s8,3.58,8,8Zm-8.67,4h1.33V6.67h-1.33v5.33Zm1.5-7.33c0-.46-.37-.83-.83-.83s-.83,.37-.83,.83,.37,.83,.83,.83,.83-.37,.83-.83Z"
  })) : _ref94$children,
      props = _objectWithoutProperties(_ref94, _excluded90);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), children);
};

var InfoCircleLine = function InfoCircleLine(props) {
  var _useContext90 = useContext(PictoContext),
      optimise = _useContext90.optimise,
      refresh = _useContext90.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z1oV0SK', /*#__PURE__*/React.createElement(SVGComponent$1b, props));
};

var SVGComponent$1a = function SVGComponent$1a(_ref95) {
  var _ref95$as = _ref95.as,
      Component = _ref95$as === void 0 ? "svg" : _ref95$as,
      _ref95$children = _ref95.children,
      children = _ref95$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M23,16.44c2.14,0,2.39,0,3.23,0a4.09,4.09,0,0,1,1.49.28,2.56,2.56,0,0,1,1.51,1.51,4.32,4.32,0,0,1,.28,1.49c0,.84,0,1.09,0,3.23s0,2.39,0,3.23a4,4,0,0,1-.28,1.49,2.42,2.42,0,0,1-.59.92,2.57,2.57,0,0,1-.92.6,4.39,4.39,0,0,1-1.49.27c-.84,0-1.09,0-3.23,0s-2.39,0-3.23,0a4.28,4.28,0,0,1-1.49-.27,2.67,2.67,0,0,1-1.52-1.52,4.28,4.28,0,0,1-.27-1.49c0-.84,0-1.09,0-3.23s0-2.39,0-3.23a4.39,4.39,0,0,1,.27-1.49,2.57,2.57,0,0,1,.6-.92,2.42,2.42,0,0,1,.92-.59,4.21,4.21,0,0,1,1.49-.28C20.61,16.45,20.86,16.44,23,16.44ZM23,15c-2.17,0-2.45,0-3.3.05a5.85,5.85,0,0,0-1.94.37,3.94,3.94,0,0,0-1.42.92,4.17,4.17,0,0,0-.92,1.42,5.85,5.85,0,0,0-.37,1.94c0,.85-.05,1.13-.05,3.3s0,2.44.05,3.3a5.85,5.85,0,0,0,.37,1.94,3.94,3.94,0,0,0,.92,1.42,4.17,4.17,0,0,0,1.42.92A5.85,5.85,0,0,0,19.7,31c.86,0,1.13.05,3.3.05s2.45,0,3.3-.05a5.85,5.85,0,0,0,1.94-.37,3.86,3.86,0,0,0,1.42-.92,4,4,0,0,0,.92-1.42A5.82,5.82,0,0,0,31,26.3c0-.86,0-1.13,0-3.3s0-2.45,0-3.3a5.82,5.82,0,0,0-.38-1.94,4,4,0,0,0-2.34-2.34A5.77,5.77,0,0,0,26.3,15C25.44,15,25.17,15,23,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,18.89A4.11,4.11,0,1,0,27.11,23,4.11,4.11,0,0,0,23,18.89Zm0,6.78A2.67,2.67,0,1,1,25.67,23,2.68,2.68,0,0,1,23,25.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.27,19.69a1,1,0,1,0-1-1A1,1,0,0,0,27.27,19.69Z"
  })) : _ref95$children,
      props = _objectWithoutProperties(_ref95, _excluded91);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "46",
    viewBox: "0 0 46 46",
    width: "46",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Instagram = function Instagram(props) {
  var _useContext91 = useContext(PictoContext),
      optimise = _useContext91.optimise,
      refresh = _useContext91.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_2oO7Uf', /*#__PURE__*/React.createElement(SVGComponent$1a, props));
};

var SVGComponent$19 = function SVGComponent$19(_ref96) {
  var _ref96$as = _ref96.as,
      Component = _ref96$as === void 0 ? "svg" : _ref96$as,
      _ref96$children = _ref96.children,
      children = _ref96$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,5.44c2.14,0,2.39,0,3.23.05.78.03,1.2.17,1.49.28.37.15.64.32.92.6s.45.55.6.92c.11.28.24.7.28,1.49.04.84.05,1.1.05,3.23s0,2.39-.05,3.23c-.03.78-.17,1.2-.28,1.49-.15.37-.32.64-.6.92s-.55.45-.92.6c-.28.11-.7.24-1.49.28-.84.04-1.1.05-3.23.05s-2.39,0-3.23-.05c-.78-.03-1.2-.17-1.49-.28-.37-.15-.64-.32-.92-.6s-.45-.55-.6-.92c-.11-.28-.24-.7-.28-1.49-.04-.84-.05-1.1-.05-3.23s0-2.39.05-3.23c.03-.78.17-1.2.28-1.49.15-.37.32-.64.6-.92s.55-.45.92-.6c.28-.11.7-.24,1.49-.28.84-.04,1.1-.05,3.23-.05ZM12,4c-2.17,0-2.44,0-3.3.05-.85.04-1.43.17-1.94.37-.53.2-.97.48-1.42.92-.44.44-.72.89-.92,1.42-.2.51-.33,1.09-.37,1.94-.04.85-.05,1.12-.05,3.3s0,2.44.05,3.3c.04.85.17,1.43.37,1.94.2.53.48.97.92,1.42.44.44.89.72,1.42.92.51.2,1.09.33,1.94.37.85.04,1.12.05,3.3.05s2.44,0,3.3-.05c.85-.04,1.43-.17,1.94-.37.53-.2.97-.48,1.42-.92.44-.44.72-.89.92-1.42.2-.51.33-1.09.37-1.94.04-.85.05-1.12.05-3.3s0-2.44-.05-3.3c-.04-.85-.17-1.43-.37-1.94-.2-.53-.48-.97-.92-1.42-.44-.44-.89-.72-1.42-.92-.51-.2-1.09-.33-1.94-.37-.86-.03-1.13-.04-3.3-.04ZM12,7.89c-2.27,0-4.11,1.84-4.11,4.11s1.84,4.11,4.11,4.11,4.11-1.84,4.11-4.11-1.84-4.11-4.11-4.11ZM12,14.67c-1.47,0-2.67-1.19-2.67-2.67s1.19-2.67,2.67-2.67,2.67,1.19,2.67,2.67-1.19,2.67-2.67,2.67ZM16.27,8.69c.53,0,.96-.43.96-.96s-.43-.96-.96-.96-.96.43-.96.96.43.96.96.96Z"
  })) : _ref96$children,
      props = _objectWithoutProperties(_ref96, _excluded92);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var InstagramSmall = function InstagramSmall(props) {
  var _useContext92 = useContext(PictoContext),
      optimise = _useContext92.optimise,
      refresh = _useContext92.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_oXJc5', /*#__PURE__*/React.createElement(SVGComponent$19, props));
};

var SVGComponent$18 = function SVGComponent$18(_ref97) {
  var _ref97$as = _ref97.as,
      Component = _ref97$as === void 0 ? "svg" : _ref97$as,
      _ref97$children = _ref97.children,
      children = _ref97$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M16,1A8,8,0,0,0,8,9a7.91,7.91,0,0,0,.18,1.7L0,18v5H6V21H8V19h2l3.07-2.56A7.92,7.92,0,0,0,16,17,8,8,0,0,0,16,1ZM9.64,18l3.24-2.7A7.75,7.75,0,0,0,16,16,7,7,0,1,0,9,9a8.77,8.77,0,0,0,.28,2.06L1,18.45V22H5V20H7V18Zm.17-4-.67-.74L2,19.66V21ZM20,7a2,2,0,1,0-2,2A2,2,0,0,0,20,7ZM19,7a1,1,0,1,0-1,1A1,1,0,0,0,19,7Z",
    fillRule: "evenodd"
  })) : _ref97$children,
      props = _objectWithoutProperties(_ref97, _excluded93);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Key = function Key(props) {
  var _useContext93 = useContext(PictoContext),
      optimise = _useContext93.optimise,
      refresh = _useContext93.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_keR', /*#__PURE__*/React.createElement(SVGComponent$18, props));
};

var SVGComponent$17 = function SVGComponent$17(_ref98) {
  var _ref98$as = _ref98.as,
      Component = _ref98$as === void 0 ? "svg" : _ref98$as,
      _ref98$children = _ref98.children,
      children = _ref98$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M13,9h9L8,24l3-9H2L16,0ZM4.3,14h8.09l-2,6,9.3-10H11.61l2-6Z"
  })) : _ref98$children,
      props = _objectWithoutProperties(_ref98, _excluded94);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var LightningBolt = function LightningBolt(props) {
  var _useContext94 = useContext(PictoContext),
      optimise = _useContext94.optimise,
      refresh = _useContext94.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_1W7mmN', /*#__PURE__*/React.createElement(SVGComponent$17, props));
};

var SVGComponent$16 = function SVGComponent$16(_ref99) {
  var _ref99$as = _ref99.as,
      Component = _ref99$as === void 0 ? "svg" : _ref99$as,
      _ref99$children = _ref99.children,
      children = _ref99$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M14.85,11.92a4.06,4.06,0,0,0-1-1.75,4,4,0,0,0-5.66,0l-5,5a4,4,0,0,0,5.66,5.66L12.67,17H13a5.86,5.86,0,0,0,1.19-.12L9.53,21.54a5,5,0,0,1-7.07-7.07l5-5a5,5,0,0,1,7.07,0,4.93,4.93,0,0,1,1.11,1.67Zm-5.7.15a4.1,4.1,0,0,0,1,1.76,4,4,0,0,0,5.66,0l5-5a4,4,0,1,0-5.66-5.66L11.33,7H11a5.86,5.86,0,0,0-1.19.12l4.66-4.66a5,5,0,0,1,7.07,7.07l-5,5a5,5,0,0,1-7.07,0,4.74,4.74,0,0,1-1.11-1.68Z"
  })) : _ref99$children,
      props = _objectWithoutProperties(_ref99, _excluded95);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Link = function Link(props) {
  var _useContext95 = useContext(PictoContext),
      optimise = _useContext95.optimise,
      refresh = _useContext95.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_aqwu', /*#__PURE__*/React.createElement(SVGComponent$16, props));
};

var SVGComponent$15 = function SVGComponent$15(_ref100) {
  var _ref100$as = _ref100.as,
      Component = _ref100$as === void 0 ? "svg" : _ref100$as,
      _ref100$children = _ref100.children,
      children = _ref100$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 4H7.33333C5.49267 4 4 5.49267 4 7.33333V16.6667C4 18.5073 5.49267 20 7.33333 20H16.6667C18.508 20 20 18.5073 20 16.6667V7.33333C20 5.49267 18.508 4 16.6667 4ZM9.33333 16.6667H7.33333V9.33333H9.33333V16.6667ZM8.33333 8.488C7.68933 8.488 7.16667 7.96133 7.16667 7.312C7.16667 6.66267 7.68933 6.136 8.33333 6.136C8.97733 6.136 9.5 6.66267 9.5 7.312C9.5 7.96133 8.978 8.488 8.33333 8.488ZM17.3333 16.6667H15.3333V12.9307C15.3333 10.6853 12.6667 10.8553 12.6667 12.9307V16.6667H10.6667V9.33333H12.6667V10.51C13.5973 8.786 17.3333 8.65867 17.3333 12.1607V16.6667Z"
  })) : _ref100$children,
      props = _objectWithoutProperties(_ref100, _excluded96);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var LinkedinSmall = function LinkedinSmall(props) {
  var _useContext96 = useContext(PictoContext),
      optimise = _useContext96.optimise,
      refresh = _useContext96.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z2bLQXQ', /*#__PURE__*/React.createElement(SVGComponent$15, props));
};

var SVGComponent$14 = function SVGComponent$14(_ref101) {
  var _ref101$as = _ref101.as,
      Component = _ref101$as === void 0 ? "svg" : _ref101$as,
      _ref101$children = _ref101.children,
      children = _ref101$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M6,6A6,6,0,0,1,18,6v4h3V24H3V10H6Zm14,5H4V23H20ZM7,6v4H17V6A5,5,0,0,0,7,6Z"
  })) : _ref101$children,
      props = _objectWithoutProperties(_ref101, _excluded97);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Lock = function Lock(props) {
  var _useContext97 = useContext(PictoContext),
      optimise = _useContext97.optimise,
      refresh = _useContext97.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_arYq', /*#__PURE__*/React.createElement(SVGComponent$14, props));
};

var SVGComponent$13 = function SVGComponent$13(_ref102) {
  var _ref102$as = _ref102.as,
      Component = _ref102$as === void 0 ? "svg" : _ref102$as,
      _ref102$children = _ref102.children,
      children = _ref102$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M6.6,5.4,8,7.8l.9-2.6,2.7-.6L9.3,2.9,9.5.2,7.3,1.8,4.8.7l.8,2.6L3.8,5.4ZM6.4,2.5l1,.4.9-.7V3.4l.9.7-1.1.2L7.7,5.4l-.6-1H6l.7-.9ZM21.7,7.3l1.1.8.1-1.4L24,6l-1.3-.5-.4-1.3-.9,1.1H20l.8,1.1-.4,1.3Zm.2-1.1ZM16,1.2a1,1,0,1,1,2,0,1,1,0,0,1-2,0Zm1.7,15.4,1.1.8-1.4.3L17,19l-.7-1.2H14.9l.9-1-.4-1.3,1.3.5,1.1-.8ZM23,13.2a1,1,0,1,1-1-1A.94.94,0,0,1,23,13.2ZM.9,19a2.6,2.6,0,0,0,0,3.8,2.6,2.6,0,0,0,3.8,0L19.6,8,15.8,4.2ZM4,22.1a1.63,1.63,0,0,1-2.4,0,1.82,1.82,0,0,1,0-2.4L12.2,9.1l2.4,2.4ZM15.3,10.8,12.9,8.4l2.9-2.9,2.4,2.4Z"
  })) : _ref102$children,
      props = _objectWithoutProperties(_ref102, _excluded98);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var MagicWand = function MagicWand(props) {
  var _useContext98 = useContext(PictoContext),
      optimise = _useContext98.optimise,
      refresh = _useContext98.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_ZbIpjk', /*#__PURE__*/React.createElement(SVGComponent$13, props));
};

var SVGComponent$12 = function SVGComponent$12(_ref103) {
  var _ref103$as = _ref103.as,
      Component = _ref103$as === void 0 ? "svg" : _ref103$as,
      _ref103$children = _ref103.children,
      children = _ref103$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M11.74,12.42A6.43,6.43,0,0,1,7.5,14a6.49,6.49,0,1,1,4.95-2.28l3.43,3.45-.71.71ZM13,7.5A5.5,5.5,0,1,1,7.5,2,5.5,5.5,0,0,1,13,7.5Z",
    fillRule: "evenodd"
  })) : _ref103$children,
      props = _objectWithoutProperties(_ref103, _excluded99);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), children);
};

var MagnifyingBold = function MagnifyingBold(props) {
  var _useContext99 = useContext(PictoContext),
      optimise = _useContext99.optimise,
      refresh = _useContext99.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_132rkB', /*#__PURE__*/React.createElement(SVGComponent$12, props));
};

var SVGComponent$11 = function SVGComponent$11(_ref104) {
  var _ref104$as = _ref104.as,
      Component = _ref104$as === void 0 ? "svg" : _ref104$as,
      _ref104$children = _ref104.children,
      children = _ref104$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M15.8,16.6A9.26,9.26,0,0,1,9.1,19a9.45,9.45,0,0,1-6.5-3A9.21,9.21,0,0,1,0,9.4,9.24,9.24,0,0,1,2.8,2.8,9.07,9.07,0,0,1,9.4,0a9.71,9.71,0,0,1,6.7,2.6,9.43,9.43,0,0,1,.6,13.2l7.4,7.4-.8.8ZM14.2,2.4A8.63,8.63,0,0,0,9.5,1,8.54,8.54,0,0,0,1,9.5a8.63,8.63,0,0,0,1.4,4.7,8.21,8.21,0,0,0,3.8,3.1,9.2,9.2,0,0,0,4.9.5,8.54,8.54,0,0,0,4.4-2.3,8.18,8.18,0,0,0,2.3-4.4,8.23,8.23,0,0,0-.5-4.9A8.74,8.74,0,0,0,14.2,2.4Z"
  })) : _ref104$children,
      props = _objectWithoutProperties(_ref104, _excluded100);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var MagnifyingGlassLeft = function MagnifyingGlassLeft(props) {
  var _useContext100 = useContext(PictoContext),
      optimise = _useContext100.optimise,
      refresh = _useContext100.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z2vlwxL', /*#__PURE__*/React.createElement(SVGComponent$11, props));
};

var SVGComponent$10 = function SVGComponent$10(_ref105) {
  var _ref105$as = _ref105.as,
      Component = _ref105$as === void 0 ? "svg" : _ref105$as,
      _ref105$children = _ref105.children,
      children = _ref105$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,10a2,2,0,1,1,2-2A2,2,0,0,1,12,10Zm0-5a3,3,0,1,0,3,3A3,3,0,0,0,12,5ZM5,7.6a7,7,0,0,1,14,0c0,3.46-2.56,7.55-7,14.53C7.51,15.06,5,11.06,5,7.6ZM12,0C7.8,0,4,3.4,4,7.6S7.47,16.81,12,24c4.53-7.19,8-12.2,8-16.4S16.2,0,12,0"
  })) : _ref105$children,
      props = _objectWithoutProperties(_ref105, _excluded101);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Marker = function Marker(props) {
  var _useContext101 = useContext(PictoContext),
      optimise = _useContext101.optimise,
      refresh = _useContext101.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z2mg1CL', /*#__PURE__*/React.createElement(SVGComponent$10, props));
};

var SVGComponent$$ = function SVGComponent$$(_ref106) {
  var _ref106$as = _ref106.as,
      Component = _ref106$as === void 0 ? "svg" : _ref106$as,
      _ref106$children = _ref106.children,
      children = _ref106$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7V17H5.69L15,23V1L5.69,7Zm5,9H1V8H5ZM6,8l8-5.16V21.17L6,16Zm18,4a10.8,10.8,0,0,1-3.77,8.23l-.71-.71a9.87,9.87,0,0,0,0-15l.71-.71A10.8,10.8,0,0,1,24,12Zm-4.22,0a6.86,6.86,0,0,1-2.48,5.3l-.71-.71a5.91,5.91,0,0,0,0-9.18l.71-.71A6.86,6.86,0,0,1,19.78,12Z"
  })) : _ref106$children,
      props = _objectWithoutProperties(_ref106, _excluded102);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var Microphone = function Microphone(props) {
  var _useContext102 = useContext(PictoContext),
      optimise = _useContext102.optimise,
      refresh = _useContext102.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z16cO05', /*#__PURE__*/React.createElement(SVGComponent$$, props));
};

var SVGComponent$_ = function SVGComponent$_(_ref107) {
  var _ref107$as = _ref107.as,
      Component = _ref107$as === void 0 ? "svg" : _ref107$as,
      _ref107$children = _ref107.children,
      children = _ref107$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("rect", {
    height: "2",
    x: "3",
    width: "10",
    y: "7"
  })) : _ref107$children,
      props = _objectWithoutProperties(_ref107, _excluded103);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "16",
    viewBox: "0 0 16 16",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var MinusBold = function MinusBold(props) {
  var _useContext103 = useContext(PictoContext),
      optimise = _useContext103.optimise,
      refresh = _useContext103.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z1kd9CG', /*#__PURE__*/React.createElement(SVGComponent$_, props));
};

var SVGComponent$Z = function SVGComponent$Z(_ref108) {
  var _ref108$as = _ref108.as,
      Component = _ref108$as === void 0 ? "svg" : _ref108$as,
      _ref108$children = _ref108.children,
      children = _ref108$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Zm0,1A11,11,0,1,1,1,12,11,11,0,0,1,12,1ZM5.22,11.48H18.78v1H5.22Z",
    fillRule: "evenodd"
  })) : _ref108$children,
      props = _objectWithoutProperties(_ref108, _excluded104);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var MinusCircle = function MinusCircle(props) {
  var _useContext104 = useContext(PictoContext),
      optimise = _useContext104.optimise,
      refresh = _useContext104.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_21yah4', /*#__PURE__*/React.createElement(SVGComponent$Z, props));
};

var SVGComponent$Y = function SVGComponent$Y(_ref109) {
  var _ref109$as = _ref109.as,
      Component = _ref109$as === void 0 ? "svg" : _ref109$as,
      _ref109$children = _ref109.children,
      children = _ref109$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "m13.59,6.72l3.97,3.97,1.14-1.14-1.99-1.99c4.86.36,8.69,4.41,8.69,9.36s-4.2,9.39-9.39,9.39-9.39-4.2-9.39-9.39c0-2.38.89-4.55,2.35-6.21.26-.29.54-.57.83-.83l-1.07-1.21c-.34.3-.67.63-.97.97-1.71,1.94-2.75,4.49-2.75,7.28,0,6.08,4.92,11,11,11s11-4.92,11-11-4.57-10.64-10.34-10.98l2.04-2.04-1.14-1.14-3.97,3.97Zm.15,3.97l-3.97-3.97,3.97-3.97,1.14,1.14-2.83,2.83,2.83,2.83-1.14,1.14Zm.21,2.34v7.92h-1.44v-6.25l-1.91.63v-1.16l3.18-1.15h.16Zm7.31,3.29v1.33c0,.61-.06,1.13-.18,1.56-.12.43-.3.78-.53,1.06-.23.27-.51.47-.83.6-.32.13-.68.19-1.07.19-.31,0-.61-.04-.88-.12-.27-.08-.52-.21-.73-.38-.21-.17-.4-.39-.55-.66-.15-.27-.27-.59-.35-.96-.08-.37-.12-.8-.12-1.29v-1.33c0-.61.06-1.13.18-1.55.13-.43.31-.78.54-1.05.23-.27.51-.47.83-.59.32-.13.68-.19,1.07-.19.32,0,.61.04.88.12.27.08.51.2.73.37.22.17.4.38.55.65.15.26.27.58.35.96.08.37.12.8.12,1.28Zm-1.43,1.53v-1.73c0-.3-.02-.57-.05-.79-.03-.23-.08-.42-.15-.58-.07-.16-.15-.29-.24-.39-.1-.1-.21-.18-.34-.22-.13-.05-.27-.07-.42-.07-.19,0-.36.04-.5.11-.15.07-.27.19-.37.35-.1.16-.18.37-.23.64-.05.26-.08.58-.08.96v1.73c0,.3.02.57.05.8.04.23.09.42.15.59.07.16.15.3.24.4.1.1.21.18.34.23.13.05.27.07.42.07.19,0,.36-.04.5-.11.15-.08.27-.2.37-.36.1-.17.18-.38.23-.65.05-.27.08-.59.08-.97Z"
  })) : _ref109$children,
      props = _objectWithoutProperties(_ref109, _excluded105);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, props), children);
};

var MinusTenBold = function MinusTenBold(props) {
  var _useContext105 = useContext(PictoContext),
      optimise = _useContext105.optimise,
      refresh = _useContext105.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_ZPJARB', /*#__PURE__*/React.createElement(SVGComponent$Y, props));
};

var SVGComponent$X = function SVGComponent$X(_ref110) {
  var _ref110$as = _ref110.as,
      Component = _ref110$as === void 0 ? "svg" : _ref110$as,
      _ref110$children = _ref110.children,
      children = _ref110$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M17.84,1a3.91,3.91,0,0,1,2.72,6.72L12.1,16.19A2.27,2.27,0,1,1,8.88,13l4.41-4.41L14,9.3l-3.16,3.16h0L9.44,13.88h0a1.26,1.26,0,1,0,2,1.57L19.8,7.07a3,3,0,0,0,.94-2.16,2.9,2.9,0,0,0-4.92-2.08h0L4.29,14.35h0A4.46,4.46,0,0,0,3,17.5,4.51,4.51,0,0,0,7.5,22c.65,0,1.84,0,3.52-1.67L21.29,10.06l.71.71L11.52,21.25A5.5,5.5,0,1,1,3.73,13.5L15,2.2A3.86,3.86,0,0,1,17.84,1Z"
  })) : _ref110$children,
      props = _objectWithoutProperties(_ref110, _excluded106);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Paperclip = function Paperclip(props) {
  var _useContext106 = useContext(PictoContext),
      optimise = _useContext106.optimise,
      refresh = _useContext106.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z2lTaGS', /*#__PURE__*/React.createElement(SVGComponent$X, props));
};

var SVGComponent$W = function SVGComponent$W(_ref111) {
  var _ref111$as = _ref111.as,
      Component = _ref111$as === void 0 ? "svg" : _ref111$as,
      _ref111$children = _ref111.children,
      children = _ref111$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M8.07,21.59,1,23l1.41-7.07L17.34,1,23,6.66Zm-.49-.92L3.34,16.42,2.28,21.73ZM17.34,2.41,4,15.72,8.28,20,21.59,6.66Z"
  })) : _ref111$children,
      props = _objectWithoutProperties(_ref111, _excluded107);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Pen = function Pen(props) {
  var _useContext107 = useContext(PictoContext),
      optimise = _useContext107.optimise,
      refresh = _useContext107.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_lws', /*#__PURE__*/React.createElement(SVGComponent$W, props));
};

var SVGComponent$V = function SVGComponent$V(_ref112) {
  var _ref112$as = _ref112.as,
      Component = _ref112$as === void 0 ? "svg" : _ref112$as,
      _ref112$children = _ref112.children,
      children = _ref112$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M6,10A4,4,0,1,0,2,6,4,4,0,0,0,6,10ZM6,9A3,3,0,1,0,3,6,3,3,0,0,0,6,9ZM18,22a4,4,0,1,0-4-4A4,4,0,0,0,18,22Zm0-1a3,3,0,1,0-3-3A3,3,0,0,0,18,21ZM21,3.67,20.23,3,3,20.33l.77.67Z",
    fillRule: "evenodd"
  })) : _ref112$children,
      props = _objectWithoutProperties(_ref112, _excluded108);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var Percent = function Percent(props) {
  var _useContext108 = useContext(PictoContext),
      optimise = _useContext108.optimise,
      refresh = _useContext108.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_1abKSr', /*#__PURE__*/React.createElement(SVGComponent$V, props));
};

var SVGComponent$U = function SVGComponent$U(_ref113) {
  var _ref113$as = _ref113.as,
      Component = _ref113$as === void 0 ? "svg" : _ref113$as,
      _ref113$children = _ref113.children,
      children = _ref113$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M8.26,1.29,6.7,2.06C.9,5.08,9.49,23,16,23a3.08,3.08,0,0,0,1.31-.28L18.86,22,16,16.37l-1.54.76a1.5,1.5,0,0,1-.6.13c-2.56,0-6.84-8.2-4.24-9.6l1.54-.76ZM16,24C10.33,24,3.78,12.89,3.78,6.17c0-2.42.84-4.15,2.46-5L8.62,0l3.86,7.35L10,8.55c-1.44.77,2.41,8.42,4,7.68l2.4-1.18,3.81,7.36-2.47,1.21A4,4,0,0,1,16,24Z"
  })) : _ref113$children,
      props = _objectWithoutProperties(_ref113, _excluded109);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Phone = function Phone(props) {
  var _useContext109 = useContext(PictoContext),
      optimise = _useContext109.optimise,
      refresh = _useContext109.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_5yCzy', /*#__PURE__*/React.createElement(SVGComponent$U, props));
};

var SVGComponent$T = function SVGComponent$T(_ref114) {
  var _ref114$as = _ref114.as,
      Component = _ref114$as === void 0 ? "svg" : _ref114$as,
      _ref114$children = _ref114.children,
      children = _ref114$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M24,23H4a4,4,0,0,1-4-4V3.31A3.09,3.09,0,0,1,3,1,3,3,0,0,1,6,3.31V5H24ZM23,6H6V19a2.49,2.49,0,0,0-2-1,2,2,0,0,0,0,4H23ZM5,3.32A2.17,2.17,0,0,0,3,2,2.12,2.12,0,0,0,1,3.32V19.5a3.09,3.09,0,0,1,4-2.4ZM20,19H8V9H20Zm-8-9H9v8H19V14H17v3H16V14H13v3H12Zm7,0H13v3h6Z"
  })) : _ref114$children,
      props = _objectWithoutProperties(_ref114, _excluded110);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var Plan = function Plan(props) {
  var _useContext110 = useContext(PictoContext),
      optimise = _useContext110.optimise,
      refresh = _useContext110.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_aXdH', /*#__PURE__*/React.createElement(SVGComponent$T, props));
};

var SVGComponent$S = function SVGComponent$S(_ref115) {
  var _ref115$as = _ref115.as,
      Component = _ref115$as === void 0 ? "svg" : _ref115$as,
      _ref115$children = _ref115.children,
      children = _ref115$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M10.57,21.5a.45.45,0,0,1-.2,0,.51.51,0,0,1-.3-.46V15.29L.85,12.36a.5.5,0,0,1,0-.94l22-8.88.06,0,.1,0h.14l.15.05h0l.07.06a.52.52,0,0,1,.1.11.38.38,0,0,1,.06.13.36.36,0,0,1,0,.1.61.61,0,0,1,0,.14h0l-3.83,18a.51.51,0,0,1-.3.37.49.49,0,0,1-.47-.06l-4.63-3.27-3.35,3.22A.49.49,0,0,1,10.57,21.5Zm3.93-4.41,4.34,3.06L22.17,4.49,11.35,14.86l3.14,2.22Zm-3.43-1.2v3.93l2.35-2.27Zm-8.6-4.06,8,2.53L20.78,4.44Z"
  })) : _ref115$children,
      props = _objectWithoutProperties(_ref115, _excluded111);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var Plane = function Plane(props) {
  var _useContext111 = useContext(PictoContext),
      optimise = _useContext111.optimise,
      refresh = _useContext111.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_5z5Yv', /*#__PURE__*/React.createElement(SVGComponent$S, props));
};

var SVGComponent$R = function SVGComponent$R(_ref116) {
  var _ref116$as = _ref116.as,
      Component = _ref116$as === void 0 ? "svg" : _ref116$as,
      _ref116$children = _ref116.children,
      children = _ref116$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,24A12,12,0,1,0,0,12,12,12,0,0,0,12,24ZM9.79,6.76a.67.67,0,0,0-1,.57v9.34a.67.67,0,0,0,1,.57l7.71-4.67a.66.66,0,0,0,0-1.14Z",
    fillRule: "evenodd"
  })) : _ref116$children,
      props = _objectWithoutProperties(_ref116, _excluded112);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Play = function Play(props) {
  var _useContext112 = useContext(PictoContext),
      optimise = _useContext112.optimise,
      refresh = _useContext112.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_aXdS', /*#__PURE__*/React.createElement(SVGComponent$R, props));
};

var SVGComponent$Q = function SVGComponent$Q(_ref117) {
  var _ref117$as = _ref117.as,
      Component = _ref117$as === void 0 ? "svg" : _ref117$as,
      _ref117$children = _ref117.children,
      children = _ref117$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "m7,25.98V6.1c0-.88.98-1.4,1.71-.91l14.82,9.94c.65.44.65,1.39,0,1.83l-14.82,9.94c-.73.49-1.71-.03-1.71-.91Z"
  })) : _ref117$children,
      props = _objectWithoutProperties(_ref117, _excluded113);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, props), children);
};

var PlayBold = function PlayBold(props) {
  var _useContext113 = useContext(PictoContext),
      optimise = _useContext113.optimise,
      refresh = _useContext113.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_2ijCln', /*#__PURE__*/React.createElement(SVGComponent$Q, props));
};

var SVGComponent$P = function SVGComponent$P(_ref118) {
  var _ref118$as = _ref118.as,
      Component = _ref118$as === void 0 ? "svg" : _ref118$as,
      _ref118$children = _ref118.children,
      children = _ref118$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "m9.75,23.5c0,.28.22.5.5.5h1c.28,0,.5-.22.5-.5v-6.53l9.73,6.28c.33.21.77-.02.77-.42v-13.66c0-.4-.44-.63-.77-.42l-9.73,6.28v-6.53c0-.28-.22-.5-.5-.5h-1c-.28,0-.5.22-.5.5v15Z"
  })) : _ref118$children,
      props = _objectWithoutProperties(_ref118, _excluded114);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, props), children);
};

var PlayerBeginBold = function PlayerBeginBold(props) {
  var _useContext114 = useContext(PictoContext),
      optimise = _useContext114.optimise,
      refresh = _useContext114.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_BJcrY', /*#__PURE__*/React.createElement(SVGComponent$P, props));
};

var SVGComponent$O = function SVGComponent$O(_ref119) {
  var _ref119$as = _ref119.as,
      Component = _ref119$as === void 0 ? "svg" : _ref119$as,
      _ref119$children = _ref119.children,
      children = _ref119$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "m22.25,23.5c0,.28-.22.5-.5.5h-1c-.28,0-.5-.22-.5-.5v-6.53l-9.73,6.28c-.33.21-.77-.02-.77-.42v-13.66c0-.4.44-.63.77-.42l9.73,6.28v-6.53c0-.28.22-.5.5-.5h1c.28,0,.5.22.5.5v15Z"
  })) : _ref119$children,
      props = _objectWithoutProperties(_ref119, _excluded115);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, props), children);
};

var PlayerEndBold = function PlayerEndBold(props) {
  var _useContext115 = useContext(PictoContext),
      optimise = _useContext115.optimise,
      refresh = _useContext115.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_2bbJn3', /*#__PURE__*/React.createElement(SVGComponent$O, props));
};

var SVGComponent$N = function SVGComponent$N(_ref120) {
  var _ref120$as = _ref120.as,
      Component = _ref120$as === void 0 ? "svg" : _ref120$as,
      _ref120$children = _ref120.children,
      children = _ref120$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("polygon", {
    points: "14 7 14 9 9 9 9 14 7 14 7 9 2 9 2 7 7 7 7 2 9 2 9 7 14 7"
  })) : _ref120$children,
      props = _objectWithoutProperties(_ref120, _excluded116);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "16",
    viewBox: "0 0 16 16",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var PlusBold = function PlusBold(props) {
  var _useContext116 = useContext(PictoContext),
      optimise = _useContext116.optimise,
      refresh = _useContext116.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z26UjNN', /*#__PURE__*/React.createElement(SVGComponent$N, props));
};

var SVGComponent$M = function SVGComponent$M(_ref121) {
  var _ref121$as = _ref121.as,
      Component = _ref121$as === void 0 ? "svg" : _ref121$as,
      _ref121$children = _ref121.children,
      children = _ref121$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Zm0,1A11,11,0,1,1,1,12,11,11,0,0,1,12,1Zm.52,10.44h6.26v1H12.52v6.26h-1V12.52H5.22v-1h6.26V5.22h1Z",
    fillRule: "evenodd"
  })) : _ref121$children,
      props = _objectWithoutProperties(_ref121, _excluded117);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var PlusCircle = function PlusCircle(props) {
  var _useContext117 = useContext(PictoContext),
      optimise = _useContext117.optimise,
      refresh = _useContext117.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z22dYtQ', /*#__PURE__*/React.createElement(SVGComponent$M, props));
};

var SVGComponent$L = function SVGComponent$L(_ref122) {
  var _ref122$as = _ref122.as,
      Component = _ref122$as === void 0 ? "svg" : _ref122$as,
      _ref122$children = _ref122.children,
      children = _ref122$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "m13.94,13.03v7.92h-1.44v-6.25l-1.9.63v-1.16l3.18-1.15h.16Zm7.31,3.29v1.33c0,.61-.06,1.13-.18,1.56-.12.43-.3.78-.53,1.06-.23.27-.51.47-.83.6-.32.13-.68.19-1.07.19-.31,0-.61-.04-.88-.12-.27-.08-.52-.21-.73-.38-.21-.17-.4-.39-.55-.66-.15-.27-.27-.59-.35-.96-.08-.37-.12-.8-.12-1.29v-1.33c0-.61.06-1.13.18-1.55.13-.43.31-.78.54-1.05.23-.27.51-.47.83-.59.32-.13.68-.19,1.07-.19.32,0,.61.04.88.12.27.08.51.2.73.37.22.17.4.38.55.65.15.26.27.58.35.96.08.37.12.8.12,1.28Zm-1.43,1.53v-1.73c0-.3-.02-.57-.05-.79-.03-.23-.08-.42-.15-.58-.07-.16-.15-.29-.24-.39-.1-.1-.21-.18-.34-.22-.13-.05-.27-.07-.42-.07-.19,0-.36.04-.5.11-.15.07-.27.19-.37.35-.1.16-.18.37-.23.63-.05.26-.08.58-.08.96v1.73c0,.3.02.57.05.8.04.23.09.42.15.59.07.16.15.3.24.4.1.1.21.18.34.23.13.05.27.07.42.07.19,0,.36-.04.5-.11.15-.08.27-.2.37-.36.1-.17.18-.38.23-.65.05-.27.08-.59.08-.97Zm-1.4-11.13l-3.97,3.97-1.14-1.14,1.99-1.99c-4.86.36-8.69,4.41-8.69,9.36s4.2,9.39,9.39,9.39,9.39-4.2,9.39-9.39c0-2.38-.89-4.55-2.35-6.21-.26-.29-.54-.57-.83-.83l1.07-1.21c.34.3.67.63.97.97,1.71,1.94,2.75,4.49,2.75,7.28,0,6.08-4.92,11-11,11s-11-4.92-11-11S9.57,6.27,15.34,5.93l-2.04-2.04,1.14-1.14,3.97,3.97Zm-.15,3.97l3.97-3.97-3.97-3.97-1.14,1.14,2.83,2.83-2.83,2.83,1.14,1.14Z"
  })) : _ref122$children,
      props = _objectWithoutProperties(_ref122, _excluded118);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, props), children);
};

var PlusTenBold = function PlusTenBold(props) {
  var _useContext118 = useContext(PictoContext),
      optimise = _useContext118.optimise,
      refresh = _useContext118.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_lK2Ji', /*#__PURE__*/React.createElement(SVGComponent$L, props));
};

var SVGComponent$K = function SVGComponent$K(_ref123) {
  var _ref123$as = _ref123.as,
      Component = _ref123$as === void 0 ? "svg" : _ref123$as,
      _ref123$children = _ref123.children,
      children = _ref123$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M24,23H0V11H4V1H15.33L20,6v5h4ZM4,12H1V22H23V12H20v5H4ZM14,2H5V16H19V7H14Zm2,12H8V13h8Zm0-2H8V11h8Zm0-2H8V9h8ZM15,2.25V6h3.57Z"
  })) : _ref123$children,
      props = _objectWithoutProperties(_ref123, _excluded119);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Print = function Print(props) {
  var _useContext119 = useContext(PictoContext),
      optimise = _useContext119.optimise,
      refresh = _useContext119.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_5zU63', /*#__PURE__*/React.createElement(SVGComponent$K, props));
};

var SVGComponent$J = function SVGComponent$J(_ref124) {
  var _ref124$as = _ref124.as,
      Component = _ref124$as === void 0 ? "svg" : _ref124$as,
      _ref124$children = _ref124.children,
      children = _ref124$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M15,8c0-3.86-3.14-7-7-7S1,4.14,1,8s3.14,7,7,7,7-3.14,7-7Zm1,0C16,3.58,12.42,0,8,0S0,3.58,0,8s3.58,8,8,8,8-3.58,8-8Zm-7.45,1.86v-.49c0-.49,.21-.73,1.12-1.3,1.12-.69,1.68-1.37,1.68-2.34,0-1.58-1.48-2.74-3.4-2.74-2.16,0-3.56,1.36-3.63,3.44l2.02,.15c.06-1.09,.64-1.71,1.61-1.71,.77,0,1.25,.36,1.25,.92,0,.48-.25,.77-1.16,1.3-.98,.6-1.36,1.13-1.36,2v.76h1.88Zm.22,3.14v-2.17h-2.24v2.17h2.24Z",
    fillRule: "evenodd"
  })) : _ref124$children,
      props = _objectWithoutProperties(_ref124, _excluded120);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), children);
};

var QuestionCircleLine = function QuestionCircleLine(props) {
  var _useContext120 = useContext(PictoContext),
      optimise = _useContext120.optimise,
      refresh = _useContext120.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_zb1g7', /*#__PURE__*/React.createElement(SVGComponent$J, props));
};

var SVGComponent$I = function SVGComponent$I(_ref125) {
  var _ref125$as = _ref125.as,
      Component = _ref125$as === void 0 ? "svg" : _ref125$as,
      _ref125$children = _ref125.children,
      children = _ref125$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Zm0,1A11,11,0,1,1,1,12,11,11,0,0,1,12,1Zm.05,17a.85.85,0,1,0-.84-.84A.85.85,0,0,0,12.05,18Zm.47-2.82h-1a4,4,0,0,1,.94-2.95,23.09,23.09,0,0,0,1.95-2.05C15.13,9,14.48,7,12.14,7A2.88,2.88,0,0,0,9.21,9.51l-1-.11A3.74,3.74,0,0,1,12.11,6a3.33,3.33,0,0,1,3.62,3.22c0,1.81-1.83,2.78-2.64,3.87A3.68,3.68,0,0,0,12.52,15.18Z",
    fillRule: "evenodd"
  })) : _ref125$children,
      props = _objectWithoutProperties(_ref125, _excluded121);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var QuestionMarkCircle = function QuestionMarkCircle(props) {
  var _useContext121 = useContext(PictoContext),
      optimise = _useContext121.optimise,
      refresh = _useContext121.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_23956K', /*#__PURE__*/React.createElement(SVGComponent$I, props));
};

var SVGComponent$H = function SVGComponent$H(_ref126) {
  var _ref126$as = _ref126.as,
      Component = _ref126$as === void 0 ? "svg" : _ref126$as,
      _ref126$children = _ref126.children,
      children = _ref126$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M8,0A8,8,0,1,1,0,8,8,8,0,0,1,8,0Zm.55,9.37v.49H6.68V9.11c0-.87.38-1.4,1.36-2S9.2,6.28,9.2,5.8,8.72,4.88,8,4.88c-1,0-1.55.62-1.61,1.71l-2-.16A3.38,3.38,0,0,1,8,3c1.92,0,3.4,1.16,3.4,2.74,0,1-.56,1.66-1.68,2.34C8.76,8.65,8.55,8.88,8.55,9.37Zm.23,1.46V13H6.54V10.83Z",
    fillRule: "evenodd"
  })) : _ref126$children,
      props = _objectWithoutProperties(_ref126, _excluded122);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), children);
};

var QuestionMarkCircleBold = function QuestionMarkCircleBold(props) {
  var _useContext122 = useContext(PictoContext),
      optimise = _useContext122.optimise,
      refresh = _useContext122.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_ZN1EMW', /*#__PURE__*/React.createElement(SVGComponent$H, props));
};

var SVGComponent$G = function SVGComponent$G(_ref127) {
  var _ref127$as = _ref127.as,
      Component = _ref127$as === void 0 ? "svg" : _ref127$as,
      _ref127$children = _ref127.children,
      children = _ref127$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M15,21c5.3-1,9-4.9,9-10.6V3H14V13h4a6.6,6.6,0,0,1-4,5.8ZM1,21c5.3-1,9-4.9,9-10.6V3H0V13H4a6.6,6.6,0,0,1-4,5.8Zm.6-1.2-.2-.5A7.77,7.77,0,0,0,5,13V12H1V4H9v6.4A9.34,9.34,0,0,1,1.6,19.8Zm14,0-.2-.5A7.77,7.77,0,0,0,19.1,13V12h-4V4h8v6.4A9.52,9.52,0,0,1,15.6,19.8Z"
  })) : _ref127$children,
      props = _objectWithoutProperties(_ref127, _excluded123);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var QuoteClose = function QuoteClose(props) {
  var _useContext123 = useContext(PictoContext),
      optimise = _useContext123.optimise,
      refresh = _useContext123.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z1eti8e', /*#__PURE__*/React.createElement(SVGComponent$G, props));
};

var SVGComponent$F = function SVGComponent$F(_ref128) {
  var _ref128$as = _ref128.as,
      Component = _ref128$as === void 0 ? "svg" : _ref128$as,
      _ref128$children = _ref128.children,
      children = _ref128$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M6.61,10.69a5,5,0,0,1,3.31,1.62,4.54,4.54,0,0,1,1.41,3.38,5,5,0,0,1-1.6,3.81A5.2,5.2,0,0,1,5.94,21a5.43,5.43,0,0,1-4.29-1.88A7.52,7.52,0,0,1,0,14.06Q0,7.57,5.76,2l4.1,3A9.24,9.24,0,0,0,6.61,10.69Zm12.68,0a5,5,0,0,1,3.3,1.62A4.54,4.54,0,0,1,24,15.69a5.08,5.08,0,0,1-1.59,3.87A5.42,5.42,0,0,1,18.55,21a5.35,5.35,0,0,1-4.22-1.88,7.47,7.47,0,0,1-1.66-5.06c0-4.41,1.92-8.44,5.76-12.06l4.1,3A8.77,8.77,0,0,0,19.29,10.69Z"
  })) : _ref128$children,
      props = _objectWithoutProperties(_ref128, _excluded124);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var QuoteOpenPlain = function QuoteOpenPlain(props) {
  var _useContext124 = useContext(PictoContext),
      optimise = _useContext124.optimise,
      refresh = _useContext124.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_2qnK9W', /*#__PURE__*/React.createElement(SVGComponent$F, props));
};

var SVGComponent$E = function SVGComponent$E(_ref129) {
  var _ref129$as = _ref129.as,
      Component = _ref129$as === void 0 ? "svg" : _ref129$as,
      _ref129$children = _ref129.children,
      children = _ref129$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M16.27,5.45A4.1,4.1,0,0,1,16,4a4,4,0,1,1,.75,2.33L9.62,10.08a5,5,0,0,1,0,3.84l7.13,3.75A4,4,0,1,1,16,20a4.1,4.1,0,0,1,.27-1.45L9.14,14.8a5,5,0,1,1,0-5.6ZM20,17a3,3,0,1,1-3,3A3,3,0,0,1,20,17ZM5,8a4,4,0,1,1-4,4A4,4,0,0,1,5,8ZM20,1a3,3,0,1,1-3,3A3,3,0,0,1,20,1Z",
    fillRule: "evenodd"
  })) : _ref129$children,
      props = _objectWithoutProperties(_ref129, _excluded125);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Share = function Share(props) {
  var _useContext125 = useContext(PictoContext),
      optimise = _useContext125.optimise,
      refresh = _useContext125.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_5KLz6', /*#__PURE__*/React.createElement(SVGComponent$E, props));
};

var SVGComponent$D = function SVGComponent$D(_ref130) {
  var _ref130$as = _ref130.as,
      Component = _ref130$as === void 0 ? "svg" : _ref130$as,
      _ref130$children = _ref130.children,
      children = _ref130$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,0C8.63,2.87,6.52,3,3,3V14.53c0,4.61,3.2,5.81,9,9.47,5.8-3.66,9-4.86,9-9.47V3C17.48,3,15.37,2.87,12,0Zm0,1.29A11.5,11.5,0,0,0,20,4V14.53c0,3.9-2.64,5-8,8.29-5.38-3.35-8-4.41-8-8.29V4A11.5,11.5,0,0,0,12,1.29ZM17,9l-6,6.62L7.34,11.72,8,11l3,3.18,5.22-5.87Z"
  })) : _ref130$children,
      props = _objectWithoutProperties(_ref130, _excluded126);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var ShieldCheck = function ShieldCheck(props) {
  var _useContext126 = useContext(PictoContext),
      optimise = _useContext126.optimise,
      refresh = _useContext126.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_1zniGE', /*#__PURE__*/React.createElement(SVGComponent$D, props));
};

var SVGComponent$C = function SVGComponent$C(_ref131) {
  var _ref131$as = _ref131.as,
      Component = _ref131$as === void 0 ? "svg" : _ref131$as,
      _ref131$children = _ref131.children,
      children = _ref131$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M18,24H6a2,2,0,0,1-2-2V2A2,2,0,0,1,6,0H18a2,2,0,0,1,2,2V22A2,2,0,0,1,18,24Zm1-5.08H5V22a1,1,0,0,0,1,1H18a1,1,0,0,0,1-1Zm-7,3a1,1,0,1,1,1-1A1,1,0,0,1,12,21.92Zm7-17H5v13H19ZM18,1H6A1,1,0,0,0,5,2V3.92H19V2A1,1,0,0,0,18,1ZM13.5,2.92h-3a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5A.5.5,0,0,1,13.5,2.92Z"
  })) : _ref131$children,
      props = _objectWithoutProperties(_ref131, _excluded127);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Smartphone = function Smartphone(props) {
  var _useContext127 = useContext(PictoContext),
      optimise = _useContext127.optimise,
      refresh = _useContext127.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_eE6WD', /*#__PURE__*/React.createElement(SVGComponent$C, props));
};

var SVGComponent$B = function SVGComponent$B(_ref132) {
  var _ref132$as = _ref132.as,
      Component = _ref132$as === void 0 ? "svg" : _ref132$as,
      _ref132$children = _ref132.children,
      children = _ref132$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Zm0,1A11,11,0,1,1,1,12,11,11,0,0,1,12,1Zm0,14a7.5,7.5,0,0,1,5.12,2.22l-.67.75A6.44,6.44,0,0,0,12,16h0a6.43,6.43,0,0,0-4.4,1.91l-.67-.74A7.41,7.41,0,0,1,12,15ZM8.49,8.5a1,1,0,1,1-1,1A1,1,0,0,1,8.49,8.5Zm7,0a1,1,0,1,1-1,1A1,1,0,0,1,15.5,8.5Z",
    fillRule: "evenodd"
  })) : _ref132$children,
      props = _objectWithoutProperties(_ref132, _excluded128);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var SmileyFrown = function SmileyFrown(props) {
  var _useContext128 = useContext(PictoContext),
      optimise = _useContext128.optimise,
      refresh = _useContext128.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z1VUeoP', /*#__PURE__*/React.createElement(SVGComponent$B, props));
};

var SVGComponent$A = function SVGComponent$A(_ref133) {
  var _ref133$as = _ref133.as,
      Component = _ref133$as === void 0 ? "svg" : _ref133$as,
      _ref133$children = _ref133.children,
      children = _ref133$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Zm0,1A11,11,0,1,1,1,12,11,11,0,0,1,12,1ZM12,18.51h0a7.86,7.86,0,0,1-6.15-3.35l.79-.61a6.88,6.88,0,0,0,5.36,3h0a7,7,0,0,0,5.41-3l.79.61A8,8,0,0,1,12,18.51ZM8.49,8.5a1,1,0,1,1-1,1A1,1,0,0,1,8.49,8.5Zm7,0a1,1,0,1,1-1,1A1,1,0,0,1,15.5,8.5Z",
    fillRule: "evenodd"
  })) : _ref133$children,
      props = _objectWithoutProperties(_ref133, _excluded129);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var SmileyHappy = function SmileyHappy(props) {
  var _useContext129 = useContext(PictoContext),
      optimise = _useContext129.optimise,
      refresh = _useContext129.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z1VOjUu', /*#__PURE__*/React.createElement(SVGComponent$A, props));
};

var SVGComponent$z = function SVGComponent$z(_ref134) {
  var _ref134$as = _ref134.as,
      Component = _ref134$as === void 0 ? "svg" : _ref134$as,
      _ref134$children = _ref134.children,
      children = _ref134$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Zm0,1A11,11,0,1,1,1,12,11,11,0,0,1,12,1ZM8.49,8.5a1,1,0,1,1-1,1A1,1,0,0,1,8.49,8.5Zm7,0a1,1,0,1,1-1,1A1,1,0,0,1,15.5,8.5ZM16,15H8v1h8Z",
    fillRule: "evenodd"
  })) : _ref134$children,
      props = _objectWithoutProperties(_ref134, _excluded130);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var SmileyNeutral = function SmileyNeutral(props) {
  var _useContext130 = useContext(PictoContext),
      optimise = _useContext130.optimise,
      refresh = _useContext130.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_JpI4s', /*#__PURE__*/React.createElement(SVGComponent$z, props));
};

var SVGComponent$y = function SVGComponent$y(_ref135) {
  var _ref135$as = _ref135.as,
      Component = _ref135$as === void 0 ? "svg" : _ref135$as,
      _ref135$children = _ref135.children,
      children = _ref135$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,1C5.66,1,0,5.23,0,11a8.79,8.79,0,0,0,2.05,5.62L.05,23l7-3a19.4,19.4,0,0,0,4.86.64C19,20.64,24,16.2,24,11,24,5.2,18.3,1,12,1Zm0,1c6.07,0,11,4,11,9s-4.79,8.63-11.14,8.63A19.19,19.19,0,0,1,6.92,19L1.66,21.22l1.5-4.81A7.94,7.94,0,0,1,1,11C1,6,5.93,2,12,2Z"
  })) : _ref135$children,
      props = _objectWithoutProperties(_ref135, _excluded131);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var SpeechBubble = function SpeechBubble(props) {
  var _useContext131 = useContext(PictoContext),
      optimise = _useContext131.optimise,
      refresh = _useContext131.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z1P6s6q', /*#__PURE__*/React.createElement(SVGComponent$y, props));
};

var SVGComponent$x = function SVGComponent$x(_ref136) {
  var _ref136$as = _ref136.as,
      Component = _ref136$as === void 0 ? "svg" : _ref136$as,
      _ref136$children = _ref136.children,
      children = _ref136$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M19.3766 7.90393C19.5844 7.48472 19.9221 7.17031 21.4416 6.39738C23.3507 5.42795 24 4.70742 24 3.43668C24 2.07424 22.7792 1 21.1558 1C19.2597 1 18.0779 2.33624 18 4.0262L18.974 4.1179C19.0779 2.75546 19.8442 1.91703 21.1429 1.91703C22.2078 1.91703 22.987 2.58515 22.987 3.43668C22.987 4.32751 22.4675 4.82533 20.6623 5.76856C19.3506 6.44978 18.7792 6.869 18.4416 7.45852C18.1558 7.96943 18.0779 8.50655 18.0779 9.17467V10H23.8831V9.04367H19.1558C19.1688 8.53275 19.2208 8.19214 19.3766 7.90393Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.42863 9.8789C1.78553 10.3934 1.5 10.9626 1.5 11.3024V20.7908H0.5V8.51172H1.5V9.36393C1.59671 9.27138 1.69835 9.1825 1.80393 9.09803C2.58046 8.4768 3.66522 8.01172 4.90698 8.01172C5.78395 8.01172 6.73842 8.15501 7.48665 8.65383C7.85139 8.89699 8.15144 9.21401 8.36805 9.6106C9.04458 8.72414 10.2922 8.01172 12.1628 8.01172C13.0398 8.01172 13.9942 8.15501 14.7425 8.65383C15.5265 9.17651 16.0116 10.0405 16.0116 11.3024V20.7908H15.0116V11.3024C15.0116 10.3318 14.6596 9.80042 14.1878 9.48588C13.6802 9.1475 12.9602 9.01172 12.1628 9.01172C9.59125 9.01172 8.75581 10.516 8.75581 11.3024V20.7908H7.75581V11.3024C7.75581 10.3318 7.40376 9.80042 6.93195 9.48588C6.42437 9.1475 5.70442 9.01172 4.90698 9.01172C3.91618 9.01172 3.04744 9.38384 2.42863 9.8789Z"
  })) : _ref136$children,
      props = _objectWithoutProperties(_ref136, _excluded132);

  return /*#__PURE__*/React.createElement(Component, _extends({
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var SquareMeter = function SquareMeter(props) {
  var _useContext132 = useContext(PictoContext),
      optimise = _useContext132.optimise,
      refresh = _useContext132.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_2paMIH', /*#__PURE__*/React.createElement(SVGComponent$x, props));
};

var SVGComponent$w = function SVGComponent$w(_ref137) {
  var _ref137$as = _ref137.as,
      Component = _ref137$as === void 0 ? "svg" : _ref137$as,
      _ref137$children = _ref137.children,
      children = _ref137$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M14.44,5.69c-.95.49-1.15.6-1.26.77a1.12,1.12,0,0,0-.14.66H16V8H12.06V7.27A2,2,0,0,1,12.38,6a3.67,3.67,0,0,1,1.45-1c1-.46,1.27-.77,1.27-1.27a.89.89,0,0,0-1-.88,1.18,1.18,0,0,0-1.2,1.24L12,4a2,2,0,0,1,2.1-2A1.77,1.77,0,0,1,16,3.75C16,4.62,15.63,5.09,14.44,5.69ZM1.26,7.85V14H0V5.22H1.24v.6h0A2.89,2.89,0,0,1,3.35,5,2.81,2.81,0,0,1,5.6,6h0A3.19,3.19,0,0,1,8,5a2.7,2.7,0,0,1,3,2.59V14H9.74V7.73a1.65,1.65,0,0,0-1.8-1.66A1.7,1.7,0,0,0,6.1,7.84V14H4.89V7.73A1.66,1.66,0,0,0,3.08,6.07,1.7,1.7,0,0,0,1.26,7.85Z"
  })) : _ref137$children,
      props = _objectWithoutProperties(_ref137, _excluded133);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), children);
};

var SquareMetersBold = function SquareMetersBold(props) {
  var _useContext133 = useContext(PictoContext),
      optimise = _useContext133.optimise,
      refresh = _useContext133.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_1lUc9N', /*#__PURE__*/React.createElement(SVGComponent$w, props));
};

var SVGComponent$v = function SVGComponent$v(_ref138) {
  var _ref138$as = _ref138.as,
      Component = _ref138$as === void 0 ? "svg" : _ref138$as,
      _ref138$children = _ref138.children,
      children = _ref138$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M15.67,8.63,24,9.78l-6.07,5.88L19.42,24,12,20,4.58,24l1.48-8.34L0,9.78,8.33,8.63,12,1ZM9,9.55l-6.82.95,5,4.81L5.93,22.13,12,18.86l6.07,3.27-1.21-6.82,5-4.81L15,9.55,12,3.31Z"
  })) : _ref138$children,
      props = _objectWithoutProperties(_ref138, _excluded134);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Star = function Star(props) {
  var _useContext134 = useContext(PictoContext),
      optimise = _useContext134.optimise,
      refresh = _useContext134.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_boiV', /*#__PURE__*/React.createElement(SVGComponent$v, props));
};

var SVGComponent$u = function SVGComponent$u(_ref139) {
  var _ref139$as = _ref139.as,
      Component = _ref139$as === void 0 ? "svg" : _ref139$as,
      _ref139$children = _ref139.children,
      children = _ref139$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.668 7.626L24 8.785L17.935 14.659L19.415 23L11.999 19.003L4.583 23L6.064 14.659L0 8.785L8.331 7.626L11.999 0L15.668 7.626Z"
  })) : _ref139$children,
      props = _objectWithoutProperties(_ref139, _excluded135);

  return /*#__PURE__*/React.createElement(Component, _extends({
    width: "24",
    height: "23",
    viewBox: "0 0 24 23",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var StarFilled = function StarFilled(props) {
  var _useContext135 = useContext(PictoContext),
      optimise = _useContext135.optimise,
      refresh = _useContext135.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z136xVM', /*#__PURE__*/React.createElement(SVGComponent$u, props));
};

var SVGComponent$t = function SVGComponent$t(_ref140) {
  var _ref140$as = _ref140.as,
      Component = _ref140$as === void 0 ? "svg" : _ref140$as,
      _ref140$children = _ref140.children,
      children = _ref140$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.999 19.003L4.583 23L6.064 14.659L0 8.785L8.331 7.626L11.999 0L15.668 7.626L24 8.785L17.935 14.659L19.415 23L11.999 19.003ZM11.999 2.31V17.86L18.068 21.131L16.856 14.305L21.82 9.499L15.001 8.551L11.999 2.31Z"
  })) : _ref140$children,
      props = _objectWithoutProperties(_ref140, _excluded136);

  return /*#__PURE__*/React.createElement(Component, _extends({
    width: "24",
    height: "23",
    viewBox: "0 0 24 23",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var StarHalf = function StarHalf(props) {
  var _useContext136 = useContext(PictoContext),
      optimise = _useContext136.optimise,
      refresh = _useContext136.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_1CFnAy', /*#__PURE__*/React.createElement(SVGComponent$t, props));
};

var SVGComponent$s = function SVGComponent$s(_ref141) {
  var _ref141$as = _ref141.as,
      Component = _ref141$as === void 0 ? "svg" : _ref141$as,
      _ref141$children = _ref141.children,
      children = _ref141$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M17.52,10a.5.5,0,0,1-.15.69l-2.2,1.45a.53.53,0,0,1-.27.08.52.52,0,0,1-.42-.22.51.51,0,0,1,.14-.7l2.21-1.44A.5.5,0,0,1,17.52,10ZM11.27,7.42,12.39,5a.5.5,0,1,1,.9.42L12.18,7.84a.49.49,0,0,1-.45.29l-.21-.05A.5.5,0,0,1,11.27,7.42ZM8.65,8C10,5.38,10.14,2.93,9,.74A.49.49,0,0,1,9.41,0a.49.49,0,0,1,.44.26c1.33,2.49,1.23,5.26-.31,8.22a.51.51,0,0,1-.45.27.53.53,0,0,1-.23-.06A.5.5,0,0,1,8.65,8ZM24,13.56a.5.5,0,0,1-.67.47c-2.81-1-5.25-.83-7.27.61a.52.52,0,0,1-.29.09.49.49,0,0,1-.41-.21.5.5,0,0,1,.12-.7c2.3-1.63,5.06-1.88,8.19-.73A.48.48,0,0,1,24,13.56ZM7.52,11l2.86,7.52-2.25,1L5.38,11.92l.78-2.18Zm3.78,7.12L9.13,12.39l5,4.46ZM3,18.49l1,2.7-2.31,1Zm1.82-5.1,2.36,6.43-2.27,1L3.56,17ZM0,24l16-6.85L5.71,8ZM20.46,8.37,21,7.68l.28.84.83.31-.71.52,0,.89-.72-.51L19.8,10l.27-.84-.5-.74Zm-1.38.89-.64,2,2-.56,1.72,1.23.09-2.12L24,8.56l-2-.74-.67-2L20,7.47l-2.11,0Zm-2.17-4.2c.59,0,.92-.14,1.07-.31s.23-.65.17-1.44a.5.5,0,0,1,1-.08,3,3,0,0,1-.41,2.16A2.43,2.43,0,0,1,17,6c-.7.06-.72.25-.77.88a1.81,1.81,0,0,1-1.84,1.94c-1,.11-1.43.33-1.38,2,0,.28-.21.33-.48.33h0c-.27,0-.49,0-.5-.29-.05-1.47.19-2.66,2.27-2.89.87-.1.9-.41,1-1.07A1.67,1.67,0,0,1,16.91,5.06Zm5.26-3a.83.83,0,1,1-.82.83A.83.83,0,0,1,22.17,2Zm0,2.65a1.83,1.83,0,1,0-1.82-1.82A1.83,1.83,0,0,0,22.17,4.66ZM13.73,1a1,1,0,1,1-1,1A1,1,0,0,1,13.73,1Zm0,3a2,2,0,1,0-2-2A2,2,0,0,0,13.73,4Z"
  })) : _ref141$children,
      props = _objectWithoutProperties(_ref141, _excluded137);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Tada = function Tada(props) {
  var _useContext137 = useContext(PictoContext),
      optimise = _useContext137.optimise,
      refresh = _useContext137.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_brqe', /*#__PURE__*/React.createElement(SVGComponent$s, props));
};

var SVGComponent$r = function SVGComponent$r(_ref142) {
  var _ref142$as = _ref142.as,
      Component = _ref142$as === void 0 ? "svg" : _ref142$as,
      _ref142$children = _ref142.children,
      children = _ref142$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M14.75,13.72a2.43,2.43,0,0,1-2.66,2.45,2.81,2.81,0,0,1-2.95-2.85l.91-.15c.15,1.41.83,2.12,2,2.12a1.56,1.56,0,0,0,1.73-1.57c0-1.09-.63-1.61-1.9-1.61h-.58v-.83h.58c1,0,1.69-.57,1.69-1.3A1.37,1.37,0,0,0,12.06,8.6a1.73,1.73,0,0,0-1.81,1.56L9.36,10a2.59,2.59,0,0,1,2.7-2.26A2.22,2.22,0,0,1,14.54,9.9a1.94,1.94,0,0,1-1.24,1.71v0A2.09,2.09,0,0,1,14.75,13.72ZM24,12A12,12,0,1,1,12,0,12,12,0,0,1,24,12Zm-1,0A11,11,0,1,0,12,23,11,11,0,0,0,23,12Z",
    fillRule: "evenodd"
  })) : _ref142$children,
      props = _objectWithoutProperties(_ref142, _excluded138);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var ThreeCircle = function ThreeCircle(props) {
  var _useContext138 = useContext(PictoContext),
      optimise = _useContext138.optimise,
      refresh = _useContext138.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_2gxBlN', /*#__PURE__*/React.createElement(SVGComponent$r, props));
};

var SVGComponent$q = function SVGComponent$q(_ref143) {
  var _ref143$as = _ref143.as,
      Component = _ref143$as === void 0 ? "svg" : _ref143$as,
      _ref143$children = _ref143.children,
      children = _ref143$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M19.99,11.65c0-.16-.02-.32-.03-.48-.01-.13-.03-.26-.05-.39-.03-.2-.07-.39-.11-.59-.13-.55-.31-1.08-.55-1.59-.84-1.78-2.3-3.19-4.11-3.97-.43-.18-.86-.33-1.31-.43-.15-.03-.3-.06-.45-.09-.09-.02-.19-.03-.29-.04-.1-.01-.2-.02-.3-.03-.08,0-.16-.02-.25-.02-.18,0-.36-.02-.51-.02-.26,0-.38,0-.58.02-.13,0-.25.02-.38.04-.12.01-.24.03-.36.05-.17.03-.34.06-.51.1-.52.12-1.03.29-1.52.51-1.26.58-2.3,1.42-3.12,2.53-.58.78-1,1.63-1.27,2.57-.07.25-.13.5-.18.76-.02.12-.04.24-.06.36-.01.1-.02.21-.03.31-.01.12-.02.24-.03.37,0,.03,0,.05,0,.08-.01.2-.01.39,0,.59,0,.17.01.35.03.52.01.1.02.2.03.3.02.16.05.31.08.47.07.35.16.7.28,1.04.35,1.02.89,1.93,1.61,2.74.88.98,1.95,1.71,3.19,2.17.34.13.69.23,1.04.31.13.03.26.05.4.08.1.02.2.03.3.04.11.01.21.03.32.03.09,0,.19.02.28.02.14,0,.28.01.42.01s.28,0,.42,0c.09,0,.17-.01.26-.02.07,0,.14-.01.21-.02.12-.01.25-.03.37-.05.16-.03.32-.06.49-.09.37-.08.73-.19,1.08-.32.95-.36,1.79-.87,2.54-1.55.69-.62,1.25-1.34,1.69-2.15.32-.59.56-1.21.72-1.86.04-.18.08-.36.11-.54.03-.14.05-.29.06-.43.01-.13.03-.25.04-.38.01-.15.02-.29.02-.44,0-.16,0-.33,0-.49ZM16.33,9.39c-.05.27-.11.55-.16.82-.04.2-.08.4-.12.6,0,0,0,.01,0,.02,0,.01-.01.02-.03.02-.03,0-.05,0-.08-.01-.1-.02-.19-.03-.29-.05-.47-.1-.9-.27-1.3-.54-.15-.1-.3-.22-.43-.35-.01-.01-.02-.02-.04-.03,0,0,0,0-.01,0,0,0,0,0,0,.01,0,.02,0,.03,0,.05,0,.09,0,.18,0,.27v3.32c0,.05,0,.11,0,.16-.01.34-.08.66-.19.97-.33.88-1.06,1.61-2.04,1.89-.14.04-.29.07-.44.09-.21.03-.42.03-.63.02-.28-.02-.56-.07-.83-.17-.95-.34-1.69-1.12-1.96-2.11-.05-.17-.08-.34-.09-.51-.02-.18-.02-.36,0-.54.02-.28.08-.56.18-.83.3-.84.98-1.54,1.86-1.86.18-.07.37-.12.57-.15.16-.03.31-.04.47-.04.17,0,.35,0,.52,0,.02,0,.03,0,.05,0,0,0,.02.01.02.02,0,.02,0,.04,0,.06v1.46s0,.05,0,.07c0,0-.01.02-.02.02-.02,0-.04,0-.06,0h-.49c-.07,0-.13,0-.2.01-.17.02-.33.07-.49.15-.33.17-.65.5-.76.99-.04.16-.04.32-.02.48.05.45.32.86.71,1.09.17.1.34.16.54.19.1.01.19.02.29.01.33-.02.62-.13.88-.35.25-.21.41-.48.49-.8.02-.09.03-.19.03-.29v-3.07h0v-3.08s0-.05,0-.08c0-.01.01-.02.02-.02.02,0,.04,0,.06,0h1.47s.03,0,.05,0c.02,0,.03,0,.03.02.02.03.03.06.05.09.09.16.18.32.28.47.14.2.3.39.48.57.21.2.43.38.69.51.21.11.42.19.65.23.09.02.18.03.26.05.01,0,.02,0,.03,0,.03,0,.03.02.03.04,0,.02,0,.05-.01.07Z"
  })) : _ref143$children,
      props = _objectWithoutProperties(_ref143, _excluded139);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var TikTokSmall = function TikTokSmall(props) {
  var _useContext139 = useContext(PictoContext),
      optimise = _useContext139.optimise,
      refresh = _useContext139.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z18gf2J', /*#__PURE__*/React.createElement(SVGComponent$q, props));
};

var SVGComponent$p = function SVGComponent$p(_ref144) {
  var _ref144$as = _ref144.as,
      Component = _ref144$as === void 0 ? "svg" : _ref144$as,
      _ref144$children = _ref144.children,
      children = _ref144$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,11.29,22.29,1l.71.71L12.71,12,23,22.29l-.71.71L12,12.71,1.71,23,1,22.29,11.29,12,1,1.71,1.71,1Z"
  })) : _ref144$children,
      props = _objectWithoutProperties(_ref144, _excluded140);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Times = function Times(props) {
  var _useContext140 = useContext(PictoContext),
      optimise = _useContext140.optimise,
      refresh = _useContext140.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_5P1KP', /*#__PURE__*/React.createElement(SVGComponent$p, props));
};

var SVGComponent$o = function SVGComponent$o(_ref145) {
  var _ref145$as = _ref145.as,
      Component = _ref145$as === void 0 ? "svg" : _ref145$as,
      _ref145$children = _ref145.children,
      children = _ref145$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,12.16,9.29,8l4.17-4.2L12.16,2.5,8,6.71,3.79,2.54,2.5,3.83,6.71,8,2.54,12.21,3.83,13.5,8,9.29l4.2,4.17Z"
  })) : _ref145$children,
      props = _objectWithoutProperties(_ref145, _excluded141);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "16",
    viewBox: "0 0 16 16",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var TimesBold = function TimesBold(props) {
  var _useContext141 = useContext(PictoContext),
      optimise = _useContext141.optimise,
      refresh = _useContext141.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_2qB9uD', /*#__PURE__*/React.createElement(SVGComponent$o, props));
};

var SVGComponent$n = function SVGComponent$n(_ref146) {
  var _ref146$as = _ref146.as,
      Component = _ref146$as === void 0 ? "svg" : _ref146$as,
      _ref146$children = _ref146.children,
      children = _ref146$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Zm0,1A11,11,0,1,1,1,12,11,11,0,0,1,12,1Zm0,10.29L17.29,6l.71.71L12.71,12,18,17.29l-.71.71L12,12.71,6.71,18,6,17.29,11.29,12,6,6.71,6.71,6Z",
    fillRule: "evenodd"
  })) : _ref146$children,
      props = _objectWithoutProperties(_ref146, _excluded142);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var TimesCircle = function TimesCircle(props) {
  var _useContext142 = useContext(PictoContext),
      optimise = _useContext142.optimise,
      refresh = _useContext142.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_21rHCP', /*#__PURE__*/React.createElement(SVGComponent$n, props));
};

var SVGComponent$m = function SVGComponent$m(_ref147) {
  var _ref147$as = _ref147.as,
      Component = _ref147$as === void 0 ? "svg" : _ref147$as,
      _ref147$children = _ref147.children,
      children = _ref147$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    className: "fe888163-7f93-4aef-8e29-c21bf087d597",
    d: "M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm3.06,12L8,8.94,5,12,4,11.06,7.06,8,4,5,4.94,4,8,7.06,11,4l.94.94L8.94,8,12,11Z",
    fillRule: "evenodd"
  })) : _ref147$children,
      props = _objectWithoutProperties(_ref147, _excluded143);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), children);
};

var TimesCircleBold = function TimesCircleBold(props) {
  var _useContext143 = useContext(PictoContext),
      optimise = _useContext143.optimise,
      refresh = _useContext143.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_ZYoFYk', /*#__PURE__*/React.createElement(SVGComponent$m, props));
};

var SVGComponent$l = function SVGComponent$l(_ref148) {
  var _ref148$as = _ref148.as,
      Component = _ref148$as === void 0 ? "svg" : _ref148$as,
      _ref148$children = _ref148.children,
      children = _ref148$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M15,8c0-3.86-3.14-7-7-7S1,4.14,1,8s3.14,7,7,7,7-3.14,7-7Zm1,0C16,3.58,12.42,0,8,0S0,3.58,0,8s3.58,8,8,8,8-3.58,8-8Zm-4,3.03l-3.06-3.03,3.03-3.06-.94-.94-3.03,3.06-3.06-3.03-.94,.94,3.06,3.03-3.03,3.06,.94,.94,3.04-3.06,3.06,3.03,.94-.94Z",
    fillRule: "evenodd"
  })) : _ref148$children,
      props = _objectWithoutProperties(_ref148, _excluded144);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), children);
};

var TimesCircleLine = function TimesCircleLine(props) {
  var _useContext144 = useContext(PictoContext),
      optimise = _useContext144.optimise,
      refresh = _useContext144.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_ZYnos3', /*#__PURE__*/React.createElement(SVGComponent$l, props));
};

var SVGComponent$k = function SVGComponent$k(_ref149) {
  var _ref149$as = _ref149.as,
      Component = _ref149$as === void 0 ? "svg" : _ref149$as,
      _ref149$children = _ref149.children,
      children = _ref149$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M15.55,14.7a3,3,0,0,0,3.8,1.87h0a3,3,0,0,0,1.86-3.8c-.19-.55-.43-1.14-.7-1.76h-6A35.33,35.33,0,0,0,15.55,14.7Zm2.27-9.23L13.76,6.86c.19,1,.38,2.1.59,3.14h5.73C19.42,8.6,18.64,7.06,17.82,5.47Zm.49-1.23a72.46,72.46,0,0,1,3.86,8.19,4,4,0,0,1-2,4.88l1.21,3.52c.29.82,1.32.93,2.39.81l.25.74L19.27,24,19,23.21c.9-.48,1.69-1.21,1.41-2.05L19.2,17.64A4,4,0,0,1,14.61,15a62.74,62.74,0,0,1-2-8.84ZM9.44,11h-6c-.27.62-.51,1.21-.7,1.76a3,3,0,0,0,1.86,3.8h0a3,3,0,0,0,3.8-1.87A35.33,35.33,0,0,0,9.44,11ZM3.92,10H9.65c.21-1,.4-2.11.59-3.14l-4-1.39C5.36,7.06,4.57,8.6,3.92,10Zm7.45-3.81a62.74,62.74,0,0,1-2,8.84A4,4,0,0,1,4.8,17.64L3.59,21.16C3.31,22,4.1,22.73,5,23.21L4.73,24,0,22.38l.25-.74c1.07.12,2.1,0,2.39-.81l1.22-3.52a4,4,0,0,1-2-4.88A72.46,72.46,0,0,1,5.69,4.24ZM18.5,14a.75.75,0,1,1-.75.75A.76.76,0,0,1,18.5,14ZM4,14.25a.75.75,0,1,0,.75-.75A.76.76,0,0,0,4,14.25ZM7.25,12a.75.75,0,1,1-.75.75A.76.76,0,0,1,7.25,12Zm10.5-.5a.75.75,0,1,1-.75.75A.76.76,0,0,1,17.75,11.5Zm-5.25-8V.5A.5.5,0,0,0,12,0a.5.5,0,0,0-.5.5v3A.5.5,0,0,0,12,4,.5.5,0,0,0,12.5,3.52ZM14.43,4,16.07,1.2A.49.49,0,0,0,15.9.51a.51.51,0,0,0-.69.18L13.57,3.48a.5.5,0,0,0,.18.68.45.45,0,0,0,.25.07A.5.5,0,0,0,14.43,4Zm-4.55.25A.5.5,0,0,1,9.45,4L7.81,1.2A.51.51,0,0,1,8,.51a.51.51,0,0,1,.69.18l1.64,2.79a.5.5,0,0,1-.18.68A.45.45,0,0,1,9.88,4.23Z"
  })) : _ref149$children,
      props = _objectWithoutProperties(_ref149, _excluded145);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Toast = function Toast(props) {
  var _useContext145 = useContext(PictoContext),
      optimise = _useContext145.optimise,
      refresh = _useContext145.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_5PKOb', /*#__PURE__*/React.createElement(SVGComponent$k, props));
};

var SVGComponent$j = function SVGComponent$j(_ref150) {
  var _ref150$as = _ref150.as,
      Component = _ref150$as === void 0 ? "svg" : _ref150$as,
      _ref150$children = _ref150.children,
      children = _ref150$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M9,3h6V1.25a.29.29,0,0,0-.07-.18A.29.29,0,0,0,14.75,1H9.25a.29.29,0,0,0-.18.07A.29.29,0,0,0,9,1.25ZM20,4H4V22a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1ZM10,7.5a.5.5,0,0,0-1,0v12a.5.5,0,0,0,1,0Zm5,0a.5.5,0,0,0-1,0v12a.5.5,0,0,0,1,0ZM23,3V4H21V22a2,2,0,0,1-2,2H5a2,2,0,0,1-2-2V4H1V3H8V1A1,1,0,0,1,9,0h6a1,1,0,0,1,1,1V3Z"
  })) : _ref150$children,
      props = _objectWithoutProperties(_ref150, _excluded146);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Trash = function Trash(props) {
  var _useContext146 = useContext(PictoContext),
      optimise = _useContext146.optimise,
      refresh = _useContext146.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_5Q9P7', /*#__PURE__*/React.createElement(SVGComponent$j, props));
};

var SVGComponent$i = function SVGComponent$i(_ref151) {
  var _ref151$as = _ref151.as,
      Component = _ref151$as === void 0 ? "svg" : _ref151$as,
      _ref151$children = _ref151.children,
      children = _ref151$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M10.51,19v5h3V19A4.17,4.17,0,0,0,15,18a5.37,5.37,0,0,0,1.73.29A5.31,5.31,0,0,0,22,13a5.38,5.38,0,0,0-1.36-3.5A4,4,0,0,0,21,7.73a3.83,3.83,0,0,0-3.32-3.82,6.18,6.18,0,0,0-11.46,0A3.83,3.83,0,0,0,3,7.69a4,4,0,0,0,.4,1.72,5.3,5.3,0,0,0,3.9,8.84A5.43,5.43,0,0,0,9,18,4.16,4.16,0,0,0,10.51,19Zm2,4.05v-4.8l.66-.24a3,3,0,0,0,1.16-.76l.45-.45.6.21a4.15,4.15,0,0,0,1.39.24,4.3,4.3,0,0,0,3.15-7.17l-.45-.5.3-.61a2.86,2.86,0,0,0-1.28-3.84h0a3.06,3.06,0,0,0-.89-.27L17,4.78l-.22-.53a5.18,5.18,0,0,0-9.62,0L7,4.78l-.57.08A2.86,2.86,0,0,0,4,8.06,2.79,2.79,0,0,0,4.25,9l.3.61-.45.5a4.3,4.3,0,0,0,3.15,7.17A4.1,4.1,0,0,0,8.64,17l.6-.21.45.45a3,3,0,0,0,1.16.76l.66.24V23Z",
    fillRule: "evenodd"
  })) : _ref151$children,
      props = _objectWithoutProperties(_ref151, _excluded147);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var Tree = function Tree(props) {
  var _useContext147 = useContext(PictoContext),
      optimise = _useContext147.optimise,
      refresh = _useContext147.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_bvOC', /*#__PURE__*/React.createElement(SVGComponent$i, props));
};

var SVGComponent$h = function SVGComponent$h(_ref152) {
  var _ref152$as = _ref152.as,
      Component = _ref152$as === void 0 ? "svg" : _ref152$as,
      _ref152$children = _ref152.children,
      children = _ref152$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M10.51,19V24h3V19A4.08,4.08,0,0,0,15,18a5.37,5.37,0,0,0,1.73.29,5.3,5.3,0,0,0,3.9-8.84,3.91,3.91,0,0,0,.4-1.72,3.84,3.84,0,0,0-3.32-3.82,6.18,6.18,0,0,0-11.46,0A3.84,3.84,0,0,0,3,7.69a3.91,3.91,0,0,0,.4,1.72,5.3,5.3,0,0,0,3.9,8.84A5.37,5.37,0,0,0,9,18,4.08,4.08,0,0,0,10.51,19Z"
  })) : _ref152$children,
      props = _objectWithoutProperties(_ref152, _excluded148);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var TreePlain = function TreePlain(props) {
  var _useContext148 = useContext(PictoContext),
      optimise = _useContext148.optimise,
      refresh = _useContext148.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_2o1C6h', /*#__PURE__*/React.createElement(SVGComponent$h, props));
};

var SVGComponent$g = function SVGComponent$g(_ref153) {
  var _ref153$as = _ref153.as,
      Component = _ref153$as === void 0 ? "svg" : _ref153$as,
      _ref153$children = _ref153.children,
      children = _ref153$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M7.0941,16h10v1H7.0941v-1Zm0-3.5h10v-1H7.0941v1Zm0-4.5h10v-1H7.0941v1Zm16.9059,4c0,6.63-5.37,12-12,12S0,18.63,0,12,5.37,0,12,0s12,5.37,12,12Zm-1,0c0-6.08-4.92-11-11-11S1,5.92,1,12s4.92,11,11,11,11-4.92,11-11Z"
  })) : _ref153$children,
      props = _objectWithoutProperties(_ref153, _excluded149);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var TribarCircle = function TribarCircle(props) {
  var _useContext149 = useContext(PictoContext),
      optimise = _useContext149.optimise,
      refresh = _useContext149.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_QPSmx', /*#__PURE__*/React.createElement(SVGComponent$g, props));
};

var SVGComponent$f = function SVGComponent$f(_ref154) {
  var _ref154$as = _ref154.as,
      Component = _ref154$as === void 0 ? "svg" : _ref154$as,
      _ref154$children = _ref154.children,
      children = _ref154$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M14,0H2A2,2,0,0,0,0,2V14a2,2,0,0,0,2,2H14a2,2,0,0,0,2-2V2A2,2,0,0,0,14,0ZM8,10.36l2.16-.61.92,2.87ZM9.91,9,8,10.35H8L4.91,12.62,6.09,9,3,6.67H6.82L8,3,9.18,6.68H13Z"
  })) : _ref154$children,
      props = _objectWithoutProperties(_ref154, _excluded150);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "16",
    viewBox: "0 0 16 16",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Trustpilot = function Trustpilot(props) {
  var _useContext150 = useContext(PictoContext),
      optimise = _useContext150.optimise,
      refresh = _useContext150.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_176VV8', /*#__PURE__*/React.createElement(SVGComponent$f, props));
};

var SVGComponent$e = function SVGComponent$e(_ref155) {
  var _ref155$as = _ref155.as,
      Component = _ref155$as === void 0 ? "svg" : _ref155$as,
      _ref155$children = _ref155.children,
      children = _ref155$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M10,7a2.5,2.5,0,0,1-4.9,0H.88V6H5.05A2.5,2.5,0,0,1,10,6H24.88V7ZM9,6.5A1.5,1.5,0,1,1,7.5,5,1.5,1.5,0,0,1,9,6.5ZM7.5,16a2.5,2.5,0,0,0-2.45,2H.88v1H5.05A2.5,2.5,0,0,0,10,19H24.88V18H10A2.5,2.5,0,0,0,7.5,16Zm0,4A1.5,1.5,0,1,0,6,18.5,1.5,1.5,0,0,0,7.5,20Zm8.55-7H.88V12H16.05A2.5,2.5,0,0,1,21,12h3.93v1H21a2.5,2.5,0,0,1-4.9,0ZM20,12.5A1.5,1.5,0,1,1,18.5,11,1.5,1.5,0,0,1,20,12.5Z",
    fillRule: "evenodd"
  })) : _ref155$children,
      props = _objectWithoutProperties(_ref155, _excluded151);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "currentColor"
  }, props), children);
};

var Tune = function Tune(props) {
  var _useContext151 = useContext(PictoContext),
      optimise = _useContext151.optimise,
      refresh = _useContext151.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_bwFs', /*#__PURE__*/React.createElement(SVGComponent$e, props));
};

var SVGComponent$d = function SVGComponent$d(_ref156) {
  var _ref156$as = _ref156.as,
      Component = _ref156$as === void 0 ? "svg" : _ref156$as,
      _ref156$children = _ref156.children,
      children = _ref156$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M32,16.78a8,8,0,0,1-2.24.59,3.86,3.86,0,0,0,1.72-2.09A8.12,8.12,0,0,1,29,16.2,3.93,3.93,0,0,0,26.15,15a3.82,3.82,0,0,0-3.79,4.65,11.22,11.22,0,0,1-8-4,3.73,3.73,0,0,0,1.21,5.06,4.05,4.05,0,0,1-1.77-.47A3.83,3.83,0,0,0,16.89,24a4.15,4.15,0,0,1-1.76.06,3.89,3.89,0,0,0,3.64,2.63A8,8,0,0,1,13,28.3,11.32,11.32,0,0,0,19,30,10.84,10.84,0,0,0,30.05,18.74,7.89,7.89,0,0,0,32,16.78Z"
  })) : _ref156$children,
      props = _objectWithoutProperties(_ref156, _excluded152);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "46",
    viewBox: "0 0 46 46",
    width: "46",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Twitter = function Twitter(props) {
  var _useContext152 = useContext(PictoContext),
      optimise = _useContext152.optimise,
      refresh = _useContext152.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_S2LJj', /*#__PURE__*/React.createElement(SVGComponent$d, props));
};

var SVGComponent$c = function SVGComponent$c(_ref157) {
  var _ref157$as = _ref157.as,
      Component = _ref157$as === void 0 ? "svg" : _ref157$as,
      _ref157$children = _ref157.children,
      children = _ref157$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M21,5.78a7.89,7.89,0,0,1-1.95,2A10.84,10.84,0,0,1,8,19a11.32,11.32,0,0,1-6-1.7,8,8,0,0,0,5.77-1.57A3.89,3.89,0,0,1,4.13,13.1,4.15,4.15,0,0,0,5.89,13,3.83,3.83,0,0,1,2.76,9.28a4.05,4.05,0,0,0,1.77.47A3.73,3.73,0,0,1,3.32,4.69a11.22,11.22,0,0,0,8,4A3.82,3.82,0,0,1,15.15,4,3.93,3.93,0,0,1,18,5.2a8.12,8.12,0,0,0,2.48-.92,3.86,3.86,0,0,1-1.72,2.09A8,8,0,0,0,21,5.78Z"
  })) : _ref157$children,
      props = _objectWithoutProperties(_ref157, _excluded153);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var TwitterSmall = function TwitterSmall(props) {
  var _useContext153 = useContext(PictoContext),
      optimise = _useContext153.optimise,
      refresh = _useContext153.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_ZP0WuV', /*#__PURE__*/React.createElement(SVGComponent$c, props));
};

var SVGComponent$b = function SVGComponent$b(_ref158) {
  var _ref158$as = _ref158.as,
      Component = _ref158$as === void 0 ? "svg" : _ref158$as,
      _ref158$children = _ref158.children,
      children = _ref158$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,23A11,11,0,1,1,23,12,11,11,0,0,1,12,23Zm-1.75-9.16a2.25,2.25,0,0,0-.21,1h4.37v.88H9.05V15a3.08,3.08,0,0,1,.33-1.57,4.58,4.58,0,0,1,2.06-1.55c1.66-.86,2.14-1.32,2.14-2.13a1.54,1.54,0,0,0-1.7-1.39,1.92,1.92,0,0,0-2,2L9,10.29a2.79,2.79,0,0,1,2.91-2.77,2.41,2.41,0,0,1,2.63,2.23c0,1.16-.6,1.82-2.36,2.71C10.75,13.17,10.44,13.46,10.25,13.84Z"
  })) : _ref158$children,
      props = _objectWithoutProperties(_ref158, _excluded154);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var TwoCircle = function TwoCircle(props) {
  var _useContext154 = useContext(PictoContext),
      optimise = _useContext154.optimise,
      refresh = _useContext154.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_1JWA84', /*#__PURE__*/React.createElement(SVGComponent$b, props));
};

var SVGComponent$a = function SVGComponent$a(_ref159) {
  var _ref159$as = _ref159.as,
      Component = _ref159$as === void 0 ? "svg" : _ref159$as,
      _ref159$children = _ref159.children,
      children = _ref159$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1683 0C15.5123 0 14.1683 1.344 14.1683 2.999C14.1683 4.654 15.5123 5.998 17.1683 5.998C18.8233 5.998 20.1683 4.654 20.1683 2.999C20.1683 1.344 18.8233 0 17.1683 0ZM17.1683 1C18.2713 1 19.1683 1.896 19.1683 2.999C19.1683 4.102 18.2713 4.999 17.1683 4.999C16.0653 4.999 15.1683 4.102 15.1683 2.999C15.1683 1.896 16.0653 1 17.1683 1ZM7.49931 0C5.84331 0 4.49931 1.344 4.49931 2.999C4.49931 4.654 5.84331 5.998 7.49931 5.998C9.15431 5.998 10.4993 4.654 10.4993 2.999C10.4993 1.344 9.15431 0 7.49931 0ZM7.49931 1C8.60231 1 9.49931 1.896 9.49931 2.999C9.49931 4.102 8.60231 4.999 7.49931 4.999C6.39631 4.999 5.49931 4.102 5.49931 2.999C5.49931 1.896 6.39631 1 7.49931 1ZM17.1473 15.828C17.8413 15.828 18.3783 16.352 18.4243 17.073C18.4743 17.814 18.5963 19.274 18.7043 20.562L18.8603 22.458C18.8803 22.709 19.0243 23 19.3683 23C19.7723 23 19.8233 22.575 19.8283 22.444L20.3003 10.997C20.3223 10.485 21.0013 10.342 21.2373 10.775L22.8823 13.752C23.0003 13.967 23.3333 13.877 23.3333 13.635L21.7333 7.96C21.6403 7.625 21.3313 7.393 20.9843 7.393H3.68131C3.33531 7.393 3.02631 7.625 2.93231 7.959L1.34231 13.569C1.32031 13.971 1.70631 13.895 1.78431 13.752L3.42931 10.775C3.67331 10.336 4.34531 10.492 4.36631 10.997L4.83731 22.445C4.84831 22.701 4.98331 23 5.32731 23C5.65631 23 5.82431 22.729 5.84531 22.459L6.00531 20.519C6.11231 19.242 6.23231 17.807 6.28231 17.071C6.32931 16.352 6.86631 15.828 7.55931 15.828C8.14331 15.828 8.77731 16.293 8.82931 17.072C8.87831 17.806 8.99831 19.241 9.10531 20.518L9.26531 22.458C9.28431 22.709 9.42631 23 9.76431 23C10.1463 23 10.2033 22.611 10.2103 22.444C10.3323 19.488 10.8393 10.154 10.8453 10.06C10.8593 9.794 11.0783 9.587 11.3443 9.587H13.3073C13.5733 9.587 13.7923 9.795 13.8063 10.061C13.8123 10.155 14.3003 19.488 14.4233 22.445C14.4353 22.721 14.5973 23 14.9323 23C15.2763 23 15.4223 22.709 15.4403 22.459L15.6053 20.477C15.7103 19.211 15.8283 17.798 15.8773 17.071C15.9293 16.293 16.5643 15.828 17.1473 15.828ZM19.3693 24C18.5623 24 17.9293 23.384 17.8633 22.535C17.8283 22.08 17.7713 21.392 17.7083 20.646C17.6003 19.352 17.4773 17.885 17.4263 17.139C17.4113 16.908 17.2723 16.828 17.1473 16.828C17.0683 16.828 16.8913 16.906 16.8753 17.138C16.8263 17.869 16.7073 19.288 16.6013 20.56C16.5353 21.339 16.4753 22.062 16.4383 22.536C16.3733 23.384 15.7403 24 14.9343 24C14.1083 24 13.4603 23.35 13.4233 22.487C13.3173 19.92 12.9343 12.533 12.8323 10.587H11.8173C11.7123 12.531 11.3153 19.92 11.2093 22.486C11.1713 23.378 10.5783 24 9.76531 24C8.96231 24 8.33331 23.384 8.26831 22.535L8.10831 20.601C8.00131 19.318 7.88031 17.877 7.83131 17.139C7.81531 16.906 7.63731 16.828 7.55931 16.828C7.43431 16.828 7.29431 16.909 7.28031 17.137C7.23031 17.877 7.10931 19.319 7.00231 20.602L6.84231 22.536C6.77731 23.384 6.14031 24 5.32931 24C4.50231 24 3.87631 23.363 3.83831 22.487L3.44031 12.822L2.66031 14.235C2.33731 14.819 1.57231 15.016 1.08731 14.773C0.627313 14.578 0.333313 14.136 0.333313 13.635C0.333313 13.52 0.349313 13.406 0.380313 13.296L1.97031 7.687C2.18531 6.925 2.88931 6.393 3.68131 6.393H20.9843C21.7773 6.393 22.4813 6.926 22.6963 7.687L24.2863 13.297C24.3173 13.406 24.3333 13.52 24.3333 13.635C24.3333 14.138 24.0363 14.582 23.5743 14.775L23.5373 14.792C22.9713 15.01 22.2993 14.764 22.0073 14.234L21.2263 12.822L20.8283 22.486C20.7903 23.378 20.1903 24 19.3693 24Z"
  })) : _ref159$children,
      props = _objectWithoutProperties(_ref159, _excluded155);

  return /*#__PURE__*/React.createElement(Component, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var TwoPeople = function TwoPeople(props) {
  var _useContext155 = useContext(PictoContext),
      optimise = _useContext155.optimise,
      refresh = _useContext155.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_2byEUs', /*#__PURE__*/React.createElement(SVGComponent$a, props));
};

var SVGComponent$9 = function SVGComponent$9(_ref160) {
  var _ref160$as = _ref160.as,
      Component = _ref160$as === void 0 ? "svg" : _ref160$as,
      _ref160$children = _ref160.children,
      children = _ref160$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M21,18.5a10,10,0,0,1-2,.9v-5a14.67,14.67,0,0,0-7,2,17.62,17.62,0,0,0-7-2v5a10,10,0,0,1-2-.9V16.6c0-2,.1-2.5,1.9-2.9,2.3-.5,4.6-.8,5.2-2.3A2.51,2.51,0,0,0,9.6,9C8,6.7,7.6,4.6,8.4,3A4,4,0,0,1,12,1a4.08,4.08,0,0,1,3.6,2c.8,1.6.4,3.7-1.2,6a2.51,2.51,0,0,0-.5,2.4c.6,1.5,2.9,1.8,5.2,2.3,1.8.4,1.9.9,1.9,3ZM18,21a28.54,28.54,0,0,0-5.5,1.6V17.2A14.82,14.82,0,0,1,18,15.5Zm-6.5,1.6A28.54,28.54,0,0,0,6,21V15.5a14.82,14.82,0,0,1,5.5,1.7Zm7.9-9.9c-2.9-.6-5.7-1-4.1-3.1C19.1,4,15.9,0,12,0S4.9,4,8.8,9.5c1.6,2.2-1.3,2.5-4.1,3.1-2.6.6-2.7,1.9-2.7,4v2.5a9.53,9.53,0,0,0,3,1.4v1.4A26.41,26.41,0,0,1,12,24a22.68,22.68,0,0,1,7-2.1V20.5a13.4,13.4,0,0,0,3-1.4V16.6C22,14.5,21.9,13.2,19.4,12.7Z"
  })) : _ref160$children,
      props = _objectWithoutProperties(_ref160, _excluded156);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var UserBook = function UserBook(props) {
  var _useContext156 = useContext(PictoContext),
      optimise = _useContext156.optimise,
      refresh = _useContext156.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_ZeBy0j', /*#__PURE__*/React.createElement(SVGComponent$9, props));
};

var SVGComponent$8 = function SVGComponent$8(_ref161) {
  var _ref161$as = _ref161.as,
      Component = _ref161$as === void 0 ? "svg" : _ref161$as,
      _ref161$children = _ref161.children,
      children = _ref161$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Zm8.13,19.41a2.6,2.6,0,0,0-1.63-.85c-3.85-.91-4.09-1.5-4.35-2.06a2.18,2.18,0,0,1,.21-2c1.72-3.25,2.09-6,1-7.79A3.74,3.74,0,0,0,12,5,3.79,3.79,0,0,0,8.59,6.76c-1.06,1.79-.69,4.55,1.05,7.76a2.16,2.16,0,0,1,.22,2c-.26.59-.61,1.19-4.37,2.07a2.54,2.54,0,0,0-1.62.85,11,11,0,0,0,16.26,0Zm.65-.78a11,11,0,1,0-17.56,0,3.82,3.82,0,0,1,2-1.05c2-.46,3.38-.83,3.68-1.5A1.24,1.24,0,0,0,8.76,15c-1.92-3.54-2.28-6.65-1-8.75A4.79,4.79,0,0,1,12,4a4.77,4.77,0,0,1,4.24,2.22c1.25,2.08.9,5.19-1,8.77a1.27,1.27,0,0,0-.18,1.1c.31.66,1.64,1,3.67,1.49A3.82,3.82,0,0,1,20.78,18.63Z"
  })) : _ref161$children,
      props = _objectWithoutProperties(_ref161, _excluded157);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var UserCircle = function UserCircle(props) {
  var _useContext157 = useContext(PictoContext),
      optimise = _useContext157.optimise,
      refresh = _useContext157.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z1o37oq', /*#__PURE__*/React.createElement(SVGComponent$8, props));
};

var SVGComponent$7 = function SVGComponent$7(_ref162) {
  var _ref162$as = _ref162.as,
      Component = _ref162$as === void 0 ? "svg" : _ref162$as,
      _ref162$children = _ref162.children,
      children = _ref162$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M24,22H0V2H24ZM23,3H1V21H23ZM19,16v1H15V16Zm-6,1H2v-.91C2,15,2,14,3.71,13.55c.79-.18,1.75-.4,1.89-.71.05-.1,0-.3-.09-.4C4.4,10.4,4.2,8.6,4.94,7.36A2.88,2.88,0,0,1,7.5,6a2.9,2.9,0,0,1,2.55,1.34c.73,1.22.54,3-.55,5.09-.06.11-.15.3-.1.41.14.31,1.12.53,1.83.7C13,14,13,15,13,16.1ZM3,16h9c0-1-.06-1.27-.94-1.47-1.17-.27-2.22-.52-2.57-1.27A1.44,1.44,0,0,1,8.61,12c.92-1.74,1.13-3.2.58-4.12A1.87,1.87,0,0,0,7.5,7a1.88,1.88,0,0,0-1.7.87c-.54.91-.33,2.4.58,4.09a1.4,1.4,0,0,1,.13,1.3c-.34.75-1.38,1-2.49,1.25C3.06,14.73,3,15,3,16Zm18-3v1H15V13Zm0-3v1H15V10Zm0-3V8H15V7Z",
    fillRule: "evenodd"
  })) : _ref162$children,
      props = _objectWithoutProperties(_ref162, _excluded158);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var UserId = function UserId(props) {
  var _useContext158 = useContext(PictoContext),
      optimise = _useContext158.optimise,
      refresh = _useContext158.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z24xqaH', /*#__PURE__*/React.createElement(SVGComponent$7, props));
};

var SVGComponent$6 = function SVGComponent$6(_ref163) {
  var _ref163$as = _ref163.as,
      Component = _ref163$as === void 0 ? "svg" : _ref163$as,
      _ref163$children = _ref163.children,
      children = _ref163$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,17.92l-1,2-2.21.3,1.61,1.56L10,24l2-1.06L14,24l-.39-2.2,1.61-1.56L13,19.94Zm-7.81,0-1,2L1,20.24,2.62,21.8,2.22,24l2-1.06,2,1.06-.4-2.2,1.62-1.56-2.22-.3Zm15.62,0-1,2-2.22.3,1.62,1.56-.4,2.2,2-1.06,2,1.06-.39-2.2L23,20.24l-2.22-.3ZM11.5,21.44,11,21l.7-.09.31-.64.31.64L13,21l-.51.49.13.7L12,21.81l-.62.33Zm-7.81,0L3.18,21l.7-.09.31-.64.31.64.71.09-.51.49.12.7-.63-.33-.62.33Zm15.62,0L18.8,21l.7-.09.31-.64.31.64.7.09-.51.49.12.7-.62-.33-.63.33ZM21,17H3V15.84c0-2.45.37-3.28,2.94-3.86s3.74-1,3.12-2.12C7.35,6.7,7,3.92,8.15,2A4.32,4.32,0,0,1,12,0a4.32,4.32,0,0,1,3.83,2c1.12,1.86.81,4.65-.89,7.85-.63,1.2.62,1.56,3.16,2.14S21,13.39,21,15.86ZM4,16H20c0-2,.07-2.54-2.12-3-1.79-.4-3.47-.78-4-1.89a1.83,1.83,0,0,1,.15-1.68c1.53-2.88,1.86-5.32.92-6.87A3.3,3.3,0,0,0,12,1,3.32,3.32,0,0,0,9,2.54c-.94,1.57-.61,4,.94,6.84a1.85,1.85,0,0,1,.16,1.69c-.5,1.11-2.26,1.5-3.95,1.89C4,13.45,4,13.9,4,16Z"
  })) : _ref163$children,
      props = _objectWithoutProperties(_ref163, _excluded159);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var UserStars = function UserStars(props) {
  var _useContext159 = useContext(PictoContext),
      optimise = _useContext159.optimise,
      refresh = _useContext159.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z2jJmzf', /*#__PURE__*/React.createElement(SVGComponent$6, props));
};

var SVGComponent$5 = function SVGComponent$5(_ref164) {
  var _ref164$as = _ref164.as,
      Component = _ref164$as === void 0 ? "svg" : _ref164$as,
      _ref164$children = _ref164.children,
      children = _ref164$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M15.1,7h4v5h5v6h-5v5H.1V2h15Zm-5,11h-9v4h9Zm8,0h-7v4h7Zm-11-5h-6v4h6Zm9,0h-8v4h8Zm7,0h-6v4h6Zm-12-5v4h7V8Zm-1,0h-9v4h9Zm-3-5h-6V7h6Zm7,0h-6V7h6Z"
  })) : _ref164$children,
      props = _objectWithoutProperties(_ref164, _excluded160);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Wall = function Wall(props) {
  var _useContext160 = useContext(PictoContext),
      optimise = _useContext160.optimise,
      refresh = _useContext160.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_bPvB', /*#__PURE__*/React.createElement(SVGComponent$5, props));
};

var SVGComponent$4 = function SVGComponent$4(_ref165) {
  var _ref165$as = _ref165.as,
      Component = _ref165$as === void 0 ? "svg" : _ref165$as,
      _ref165$children = _ref165.children,
      children = _ref165$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M16.06,19.53,9.65,14.16l1.08,2a2,2,0,0,1,.23.79l.38,5.79A1.22,1.22,0,0,1,10.09,24a1.25,1.25,0,0,1-1.23-1l-1.16-5c-.38-.43-1.47-1.59-2.13-2.29C4.85,17.48,3,21.82,2.45,23.23A1.22,1.22,0,0,1,1.28,24,1.27,1.27,0,0,1,0,22.73c0-.09,0-.11.76-3.86.52-2.56,1.17-5.76,1.47-7.39a2.53,2.53,0,0,1,.59-1.19l.94-1.06L.39,6.41A.5.5,0,0,1,1,5.64l1,.8c.33-.63.86-1.65,1.16-2.28a1.28,1.28,0,0,1,1.05-.7l5.25,0A2,2,0,0,1,11,4c.29.29,2.05,2.17,2.41,2.54A1.76,1.76,0,0,1,14,7.83v8.64l2.77,2.32,2.72-3a1.12,1.12,0,0,1,.85-.38,1.15,1.15,0,0,1,1.09.78C22.33,19,24,24,24,24H12l4.06-4.47ZM4.53,9.87,3.57,11a1.48,1.48,0,0,0-.35.72c-.31,1.63-1,4.84-1.48,7.39C1.37,20.89,1,22.62,1,22.78s.43.32.53.08c.73-1.79,3.41-8.18,3.41-8.18a.49.49,0,0,1,.83-.15L8.4,17.31a1.29,1.29,0,0,1,.28.53l1.16,5c.06.29.52.26.5,0L10,17a1,1,0,0,0-.11-.38L7.91,13.07a.51.51,0,0,1,0-.4L4.53,9.87ZM22.61,23c-.56-1.68-1.79-5.4-2.16-6.49a.15.15,0,0,0-.25-.05c-1,1.09-4.26,4.69-5.94,6.54ZM13,15.64V7.83a.79.79,0,0,0-.23-.55c-.71-.72-1.81-1.93-2.42-2.55-.18-.18-.37-.23-.9-.23l-5.2,0A.28.28,0,0,0,4,4.6c-.34.69-.94,1.85-1.25,2.45l.07,0L4.55,5.21A.53.53,0,0,1,5,5.05l2.61.17a.5.5,0,0,1,.34.83L5.19,9.12,8.5,11.89l2.43-2.82a.5.5,0,0,1,.87.23L13,15.63Zm-3.7-3.11.93.79,1.53,1.28L11,10.52ZM3.59,7.78l.83.7L6.49,6.15,5.14,6.06,3.59,7.78ZM14.43,5.69a2.85,2.85,0,1,1,2.85-2.85A2.85,2.85,0,0,1,14.43,5.69Zm0-4.69a1.85,1.85,0,1,0,1.85,1.84A1.84,1.84,0,0,0,14.43,1Z",
    fillRule: "evenodd"
  })) : _ref165$children,
      props = _objectWithoutProperties(_ref165, _excluded161);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var WorkingMan = function WorkingMan(props) {
  var _useContext161 = useContext(PictoContext),
      optimise = _useContext161.optimise,
      refresh = _useContext161.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_22g4RU', /*#__PURE__*/React.createElement(SVGComponent$4, props));
};

var SVGComponent$3 = function SVGComponent$3(_ref166) {
  var _ref166$as = _ref166.as,
      Component = _ref166$as === void 0 ? "svg" : _ref166$as,
      _ref166$children = _ref166.children,
      children = _ref166$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M8.62,7.96h1.21l5.56,8.09h-1.21l-5.56-8.09ZM20,12c0,4.42-3.58,8-8,8s-8-3.58-8-8S7.58,4,12,4s8,3.58,8,8ZM12.5,10.78l-2.36-3.43h-2.68l3.55,5.15-3.56,4.14h.77l3.13-3.64,2.51,3.64h2.68l-3.7-5.37,3.37-3.93h-.77l-.66.76-2.29,2.66Z"
  })) : _ref166$children,
      props = _objectWithoutProperties(_ref166, _excluded162);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var XSmall = function XSmall(props) {
  var _useContext162 = useContext(PictoContext),
      optimise = _useContext162.optimise,
      refresh = _useContext162.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_Z20sfwA', /*#__PURE__*/React.createElement(SVGComponent$3, props));
};

var SVGComponent$2 = function SVGComponent$2(_ref167) {
  var _ref167$as = _ref167.as,
      Component = _ref167$as === void 0 ? "svg" : _ref167$as,
      _ref167$children = _ref167.children,
      children = _ref167$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M31.63,18.88A2.19,2.19,0,0,0,30,17.37,54.83,54.83,0,0,0,23,17a57.93,57.93,0,0,0-7,.35,2.25,2.25,0,0,0-1.59,1.53A21.58,21.58,0,0,0,14,23a21.47,21.47,0,0,0,.37,4.12A2.19,2.19,0,0,0,16,28.63,54.91,54.91,0,0,0,23,29a57.93,57.93,0,0,0,7-.35,2.23,2.23,0,0,0,1.59-1.51A21.67,21.67,0,0,0,32,23,20.83,20.83,0,0,0,31.63,18.88ZM21.21,25.57V20.43L25.89,23Z"
  })) : _ref167$children,
      props = _objectWithoutProperties(_ref167, _excluded163);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "46",
    viewBox: "0 0 46 46",
    width: "46",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var Youtube = function Youtube(props) {
  var _useContext163 = useContext(PictoContext),
      optimise = _useContext163.optimise,
      refresh = _useContext163.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_MAADg', /*#__PURE__*/React.createElement(SVGComponent$2, props));
};

var SVGComponent$1 = function SVGComponent$1(_ref168) {
  var _ref168$as = _ref168.as,
      Component = _ref168$as === void 0 ? "svg" : _ref168$as,
      _ref168$children = _ref168.children,
      children = _ref168$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M20.63,7.88c-.21-.73-.82-1.31-1.59-1.51-1.41-.37-7.04-.37-7.04-.37,0,0-5.63,0-7.04.35-.76.2-1.38.79-1.59,1.52-.37,1.34-.37,4.12-.37,4.12,0,0,0,2.8.37,4.12.21.73.82,1.31,1.59,1.51,1.42.37,7.04.37,7.04.37,0,0,5.63,0,7.04-.35.77-.2,1.38-.78,1.59-1.51.37-1.34.37-4.12.37-4.12,0,0,.01-2.8-.37-4.14ZM10.21,14.57v-5.14l4.69,2.57-4.69,2.57Z"
  })) : _ref168$children,
      props = _objectWithoutProperties(_ref168, _excluded164);

  return /*#__PURE__*/React.createElement(Component, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), children);
};

var YoutubeSmall = function YoutubeSmall(props) {
  var _useContext164 = useContext(PictoContext),
      optimise = _useContext164.optimise,
      refresh = _useContext164.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_2rPnaf', /*#__PURE__*/React.createElement(SVGComponent$1, props));
};

var SVGComponent = function SVGComponent(_ref169) {
  var _ref169$as = _ref169.as,
      Component = _ref169$as === void 0 ? "svg" : _ref169$as,
      _ref169$children = _ref169.children,
      children = _ref169$children === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M8.33.5a6.75,6.75,0,0,0-5.7,3.15A14.79,14.79,0,0,0,.5,12a14.79,14.79,0,0,0,2.13,8.35,6.75,6.75,0,0,0,5.7,3.15,6.52,6.52,0,0,0,4.46-1.71L12.12,21A5.47,5.47,0,0,1,8.33,22.5a5.75,5.75,0,0,1-4.87-2.71A13.85,13.85,0,0,1,1.5,12a13.85,13.85,0,0,1,2-7.79,5.74,5.74,0,0,1,9.75,0,13.85,13.85,0,0,1,2,7.79,20.06,20.06,0,0,1-.12,2.24l1,.11A22.05,22.05,0,0,0,16.17,12,14.87,14.87,0,0,0,14,3.65,6.75,6.75,0,0,0,8.33.5ZM15.4,15.75a1.65,1.65,0,1,0,1.65,1.65A1.65,1.65,0,0,0,15.4,15.75Zm-.8,1.65a.8.8,0,1,1,.8.8A.8.8,0,0,1,14.6,17.4ZM21,16.57,20.37,16,14,22.43l.65.56ZM19.6,20a1.65,1.65,0,1,0,1.65,1.65A1.65,1.65,0,0,0,19.6,20Zm-.8,1.65a.8.8,0,1,1,.8.8A.8.8,0,0,1,18.8,21.6Z"
  })) : _ref169$children,
      props = _objectWithoutProperties(_ref169, _excluded165);

  return /*#__PURE__*/React.createElement(Component, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), children);
};

var ZeroPercent = function ZeroPercent(props) {
  var _useContext165 = useContext(PictoContext),
      optimise = _useContext165.optimise,
      refresh = _useContext165.refresh;

  useEffect(function () {
    refresh();
  }, []);
  return optimise('p_6lhot', /*#__PURE__*/React.createElement(SVGComponent, props));
};

var manifest = ["Archive", "ArrowDirectionDown", "ArrowDirectionEgal", "ArrowDirectionUp", "ArrowDouble", "ArrowDown", "ArrowDownRightCircle", "ArrowLeft", "ArrowLeftBold", "ArrowRight", "ArrowRightBold", "ArrowUp", "ArrowUpRightCircle", "Bank", "BankNote", "Bars", "Bell", "Bookmark", "BreakBold", "Briefcase", "BubbleDouble", "Building", "Bulb", "BulletBold", "BulletBook", "Burden", "BurgerBold", "Calculator", "Calendar", "CalendarBold", "Camera", "ChalkboardTeacher", "ChartBar", "Check", "CheckBold", "CheckBoldMini", "CheckHandwrite", "ChevronDown", "ChevronDownBold", "ChevronLeftBold", "ChevronRightBold", "ChevronUp", "ChevronUpBold", "Clock", "ClockBold", "CloseBold", "Cloud", "CloudUpload", "CoinBold", "Coins", "Crane", "Crown", "DoubleArrow", "Download", "Duplicate", "Envelope", "EqualBold", "EqualCircle", "Euro", "EuroBold", "ExclamationMarkCircle", "ExclamationMarkCircleBold", "ExclamationMarkCircleLine", "ExclamationMarkTriangle", "ExclamationMarkTriangleBold", "ExclamationMarkTriangleLine", "ExternalLink", "Eye", "Facebook", "FacebookSmall", "File", "FileCheck", "Files", "Filter", "FirstCircle", "Flag", "Folder", "FolderOpen", "FourCircle", "Globe", "GraduationCap", "HandCoin", "Heart", "HeartPlain", "HorseChase", "House", "HouseMagnifier", "InfoCircle", "InfoCircleBold", "InfoCircleLine", "Instagram", "InstagramSmall", "Key", "LightningBolt", "Link", "LinkedinSmall", "Lock", "MagicWand", "MagnifyingBold", "MagnifyingGlassLeft", "Marker", "Microphone", "MinusBold", "MinusCircle", "MinusTenBold", "Paperclip", "Pen", "Percent", "Phone", "Plan", "Plane", "Play", "PlayBold", "PlayerBeginBold", "PlayerEndBold", "PlusBold", "PlusCircle", "PlusTenBold", "Print", "QuestionCircleLine", "QuestionMarkCircle", "QuestionMarkCircleBold", "QuoteClose", "QuoteOpenPlain", "Share", "ShieldCheck", "Smartphone", "SmileyFrown", "SmileyHappy", "SmileyNeutral", "SpeechBubble", "SquareMeter", "SquareMetersBold", "Star", "StarFilled", "StarHalf", "Tada", "ThreeCircle", "TikTokSmall", "Times", "TimesBold", "TimesCircle", "TimesCircleBold", "TimesCircleLine", "Toast", "Trash", "Tree", "TreePlain", "TribarCircle", "Trustpilot", "Tune", "Twitter", "TwitterSmall", "TwoCircle", "TwoPeople", "UserBook", "UserCircle", "UserId", "UserStars", "Wall", "WorkingMan", "XSmall", "Youtube", "YoutubeSmall", "ZeroPercent"];
export { Archive, ArrowDirectionDown, ArrowDirectionEgal, ArrowDirectionUp, ArrowDouble, ArrowDown, ArrowDownRightCircle, ArrowLeft, ArrowLeftBold, ArrowRight, ArrowRightBold, ArrowUp, ArrowUpRightCircle, Bank, BankNote, Bars, Bell, Bookmark, BreakBold, Briefcase, BubbleDouble, Building, Bulb, BulletBold, BulletBook, Burden, BurgerBold, Calculator, Calendar, CalendarBold, Camera, ChalkboardTeacher, ChartBar, Check, CheckBold, CheckBoldMini, CheckHandwrite, ChevronDown, ChevronDownBold, ChevronLeftBold, ChevronRightBold, ChevronUp, ChevronUpBold, Clock, ClockBold, CloseBold, Cloud, CloudUpload, CoinBold, Coins, Crane, Crown, DoubleArrow, Download, Duplicate, Envelope, EqualBold, EqualCircle, Euro, EuroBold, ExclamationMarkCircle, ExclamationMarkCircleBold, ExclamationMarkCircleLine, ExclamationMarkTriangle, ExclamationMarkTriangleBold, ExclamationMarkTriangleLine, ExternalLink, Eye, Facebook, FacebookSmall, File, FileCheck, Files, Filter, FirstCircle, Flag, Folder, FolderOpen, FourCircle, Globe, GraduationCap, HandCoin, Heart, HeartPlain, HorseChase, House, HouseMagnifier, InfoCircle, InfoCircleBold, InfoCircleLine, Instagram, InstagramSmall, Key, LightningBolt, Link, LinkedinSmall, Lock, MagicWand, MagnifyingBold, MagnifyingGlassLeft, Marker, Microphone, MinusBold, MinusCircle, MinusTenBold, Paperclip, Pen, Percent, Phone, PictoProvider, Plan, Plane, Play, PlayBold, PlayerBeginBold, PlayerEndBold, PlusBold, PlusCircle, PlusTenBold, Print, QuestionCircleLine, QuestionMarkCircle, QuestionMarkCircleBold, QuoteClose, QuoteOpenPlain, Share, ShieldCheck, Smartphone, SmileyFrown, SmileyHappy, SmileyNeutral, SpeechBubble, SquareMeter, SquareMetersBold, Star, StarFilled, StarHalf, Tada, ThreeCircle, TikTokSmall, Times, TimesBold, TimesCircle, TimesCircleBold, TimesCircleLine, Toast, Trash, Tree, TreePlain, TribarCircle, Trustpilot, Tune, Twitter, TwitterSmall, TwoCircle, TwoPeople, UserBook, UserCircle, UserId, UserStars, Wall, WorkingMan, XSmall, Youtube, YoutubeSmall, ZeroPercent, manifest };